function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7",
  x1: 42.59,
  y1: 198.48,
  x2: 340.28,
  y2: 198.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f548b9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8f4bff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-2",
  x1: 47.34,
  y1: 132.87,
  x2: 197.75,
  y2: 132.87,
  gradientTransform: "matrix(0.15, 0.99, -0.99, 0.15, 287.75, -39.93)",
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-3",
  x1: 43.54,
  y1: 141.85,
  x2: 193.94,
  y2: 141.85,
  gradientTransform: "translate(313.73 -51.71) rotate(72.92)",
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-4",
  x1: 170.48,
  y1: 124.84,
  x2: 320.89,
  y2: 124.84,
  gradientTransform: "translate(160.23 -137.16) rotate(45)",
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-5",
  x1: 52.3,
  y1: 159.2,
  x2: 202.7,
  y2: 159.2,
  gradientTransform: "matrix(-0.98, 0.2, -0.2, -0.98, 420.2, 290.4)",
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-6",
  x1: 187.85,
  y1: 198.4,
  x2: 338.29,
  y2: 198.4,
  gradientTransform: "translate(217.34 -127.91) rotate(45)",
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-7",
  x1: 70.88,
  y1: 161.04,
  x2: 221.29,
  y2: 161.04,
  gradientTransform: "translate(226.51 448.92) rotate(-133.33)",
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-8",
  x1: 134.68,
  y1: 252.12,
  x2: 285.11,
  y2: 252.12,
  gradientTransform: "translate(239.75 -74.57) rotate(45)",
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-9",
  x1: 83.06,
  y1: 147.05,
  x2: 233.47,
  y2: 147.05,
  gradientTransform: "translate(-45.14 251.21) rotate(-42.33)",
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-10",
  x1: 60.95,
  y1: 235.47,
  x2: 211.36,
  y2: 235.47,
  gradientTransform: "translate(206.39 -27.31) rotate(45)",
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-11",
  x1: 76.44,
  y1: 128.68,
  x2: 226.84,
  y2: 128.68,
  gradientTransform: "matrix(0.95, -0.3, 0.3, 0.95, -68.61, 125.29)",
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-12",
  x1: 36,
  y1: 164.12,
  x2: 186.42,
  y2: 164.12,
  gradientTransform: "translate(148.62 -30.57) rotate(45)",
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-13",
  x1: 56.61,
  y1: 124.85,
  x2: 207.02,
  y2: 124.85,
  gradientTransform: "translate(126.89 -56.64) rotate(45)",
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3",
  cx: -149.33,
  cy: 275.47,
  r: 30.41,
  gradientTransform: "matrix(0.31, 0, 0, -0.31, 100.25, 116.67)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2ba6b",
  stopOpacity: 0.98
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#bc7b0a",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#326005",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-2",
  cx: -255.8,
  cy: -157.42,
  r: 30.41,
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-3",
  cx: -261.04,
  cy: 93.93,
  r: 30.41,
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-4",
  cx: 133.45,
  cy: 343.54,
  r: 30.41,
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-5",
  cx: -60.3,
  cy: -611.26,
  r: 30.41,
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-6",
  cx: -172.02,
  cy: -539.69,
  r: 30.41,
  gradientTransform: "matrix(0.12, 0.29, 0.29, -0.12, 222.65, 269.78)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-7",
  cx: -177.26,
  cy: -297.06,
  r: 30.41,
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-8",
  cx: -90.92,
  cy: 40.24,
  r: 30.41,
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-9",
  cx: 26.16,
  cy: 187.25,
  r: 30.41,
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-10",
  cx: 3994.05,
  cy: -275.96,
  r: 51.94,
  gradientTransform: "translate(1356.95 116.67) rotate(180) scale(0.31)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-11",
  cx: 4036.84,
  cy: -579.59,
  r: 51.94,
  gradientTransform: "translate(544.03 1488.97) rotate(-102.38) scale(0.31)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-12",
  cx: 4004.75,
  cy: -55.44,
  r: 51.94,
  gradientTransform: "translate(1003.22 1005.26) rotate(-135) scale(0.31)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-13",
  cx: 462.16,
  cy: 275.47,
  r: 30.41,
  gradientTransform: "translate(466.12 116.67) rotate(180) scale(0.31)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-14",
  cx: 355.69,
  cy: -157.42,
  r: 30.41,
  gradientTransform: "translate(466.12 116.67) rotate(180) scale(0.31)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-15",
  cx: 350.45,
  cy: 93.93,
  r: 30.41,
  gradientTransform: "translate(466.12 116.67) rotate(180) scale(0.31)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-16",
  cx: 744.94,
  cy: 343.54,
  r: 30.41,
  gradientTransform: "translate(466.12 116.67) rotate(180) scale(0.31)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-17",
  cx: 551.19,
  cy: -611.26,
  r: 30.41,
  gradientTransform: "translate(466.12 116.67) rotate(180) scale(0.31)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-18",
  cx: 439.47,
  cy: -539.69,
  r: 30.41,
  gradientTransform: "matrix(-0.29, -0.12, 0.12, -0.29, 520.37, 182.42)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-19",
  cx: 434.24,
  cy: -297.06,
  r: 30.41,
  gradientTransform: "translate(466.12 116.67) rotate(180) scale(0.31)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-20",
  cx: 520.57,
  cy: 40.24,
  r: 30.41,
  gradientTransform: "translate(466.12 116.67) rotate(180) scale(0.31)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-21",
  cx: 637.65,
  cy: 187.25,
  r: 30.41,
  gradientTransform: "translate(466.12 116.67) rotate(180) scale(0.31)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-22",
  cx: 3382.56,
  cy: -275.96,
  r: 51.94,
  gradientTransform: "matrix(0.31, 0, 0, -0.31, -790.58, 116.67)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-23",
  cx: 3425.35,
  cy: -579.59,
  r: 51.94,
  gradientTransform: "matrix(0.22, 0.22, 0.22, -0.22, -349.7, -586.05)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_3-24",
  cx: 3393.26,
  cy: -55.44,
  r: 51.94,
  gradientTransform: "matrix(0.3, 0.07, 0.07, -0.3, -757.85, -127.79)",
  xlinkHref: "#Degradado_sin_nombre_3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_676",
  cx: 191.27,
  cy: 134.29,
  r: 335.12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#4920a5",
  stopOpacity: 0.98
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#3c1884",
  stopOpacity: 0.98
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#2c105f",
  stopOpacity: 0.99
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#200942",
  stopOpacity: 0.99
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#18042d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#130120"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#11001c"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-14",
  x1: 168.55,
  y1: 277.09,
  x2: 168.55,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-15",
  x1: 212.72,
  y1: 277.09,
  x2: 212.72,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-16",
  x1: 190.86,
  y1: 277.09,
  x2: 190.86,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-17",
  x1: 64.39,
  y1: 277.09,
  x2: 64.39,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-18",
  x1: 321,
  y1: 277.09,
  x2: 321,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-19",
  x1: 209.98,
  y1: 277.09,
  x2: 209.98,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-20",
  x1: 169.23,
  y1: 277.09,
  x2: 169.23,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-21",
  x1: 58.78,
  y1: 277.09,
  x2: 58.78,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-22",
  x1: 120.23,
  y1: 277.09,
  x2: 120.23,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-23",
  x1: 189.76,
  y1: 277.09,
  x2: 189.76,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-24",
  x1: 321.17,
  y1: 277.09,
  x2: 321.17,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-25",
  x1: 259.72,
  y1: 277.09,
  x2: 259.72,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_7-26",
  x1: 190.96,
  y1: 277.09,
  x2: 190.96,
  y2: 93.04,
  xlinkHref: "#Degradado_sin_nombre_7"
}));

function SvgLabelled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 379.51 359.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "labelled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "triangle"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    points: "191.43 70.5 338.68 70.5 265.06 198.02 191.43 325.54 117.81 198.02 44.19 70.5 191.43 70.5",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "1.84457px",
      stroke: "url(#Degradado_sin_nombre_7)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "coAxialCircals",
    className: "coAxialCircals"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 174.08,
    cy: 100.61,
    r: 75.09,
    transform: "translate(-20.15 152.56) rotate(-45)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.230572px",
      stroke: "url(#Degradado_sin_nombre_7-2)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.02,
    cy: 103.46,
    r: 75.09,
    transform: "translate(-11.37 27.76) rotate(-7.26)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.230572px",
      stroke: "url(#Degradado_sin_nombre_7-3)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.69,
    cy: 124.84,
    r: 75.09,
    transform: "translate(-16.31 210.29) rotate(-45)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.230572px",
      stroke: "url(#Degradado_sin_nombre_7-4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.89,
    cy: 159.37,
    r: 75.09,
    transform: "translate(-35.4 233.28) rotate(-45)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.230572px",
      stroke: "url(#Degradado_sin_nombre_7-5)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.07,
    cy: 198.4,
    r: 75.09,
    transform: "translate(-63.24 244.13) rotate(-45)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.230572px",
      stroke: "url(#Degradado_sin_nombre_7-6)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.43,
    cy: 232.14,
    r: 75.09,
    transform: "translate(-92.85 240.12) rotate(-45)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.230572px",
      stroke: "url(#Degradado_sin_nombre_7-7)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.89,
    cy: 252.12,
    r: 75.09,
    transform: "translate(-116.8 222.26) rotate(-45)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.230572px",
      stroke: "url(#Degradado_sin_nombre_7-8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.87,
    cy: 253.33,
    r: 75.09,
    transform: "translate(-112.48 367.74) rotate(-77.99)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.230572px",
      stroke: "url(#Degradado_sin_nombre_7-9)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.16,
    cy: 235.47,
    r: 75.09,
    transform: "translate(-126.63 165.25) rotate(-45)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.230572px",
      stroke: "url(#Degradado_sin_nombre_7-10)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.46,
    cy: 203.02,
    r: 75.09,
    transform: "translate(-110.04 140.4) rotate(-45)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.230572px",
      stroke: "url(#Degradado_sin_nombre_7-11)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.21,
    cy: 164.12,
    r: 75.09,
    transform: "translate(-83.48 126.71) rotate(-45)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.230572px",
      stroke: "url(#Degradado_sin_nombre_7-12)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.81,
    cy: 124.85,
    r: 75.09,
    transform: "translate(-49.68 129.78) rotate(-45)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.230572px",
      stroke: "url(#Degradado_sin_nombre_7-13)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53.66,
    cy: 30.73,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.44,
    cy: 165.79,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-2)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.81,
    cy: 87.37,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-3)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.89,
    cy: 9.49,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.43,
    cy: 307.39,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-5)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.58,
    cy: 285.06,
    r: 9.49,
    transform: "translate(-234.45 218.33) rotate(-67.36)",
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-6)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.95,
    cy: 209.36,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-7)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.88,
    cy: 104.12,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.41,
    cy: 58.25,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-9)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.81,
    cy: 202.77,
    r: 16.2,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-10)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.46,
    cy: 297.51,
    r: 16.2,
    transform: "translate(-214.02 328.93) rotate(-77.62)",
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-11)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.47,
    cy: 133.97,
    r: 16.2,
    transform: "translate(-63.26 115.23) rotate(-45)",
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-12)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 321.92,
    cy: 30.73,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-13)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.15,
    cy: 165.79,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-14)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.78,
    cy: 87.37,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-15)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.7,
    cy: 9.49,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-16)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.15,
    cy: 307.39,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-17)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 285.06,
    r: 9.49,
    transform: "translate(-84.37 148.6) rotate(-22.64)",
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-18)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.64,
    cy: 209.36,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-19)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.7,
    cy: 104.12,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-20)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.17,
    cy: 58.25,
    r: 9.49,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-21)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.78,
    cy: 202.77,
    r: 16.2,
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-22)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.13,
    cy: 297.51,
    r: 16.2,
    transform: "translate(-128.91 283.8) rotate(-45)",
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-23)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.12,
    cy: 133.97,
    r: 16.2,
    transform: "translate(-23.72 65.67) rotate(-13.38)",
    style: {
      mixBlendMode: "hard-light",
      fill: "url(#Degradado_sin_nombre_3-24)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BodycompoundPath",
    d: "M378.18,281a4.55,4.55,0,0,0-3.11-.83,11.29,11.29,0,0,1-1.73-.13c-.26,0-.52-.06-.79-.09a5.37,5.37,0,0,0,.57-.5l.65-.58a5,5,0,0,0,1.48-1.7,2.27,2.27,0,0,0-.93-2.95,4.66,4.66,0,0,0-3.2-.47,20.82,20.82,0,0,0-4.78,2.41,16.86,16.86,0,0,1-5.3,2.49,9,9,0,0,1-1.38.18c.41-.29.81-.59,1.2-.91a4.15,4.15,0,0,0,1.06-1.2,4.35,4.35,0,0,0,.38-1.93l.16-3.82a22,22,0,0,0,0-2.3c-.19-3.2-1.67-6.11-3.31-9.06a5.31,5.31,0,0,0-.41-.65l.1,0,0,.11a1.76,1.76,0,0,0,.77-2.27,2.8,2.8,0,0,0-1.71-1.45,8.94,8.94,0,0,0-4.08-.15l-.79.08c-.88.09-1.8.12-2.69.14-2.43.08-4.95.16-7.13,1.36a13.26,13.26,0,0,0-1.37.88,18.58,18.58,0,0,1-7,2.84c-.88.19-1.8.34-2.68.48a23.74,23.74,0,0,0-6,1.51,23.26,23.26,0,0,0-2.21,1.18c-.65.37-1.32.76-2,1.07a14,14,0,0,1-7.47,1.19,22.37,22.37,0,0,1-4.18-1.67l-2.17-1c-6-2.87-12.23-5.84-17.47-9.86-.78-.6-1.54-1.24-2.27-1.86-1.09-.92-2.22-1.87-3.43-2.7a42.09,42.09,0,0,0-5.38-2.89c-4.47-2.16-9.43-4.55-11-8.69-.19-.76-.34-1.52-.46-2.28,0-.2,0-.4,0-.6h-.08a74.66,74.66,0,0,1-.4-12.33,68.35,68.35,0,0,0-.64-13.92,71.74,71.74,0,0,0-3.07-10.5A58,58,0,0,1,260.65,185c-.12-1-.29-2-.46-3a24.22,24.22,0,0,1-.54-5.6c.07-1.23.26-2.49.47-3.83.43-2.75.88-5.61.12-8.24a55.13,55.13,0,0,0-4.81-12,.35.35,0,0,0,.09-.38h0l.11,0c-1.3-3.51-4.11-6.55-8.84-9.57a34.42,34.42,0,0,0-8.72-4.16,50.83,50.83,0,0,0-10.8-1.57l-1.48-.11a47.35,47.35,0,0,1-12.35-2.86v0c-4.23-2.1-6.73-5.32-7.44-9.64a22.42,22.42,0,0,1,0-5l-.11,0a.49.49,0,0,0,0-.12,29.39,29.39,0,0,0,6.6-9.43l.11-.4a.33.33,0,0,0,.22-.18l.1,0a22,22,0,0,1,6-7.68l.57-.44A9.61,9.61,0,0,0,222.21,98a9.41,9.41,0,0,0,.93-3.52c.36-3,.7-6.1,1-9.13l0-.39-4.53-1.21,1.68-6a21.49,21.49,0,0,0-1.26-15.09c-3.74-7.79-11.73-17.19-28.6-17.74h-1.65C173,45.39,165,54.79,161.22,62.58A21.49,21.49,0,0,0,160,77.67l1.7,6.11-.37.07-4,1.08,0,.39c.29,3,.63,6.1,1,9.13a9.21,9.21,0,0,0,.92,3.52,9.61,9.61,0,0,0,2.66,2.73l.57.44a21.86,21.86,0,0,1,6,7.68l.1,0,0,0,.16.57a28.67,28.67,0,0,0,5.15,8,37.93,37.93,0,0,1,0,6.57c-.72,4.38-3.28,7.63-7.62,9.73v0a43.7,43.7,0,0,1-11.44,2.72l-2.2.17a50.92,50.92,0,0,0-10.8,1.57,34.42,34.42,0,0,0-8.72,4.16c-4.73,3-7.54,6.06-8.84,9.57l.11,0h0a.34.34,0,0,0,.1.38,54.62,54.62,0,0,0-4.82,12c-.75,2.63-.31,5.49.12,8.24.21,1.34.41,2.6.48,3.83a24.24,24.24,0,0,1-.55,5.6c-.17,1-.34,2-.45,3a59.21,59.21,0,0,1-3.37,12.59,71.77,71.77,0,0,0-3.08,10.5,67.63,67.63,0,0,0-.63,13.92,74.67,74.67,0,0,1-.41,12.33h-.08c0,.2,0,.4,0,.6-.13.76-.28,1.52-.46,2.28-1.54,4.14-6.49,6.53-11,8.69a41.92,41.92,0,0,0-5.37,2.89c-1.21.83-2.34,1.78-3.44,2.7-.73.62-1.49,1.26-2.26,1.86-5.25,4-11.47,7-17.48,9.86l-2.17,1a22.27,22.27,0,0,1-4.17,1.67,14.07,14.07,0,0,1-7.48-1.19c-.68-.31-1.35-.7-2-1.07a22.1,22.1,0,0,0-2.21-1.18,23.74,23.74,0,0,0-6-1.51c-.88-.14-1.8-.29-2.67-.48a19.74,19.74,0,0,1-5.83-2.13,7.13,7.13,0,0,1-1-.79,6.65,6.65,0,0,0-1.1-.84,12.94,12.94,0,0,0-3.5-1.3,27.88,27.88,0,0,0-10-.7c-1,.11-2.42.4-3,1.54a5.06,5.06,0,0,0-.08,3l.11,0a.35.35,0,0,0,.36.27l-.07.12c-1.63,3-3.12,5.86-3.31,9.06a19.63,19.63,0,0,0,0,2.3l.15,3.82A4.64,4.64,0,0,0,18,276.7a4,4,0,0,0,1.07,1.2c.38.32.79.62,1.2.91a9.27,9.27,0,0,1-1.39-.18,17,17,0,0,1-5.3-2.49,20.75,20.75,0,0,0-4.77-2.41,4.68,4.68,0,0,0-3.21.47,2.28,2.28,0,0,0-.93,2.95,5,5,0,0,0,1.49,1.7c.28.24.47.42.64.59a6.19,6.19,0,0,0,.55.47l-1.53.14c-.48.06-1,.11-1.47.15a5.91,5.91,0,0,0-2,.37,2,2,0,0,0-1.28,1.31,2.74,2.74,0,0,0-1,1.65,4,4,0,0,0,.58,3.1,5.32,5.32,0,0,0,3.51,2.17A14.49,14.49,0,0,0,7,289h.25c1.62,0,3.26.09,4.88.21a2,2,0,0,0,1,1,3.27,3.27,0,0,0,1.4.23h.91a79.93,79.93,0,0,0,17.38-1.83c2.56-.48,5.46-1,9.14-1.57,3-.45,5.51-1,8-1.59a63.91,63.91,0,0,1,11.82-1.88v-.11a.41.41,0,0,0,.19-.08l2.5-.4c22.12-3.55,36.74-5.89,57.48-16.1,3.61-1.78,7.37-3.76,10.24-6.72,3.23-3.34,5.74-8.34,7.48-14.85.2,2.14.46,4.27.72,6.36.41,3.35.85,6.81,1,10.23a47.83,47.83,0,0,1-1.2,12.67h0c-9.58,5-21.27,8.35-31.63,11.05-3.64.95-7.39,1.93-11,3-10,2.91-17.65,6.11-24.05,10.09a52.75,52.75,0,0,0-10.25,8.15,24.84,24.84,0,0,0-1.81,2.2,24.51,24.51,0,0,1-1.71,2.09,19.37,19.37,0,0,1-2,1.71,15.09,15.09,0,0,0-2.83,2.67c-2.22,2.93-3.07,6.64-3.56,9.53-1.91,11.25.38,21.09,6.31,27,4.49,4.49,11.46,7,19.25,7h.92c7.21-.18,14.25-2.3,21.06-4.34l.12,0c28.94-8.67,60.67-17.61,94.31-26.58l0-.11a.35.35,0,0,0,.23-.21c28,8.63,65.86,18.78,99.18,26.61,5,1.18,10.66,2.51,16.39,2.51h.25c4.48,0,10.87-1,15.93-5.18s8.07-11.5,8.16-19.89c.07-5.85-1.19-10.72-3.75-14.47a25.39,25.39,0,0,0-9.28-7.76c-.78-.42-1.62-.78-2.43-1.12a21.86,21.86,0,0,1-3.18-1.57,8.86,8.86,0,0,1-1.91-1.86c-.3-.36-.61-.73-.95-1.08-5.44-5.59-13.33-10.8-23.45-15.47a61.19,61.19,0,0,0-12.59-4.4c-2.21-.48-4.49-.8-6.69-1.11-1.23-.17-2.46-.35-3.69-.55-5.3-.87-11.31-3.31-17.12-5.67-3.23-1.32-6.28-2.55-9.12-3.49a59.53,59.53,0,0,1-.35-11.63c.17-3.35.59-6.73,1-10,.24-1.93.48-3.91.67-5.9,1.73,6.29,4.2,11.13,7.37,14.39,2.87,3,6.63,4.94,10.23,6.72,20.75,10.21,35.36,12.55,57.48,16.1l2.5.4a.4.4,0,0,0,.2.08v.11a63.91,63.91,0,0,1,11.82,1.88c2.44.56,5,1.14,8,1.59,3.67.54,6.57,1.09,9.14,1.57a79.9,79.9,0,0,0,17.37,1.83h.91a3.33,3.33,0,0,0,1.41-.23,2.07,2.07,0,0,0,1-1c1.63-.12,3.26-.2,4.88-.21,2,0,3.51-.12,5.16-1.49a4.48,4.48,0,0,0,.74-.76,4.62,4.62,0,0,0,.71-1.71C379.63,283.67,379.73,282.13,378.18,281ZM33.75,268.25c-.4,1.75-.61,3.53-.89,5.3a1.39,1.39,0,0,1-1.34,1,9.52,9.52,0,0,1-3.68-1.38c-1.05-.52-2.69-.66-3.5-1.51s-.67-2.09-.61-3.12a24.48,24.48,0,0,1,.41-4.36l0-.09a1.46,1.46,0,0,1,1.59-2.06c2.4.5,6.23,1.37,7.77,3.5A3,3,0,0,1,33.75,268.25Z",
    style: {
      fill: "url(#Degradado_sin_nombre_676)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "BodyLayout"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.38,161.67a11.25,11.25,0,0,0-3.26-2.67,10.88,10.88,0,0,0-3.46-.78c-1.06-.13-2.14-.22-3.22-.31a39.34,39.34,0,0,1-9.06-1.48c-3.76-1.27-7.1-3.54-10.34-5.74a.46.46,0,0,0-.64.13.46.46,0,0,0,.12.64c3.29,2.23,6.69,4.54,10.57,5.84a40,40,0,0,0,9.27,1.53c1.08.09,2.15.18,3.19.3a7.57,7.57,0,0,1,6.16,3.17l4.27,4.54a.46.46,0,1,0,.67-.64Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.23,150.69c-3.24,2.2-6.58,4.47-10.34,5.74a39.34,39.34,0,0,1-9.06,1.48c-1.09.09-2.16.18-3.22.31a10.88,10.88,0,0,0-3.46.78,11,11,0,0,0-3.26,2.67l-4.27,4.53a.46.46,0,0,0,0,.66.47.47,0,0,0,.65,0l4.27-4.54a7.57,7.57,0,0,1,6.16-3.17c1-.12,2.11-.21,3.19-.3a40,40,0,0,0,9.27-1.53c3.88-1.3,7.28-3.61,10.57-5.84a.46.46,0,0,0,.12-.64A.46.46,0,0,0,229.23,150.69Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.86,201.11a.46.46,0,0,0,.46-.46V173.48a.45.45,0,0,0-.46-.46.46.46,0,0,0-.46.46v27.17A.47.47,0,0,0,190.86,201.11Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.46,349.76c-3.54-2-7.55-4.35-9.7-8.13-2.58-4.51-1.84-10.11-.76-14a.45.45,0,0,0-.32-.56.46.46,0,0,0-.57.32c-1.12,4.07-1.89,9.93.85,14.72,2.28,4,6.58,6.47,10,8.47a.49.49,0,0,0,.23.06.45.45,0,0,0,.4-.23A.46.46,0,0,0,70.46,349.76Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.34,341a.46.46,0,0,0,.23-.06,11.37,11.37,0,0,0,5-13.23.45.45,0,0,0-.58-.28.47.47,0,0,0-.29.59,10.42,10.42,0,0,1-4.56,12.12.47.47,0,0,0-.18.63A.45.45,0,0,0,318.34,341Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.93,259.5a.47.47,0,0,0,.31.12.45.45,0,0,0,.34-.15,34.66,34.66,0,0,0,8.84-25.23l0-.22a6,6,0,0,1,.22-2.72,5.66,5.66,0,0,1,1.29-1.65l.17-.17a26.57,26.57,0,0,0,5.06-7.31.46.46,0,0,0-.22-.61.47.47,0,0,0-.62.22,25.49,25.49,0,0,1-4.88,7.05l-.17.17a5,5,0,0,0-1.77,5.08l0,.22a33.71,33.71,0,0,1-8.6,24.55A.46.46,0,0,0,201.93,259.5Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.71,234.3l0-.23A5,5,0,0,0,167,229l-.17-.18a25.64,25.64,0,0,1-4.88-7.05.46.46,0,0,0-.61-.22.47.47,0,0,0-.23.61,26.57,26.57,0,0,0,5.06,7.31l.18.17a5.79,5.79,0,0,1,1.28,1.65,5.94,5.94,0,0,1,.22,2.71l0,.23a34.7,34.7,0,0,0,8.84,25.23.45.45,0,0,0,.34.15.47.47,0,0,0,.31-.12.46.46,0,0,0,0-.65A33.75,33.75,0,0,1,168.71,234.3Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.83,268.61a.43.43,0,0,0-.48.43.46.46,0,0,0,.43.49,8.17,8.17,0,0,1,5.63,2.71.49.49,0,0,0,.35.15.51.51,0,0,0,.31-.11.47.47,0,0,0,0-.66A9.14,9.14,0,0,0,55.83,268.61Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.15,243.46a.46.46,0,0,0-.51.4.46.46,0,0,0,.41.51,7.49,7.49,0,0,1,5.89,4.3.45.45,0,0,0,.42.27.39.39,0,0,0,.18,0,.45.45,0,0,0,.24-.6A8.39,8.39,0,0,0,117.15,243.46Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.18,281a4.52,4.52,0,0,0-3.11-.83,11.16,11.16,0,0,1-1.72-.13l-.71-.08.39-.38c.2-.21.43-.44.74-.71a5,5,0,0,0,1.49-1.7,2.28,2.28,0,0,0-.93-2.95,4.68,4.68,0,0,0-3.21-.47,20.75,20.75,0,0,0-4.77,2.41,17,17,0,0,1-5.3,2.49,9.27,9.27,0,0,1-1.39.18c.41-.29.82-.59,1.2-.91a3.92,3.92,0,0,0,1.07-1.2,4.64,4.64,0,0,0,.38-1.93l.15-3.82a19.57,19.57,0,0,0,0-2.3c-.19-3.2-1.68-6.11-3.31-9.06q-.14-.24-.3-.48a2.22,2.22,0,0,0,.81-2.35,2.79,2.79,0,0,0-1.72-1.45,8.89,8.89,0,0,0-4.07-.15l-.8.08c-.88.09-1.8.12-2.69.14-2.43.08-4.94.16-7.13,1.36a13.89,13.89,0,0,0-1.37.88,18.44,18.44,0,0,1-7,2.84c-.88.19-1.79.34-2.68.48a23.77,23.77,0,0,0-6,1.51,23.26,23.26,0,0,0-2.21,1.18c-.65.37-1.32.76-2,1.07a11.72,11.72,0,0,1-7.17,1.26l-.13,0-.46-.13-.87-.27c-.24-.09-.48-.18-.71-.29l-.1,0c-.76-.31-1.51-.67-2.21-1l-2.17-1c-6-2.87-12.23-5.84-17.48-9.86-.77-.6-1.53-1.24-2.26-1.86-1.1-.92-2.23-1.87-3.44-2.7a41.92,41.92,0,0,0-5.37-2.89c-4.48-2.16-9.44-4.55-11-8.7-.18-.75-.33-1.51-.46-2.27,0-.2,0-.4,0-.6a.48.48,0,0,0-.12-.32,75.31,75.31,0,0,1-.36-12,68.41,68.41,0,0,0-.64-13.93,70.55,70.55,0,0,0-3.08-10.5A59.21,59.21,0,0,1,260.65,185c-.11-1-.28-2-.45-3a23.82,23.82,0,0,1-.54-5.61,36.64,36.64,0,0,1,.47-3.83c.43-2.75.87-5.61.12-8.24a55.16,55.16,0,0,0-4.85-12.09,21.65,21.65,0,0,0-8.6-9.93,34.42,34.42,0,0,0-8.72-4.16,50.92,50.92,0,0,0-10.8-1.57l-1.49-.11a47.19,47.19,0,0,1-12.34-2.86h-.07A12.71,12.71,0,0,1,206,124a21.85,21.85,0,0,1,0-5,.53.53,0,0,0,0-.25,29.71,29.71,0,0,0,6.5-9.34l.07-.28a.45.45,0,0,0,.36-.25,21.75,21.75,0,0,1,6-7.68l.57-.45A9.45,9.45,0,0,0,222.22,98a9.21,9.21,0,0,0,.92-3.52c.37-3,.71-6.1,1-9.13a.46.46,0,0,0-.34-.49c-.61-.17-1.42-.36-2.22-.55s-1.39-.33-2-.48l1.71-6.13a21.54,21.54,0,0,0-1.26-15.09c-3.74-7.79-11.73-17.19-28.61-17.74h-1.65C173,45.39,165,54.79,161.22,62.58A21.54,21.54,0,0,0,160,77.67l1.67,6-2,.56c-.7.2-1.41.41-2,.57a.46.46,0,0,0-.34.49c.29,3,.62,6.1,1,9.13a9.64,9.64,0,0,0,.92,3.52,9.52,9.52,0,0,0,2.67,2.73l.57.44a21.83,21.83,0,0,1,6,7.68.47.47,0,0,0,.21.21l.1.36a28.67,28.67,0,0,0,5.15,8,37.93,37.93,0,0,1,0,6.57c-.72,4.35-3.25,7.58-7.52,9.68a.35.35,0,0,0-.11,0,44.26,44.26,0,0,1-11.45,2.71l-2.19.17a50.83,50.83,0,0,0-10.8,1.57,34.42,34.42,0,0,0-8.72,4.16c-4,2.58-7.7,6.88-9.11,10.72a.42.42,0,0,0,0,.19,56.41,56.41,0,0,0-4.31,11.11c-.76,2.63-.31,5.49.12,8.24.21,1.34.4,2.6.47,3.83a24.22,24.22,0,0,1-.54,5.6c-.17,1-.34,2-.46,3a58,58,0,0,1-3.37,12.59,71.74,71.74,0,0,0-3.07,10.5,68.41,68.41,0,0,0-.64,13.93,76.5,76.5,0,0,1-.36,12,.48.48,0,0,0-.12.32c0,.2,0,.4,0,.6q-.18,1.14-.45,2.28c-1.54,4.14-6.5,6.53-11,8.69a42.09,42.09,0,0,0-5.38,2.89c-1.21.83-2.34,1.78-3.43,2.7-.73.62-1.49,1.26-2.27,1.86-5.24,4-11.46,7-17.47,9.86l-2.17,1-1,.5a14.18,14.18,0,0,1-1.86.84,13.83,13.83,0,0,1-8.79-.86,22.72,22.72,0,0,1-2-1.08c-.71-.4-1.44-.83-2.21-1.17a23.74,23.74,0,0,0-6-1.51c-.88-.14-1.8-.29-2.68-.48a19.77,19.77,0,0,1-5.82-2.13,7.13,7.13,0,0,1-1-.79,7.29,7.29,0,0,0-1.1-.85,13.54,13.54,0,0,0-3.51-1.29,28.07,28.07,0,0,0-10-.7c-1,.11-2.43.4-3,1.54s0,3.66,0,3.69a.37.37,0,0,0,.05.11c-1.53,2.8-2.88,5.57-3.06,8.61a21.09,21.09,0,0,0,0,2.38l.15,3.74A4.43,4.43,0,0,0,18,276.7a4,4,0,0,0,1.07,1.2c.38.32.78.62,1.2.91a9,9,0,0,1-1.39-.18,16.86,16.86,0,0,1-5.3-2.49,20.82,20.82,0,0,0-4.78-2.41,4.66,4.66,0,0,0-3.2.47,2.27,2.27,0,0,0-.93,2.95,5.1,5.1,0,0,0,1.48,1.7c.3.25.51.46.7.65l.45.41-1.48.14q-.72.09-1.47.15H4.13a4.45,4.45,0,0,0-1.6.3A5.22,5.22,0,0,0,1,281.68a4,4,0,0,0-.49,4.71,5.27,5.27,0,0,0,3.65,2.41A14.33,14.33,0,0,0,7,289h.28c1.8,0,3.1.11,4.9.26a2.06,2.06,0,0,0,1,.94,3.33,3.33,0,0,0,1.41.23h.91a79.76,79.76,0,0,0,17.37-1.83c2.57-.48,5.47-1,9.14-1.57,3-.45,5.52-1,8-1.59a63.91,63.91,0,0,1,11.82-1.88.43.43,0,0,0,.36-.22L64.4,283c22.12-3.55,36.73-5.89,57.48-16.1,3.6-1.78,7.36-3.76,10.23-6.72,3.24-3.34,5.75-8.34,7.48-14.85.21,2.14.46,4.28.72,6.36.42,3.35.85,6.81,1,10.23a47.37,47.37,0,0,1-1.17,12.52c-10,5.25-21.73,8.43-33.05,11.5-3.2.87-6.51,1.77-9.66,2.69-10,2.91-17.65,6.11-24,10.09a53.12,53.12,0,0,0-10.26,8.15,24.72,24.72,0,0,0-1.8,2.2,22.81,22.81,0,0,1-1.72,2.09,18.26,18.26,0,0,1-2,1.71,14.5,14.5,0,0,0-2.83,2.67c-2.22,2.93-3.07,6.64-3.56,9.53-1.92,11.25.38,21.09,6.31,27,4.49,4.49,11.46,7,19.25,7h.91c7.21-.18,14.26-2.3,21.07-4.34l.12,0c28.94-8.67,60.67-17.61,94.3-26.58a.43.43,0,0,0,.31-.29c28,8.63,65.8,18.76,99.08,26.58,5,1.18,10.65,2.51,16.39,2.51h.25c4.48,0,10.87-1,15.92-5.18s8.07-11.5,8.17-19.89c.07-5.85-1.2-10.72-3.75-14.47a25.48,25.48,0,0,0-9.28-7.76c-.78-.42-1.62-.78-2.43-1.12a21.37,21.37,0,0,1-3.18-1.57,8.64,8.64,0,0,1-1.91-1.86c-.31-.36-.61-.73-1-1.08-5.43-5.59-13.32-10.8-23.44-15.47a61.4,61.4,0,0,0-12.59-4.4c-2.22-.48-4.49-.8-6.7-1.11-1.23-.17-2.46-.35-3.68-.55-5.3-.87-11.31-3.31-17.12-5.67-3.23-1.31-6.28-2.55-9.12-3.49a59.53,59.53,0,0,1-.35-11.63c.16-3.35.59-6.74,1-10,.25-1.94.49-3.91.68-5.89,1.73,6.28,4.2,11.12,7.36,14.38,2.87,3,6.63,4.94,10.24,6.72,20.74,10.21,35.36,12.55,57.48,16.1l2.32.37a.46.46,0,0,0,.37.22,63.91,63.91,0,0,1,11.82,1.88c2.44.56,5,1.14,7.95,1.59,3.68.54,6.58,1.09,9.14,1.57a79.9,79.9,0,0,0,17.37,1.83h.92a3.29,3.29,0,0,0,1.4-.23,2,2,0,0,0,1-1c1.82-.15,3.05-.23,4.9-.24,2,0,3.5-.12,5.16-1.49a5.17,5.17,0,0,0,.74-.76,4.53,4.53,0,0,0,.7-1.71C379.63,283.67,379.74,282.14,378.18,281Zm-11.35-4.06a20.34,20.34,0,0,1,4.56-2.3,3.71,3.71,0,0,1,2.5.39,1.34,1.34,0,0,1,.53,1.75,4.21,4.21,0,0,1-1.24,1.39,10.8,10.8,0,0,0-.82.77,3.88,3.88,0,0,1-1.23.95,75.42,75.42,0,0,1-9.3-.49A19.39,19.39,0,0,0,366.83,276.92Zm-5.27-8.22c0,.73,0,1.48,0,2.21l-.15,3.82a3.84,3.84,0,0,1-.28,1.54,3.08,3.08,0,0,1-.84.92,16.28,16.28,0,0,1-2.38,1.65h-.11a14.32,14.32,0,0,1-3.79-.4,15.4,15.4,0,0,1-2-.8l-.53-.24a31.45,31.45,0,0,0-3.28-1.22q-.07-.37-.15-.78c2.56-.85,5.11-1.8,7.59-2.83a1.6,1.6,0,0,0,.73-.49,1.65,1.65,0,0,0,.28-.83,19.34,19.34,0,0,0,0-6l-.07-.33a10.05,10.05,0,0,1-.31-4.49,2.64,2.64,0,0,1,.38-1,.86.86,0,0,1,.69-.4c.44,0,.78.55,1.06,1.05C359.94,262.89,361.38,265.7,361.56,268.7Zm-6.39-6.63a15.55,15.55,0,0,0,.47,3l.07.33a18.3,18.3,0,0,1,0,5.72.89.89,0,0,1-.09.38.9.9,0,0,1-.35.2c-2.42,1-4.92,1.94-7.42,2.77-.48-2.36-1.16-5-1.7-6.93-.08-.27-.16-.55-.26-.83,0,0,.07-.05.09-.09a6,6,0,0,1,2.56-2.36,11.45,11.45,0,0,1,3.5-1A7.55,7.55,0,0,0,355.17,262.07Zm-131-124.8,1.48.11,2,.25c1.58.2,3.16.4,4.75.64-1.4,0-2.8.08-4.17.14-2.16.1-4.38.2-6.58.19-5.86,0-12.39-.63-16.36-4.92a.42.42,0,0,0-.14-.09v-9.08C206.59,132,213,136.27,224.22,137.27Zm-2.85-52.09,1.81.44c-.28,2.9-.6,5.83-1,8.71a8.89,8.89,0,0,1-.81,3.19A8.84,8.84,0,0,1,219,100l-.58.45a22.62,22.62,0,0,0-5,5.59l5.93-21.32ZM163,100.42l-.58-.45A8.84,8.84,0,0,1,160,97.52a8.79,8.79,0,0,1-.81-3.19c-.35-2.88-.67-5.81-1-8.71l1.66-.47,2-.56,5.86,21A23,23,0,0,0,163,100.42Zm-2.18-23A20.63,20.63,0,0,1,162.06,63c3.62-7.56,11.39-16.68,27.77-17.21h1.62c16.39.54,24.16,9.66,27.79,17.22a20.58,20.58,0,0,1,1.2,14.44l-8.8,31.64c-.06.15-6,15-21.09,15.18-15.08-.18-20.84-15-20.89-15.13Zm13.29,49.42v7.86a.35.35,0,0,0-.16.08,18.32,18.32,0,0,1-12.36,3.54c-1.66-.09-3.39-.33-5.07-.56l-2.46-.32.86-.11.77-.06C165.74,136.38,171.92,132.88,174.14,126.84ZM18.84,276.27a3.58,3.58,0,0,1-.28-1.54l-.15-3.82a18.07,18.07,0,0,1,0-2.21c.18-3,1.61-5.81,3.2-8.66.28-.5.62-1,1.06-1.05a.89.89,0,0,1,.69.39,2.75,2.75,0,0,1,.38,1,10.2,10.2,0,0,1-.31,4.49l-.07.33a19,19,0,0,0,0,6,1.63,1.63,0,0,0,.27.83,1.68,1.68,0,0,0,.73.49c2.48,1,5,2,7.58,2.83-.05.26-.1.52-.14.77v0a31.22,31.22,0,0,0-3.27,1.21l-.53.24a15.4,15.4,0,0,1-2,.8,14.32,14.32,0,0,1-3.79.4h-.11a16.93,16.93,0,0,1-2.39-1.65A3.18,3.18,0,0,1,18.84,276.27Zm8.8-13,.29,0a11.74,11.74,0,0,1,3.5,1A5.92,5.92,0,0,1,34,266.64l.09.09c-.09.28-.17.56-.25.83-.36,1.28-1.15,4.18-1.72,6.92-2.49-.83-5-1.75-7.4-2.76a.9.9,0,0,1-.35-.2.89.89,0,0,1-.09-.38,18.3,18.3,0,0,1,0-5.72l.07-.33a17.64,17.64,0,0,0,.45-2.68A8,8,0,0,0,27.64,263.22ZM6.76,278.15a4.29,4.29,0,0,1-1.23-1.39A1.34,1.34,0,0,1,6.06,275a3.7,3.7,0,0,1,2.5-.39,20.06,20.06,0,0,1,4.55,2.3,19.88,19.88,0,0,0,5,2.47,73.93,73.93,0,0,1-9.18.48l-.11-.08a3.88,3.88,0,0,1-1.32-1C7.31,278.64,7.08,278.41,6.76,278.15Zm241.16-.53c5.86,2.38,11.92,4.85,17.32,5.73,1.23.2,2.47.38,3.71.55,2.18.31,4.44.62,6.62,1.1a59.91,59.91,0,0,1,12.4,4.33c10,4.63,17.81,9.78,23.17,15.29.33.33.62.68.91,1a9.6,9.6,0,0,0,2.12,2,21.23,21.23,0,0,0,3.31,1.64c.8.34,1.62.69,2.36,1.09a24.48,24.48,0,0,1,9,7.47c2.45,3.59,3.66,8.28,3.6,13.94-.09,8.12-2.95,15.12-7.84,19.2s-11,4.93-15.34,5c-5.7.07-11.4-1.29-16.42-2.48-23.46-5.51-49.14-12.17-72.07-18.64a.56.56,0,0,0-.21-.22,65.22,65.22,0,0,0-11-3.34l-.76-.19c-2.55-.62-4.9-1.34-7.18-2s-4.67-1.43-7.24-2.05l-1.5-.37-.66-.2a.38.38,0,0,0-.21,0l-11.63-2.83a15.84,15.84,0,0,0,6.55-8.89c1.29-4.07,1.31-8.37,1.14-12.4a9.07,9.07,0,0,0-1-4.56l3.43.23c2.85.2,5.7.39,9.29.67l.77.07a4.26,4.26,0,0,0,.7.07l.57,0a36.16,36.16,0,0,0,4.65.28,12.14,12.14,0,0,0,2.21-.3,12.38,12.38,0,0,1,1.85-.28,51.9,51.9,0,0,1,9,.57c1.7.21,3.47.42,5.16.53,9.59.62,19.34.83,29,.63l1.4,0a77.75,77.75,0,0,1,12.85.43c5.32.78,9.62,2.61,12.78,5.43a36.21,36.21,0,0,1,6.24,8.25.46.46,0,0,0,.39.22.51.51,0,0,0,.24-.07.46.46,0,0,0,.15-.64,36.61,36.61,0,0,0-6.41-8.45,20.8,20.8,0,0,0-3.59-2.53c.06-5.92-3.73-11.88-9.45-14.84-7.89-4.07-16.05-1.87-23.94.25-5.07,1.37-10.32,2.77-15.44,2.52-1.44-.07-2.95-.23-4.42-.39-5-.53-10.14-1.08-14.38,1.59a22.22,22.22,0,0,0-2.78,2.2c-.61.54-1.25,1.11-1.91,1.6l-.21.16c-1.25.92-2.53,1.86-3.87,1.89l-.68-.06-.12,0h-.17l-.48,0c-3.6-.28-6.44-.47-9.29-.67s-5.69-.38-9.29-.66a.37.37,0,0,0-.31.1,13,13,0,0,1-3.81-2.21l-.1-.08c-.67-.49-1.3-1-1.92-1.6a21.52,21.52,0,0,0-2.78-2.2c-4.24-2.67-9.39-2.12-14.38-1.59-1.46.16-3,.32-4.42.39-5.12.25-10.36-1.15-15.43-2.52-7.9-2.12-16.06-4.32-24-.24-5.72,3-9.51,8.93-9.44,14.86a6.73,6.73,0,0,0,.32,2.08A23.16,23.16,0,0,0,97,304a10.76,10.76,0,0,0-6.82,5.35.46.46,0,0,0,.83.4,9.83,9.83,0,0,1,6.25-4.87,23.08,23.08,0,0,1,8.12-.56,3.27,3.27,0,0,0,.7.82,5.62,5.62,0,0,0,3.65.85h1.85c8.17,0,16.61,0,24.48,2.68a94.34,94.34,0,0,1,12.05,5.48c1.15.6,2.3,1.19,3.46,1.76,2.3,1.15,4.8,2.26,7.89,3.5a29.56,29.56,0,0,0,5.33,1.41c.84.17,1.68.34,2.53.54l11.12,2.71a.45.45,0,0,0,.38.22.43.43,0,0,0,.19,0l.06,0,13,3.18c-33.35,8.89-64.82,17.76-93.53,26.37l-.12,0c-6.76,2-13.74,4.12-20.83,4.3-7.87.21-15-2.26-19.49-6.75-5.71-5.71-7.92-15.27-6-26.21.47-2.8,1.29-6.36,3.38-9.14a14.35,14.35,0,0,1,2.67-2.49,19.27,19.27,0,0,0,2.08-1.8,23.16,23.16,0,0,0,1.79-2.17,25.47,25.47,0,0,1,1.74-2.12,52.27,52.27,0,0,1,10.07-8c6.34-3.93,13.91-7.1,23.83-10,3.14-.91,6.44-1.81,9.64-2.68,11.12-3,22.59-6.15,32.54-11.23-.3,1.26-.62,2.56-1,3.93a.46.46,0,0,0,.32.57l.12,0a.48.48,0,0,0,.45-.34,74,74,0,0,0,1.9-8.41c5.33,1.16,10.11,2,14.48.05a22.76,22.76,0,0,0,2.91-1.61c.7-.43,1.42-.87,2.16-1.24,5.44-2.76,12-1.87,17.7-.82,2.59.47,5.22,1,7.76,1.51a163.57,163.57,0,0,0,22,3.39c1.53.1,3,.15,4.49.15,9.71,0,18-2.1,24.62-6.23a68.18,68.18,0,0,0,1.12,11.19.45.45,0,0,0,.45.38h.07a.46.46,0,0,0,.39-.53c-.19-1.18-.36-2.26-.5-3.26C242,275.21,244.87,276.38,247.92,277.62Zm-80.34,42.87c-.86-.2-1.72-.37-2.57-.54a28.7,28.7,0,0,1-5.17-1.37c-3.06-1.23-5.55-2.33-7.82-3.46l-3.45-1.76a94.32,94.32,0,0,0-12.17-5.53,57.28,57.28,0,0,0-17-2.66,19,19,0,0,0,5-1.9,13.06,13.06,0,0,0,6.54-8.4.45.45,0,0,0-.35-.54.46.46,0,0,0-.55.36,12.13,12.13,0,0,1-6.09,7.77,21.88,21.88,0,0,1-10,2.5.43.43,0,0,0-.31.14h-3.91a4.89,4.89,0,0,1-3.07-.65,3.92,3.92,0,0,1-1.11-3.15c-.07-5.59,3.53-11.23,9-14,7.57-3.91,15.2-1.86,23.28.31,5.14,1.39,10.44,2.82,15.72,2.55,1.47-.07,3-.23,4.47-.39,4.83-.51,9.82-1.05,13.79,1.45a20.86,20.86,0,0,1,2.66,2.11c.63.56,1.28,1.14,2,1.65l.1.08c1.71,1.27,4,3,6.15,2.43l.05,0,3.11.23,0,.06c1,1.37,1.14,2.72,1.22,4.61.16,4,.14,8.16-1.1,12.09a14.5,14.5,0,0,1-7,8.84Zm85.1-21.13a.47.47,0,0,0-.12-.32c-.58-.62-.54-.69-.45-.9a2.59,2.59,0,0,0,.15-1.86.45.45,0,0,0-.54-.35.46.46,0,0,0-.36.54,1.71,1.71,0,0,1-.09,1.29c-.24.52-.24.89.35,1.61-9,.13-18-.08-26.93-.65-1.67-.1-3.42-.32-5.11-.52a52.57,52.57,0,0,0-9.16-.58,15.73,15.73,0,0,0-2,.29,11.25,11.25,0,0,1-2.05.29,24,24,0,0,1-2.8-.11,18.62,18.62,0,0,0,2.07-1.38l.21-.16c.69-.51,1.34-1.09,2-1.65a20.1,20.1,0,0,1,2.65-2.11c4-2.5,9-2,13.8-1.45,1.47.15,3,.32,4.47.39,5.27.26,10.58-1.17,15.72-2.55,8.08-2.17,15.71-4.23,23.28-.32,5.25,2.72,8.78,8.1,8.93,13.52a28.92,28.92,0,0,0-8.73-2.62,76.53,76.53,0,0,0-13-.44l-1.4,0Zm125.74-14.54a3.55,3.55,0,0,1-.55,1.36,3.18,3.18,0,0,1-.58.6c-1.42,1.18-2.68,1.27-4.58,1.28-1.75,0-3,.08-4.6.21a8.28,8.28,0,0,0-.07-2c-.18-1.39-1.37-1.87-2.33-2.24l-.36-.15a16.8,16.8,0,0,0-3.74-1.05,44.33,44.33,0,0,1-5.3-1.21,32.51,32.51,0,0,0-6.27-1.2.47.47,0,0,0-.51.41.46.46,0,0,0,.4.51,32.24,32.24,0,0,1,6.13,1.16,43.9,43.9,0,0,0,5.39,1.24,15.7,15.7,0,0,1,3.54,1l.38.15c1,.41,1.65.71,1.75,1.51.17,1.27.25,2.55-.66,3a2.64,2.64,0,0,1-1,.15,78.9,78.9,0,0,1-18.11-1.82c-2.57-.48-5.48-1-9.17-1.58-3-.43-5.46-1-7.89-1.56a68.13,68.13,0,0,0-10.46-1.81l-.13-.05-4-.63c-22-3.54-36.59-5.87-57.21-16-3.54-1.74-7.22-3.67-10-6.53-3.47-3.57-6.08-9.13-7.78-16.51l0,0c0-.45.07-.9.1-1.35.45-9.05-.81-18.32-2-27.28-.35-2.6-.72-5.28-1-7.89a37,37,0,0,1-.29-10c.56-3.59,2.2-7,3.78-10.24.55-1.12,1.09-2.24,1.59-3.37,2.65-5.93,3.16-10.73,1.57-14.68a.46.46,0,1,0-.85.34c1.48,3.71,1,8.27-1.56,14-.5,1.13-1,2.24-1.58,3.35a58,58,0,0,0-2.89,6.66l-.11.09-14,17-11.7-5.06a.33.33,0,0,0-.17,0l-4.06-.16a.45.45,0,0,0-.48.44.47.47,0,0,0,.44.48l4,.16,11.94,5.16a.41.41,0,0,0,.19,0,.46.46,0,0,0,.35-.17l13-15.76c-.13.55-.25,1.11-.34,1.67a37.56,37.56,0,0,0,.29,10.22c.31,2.62.68,5.3,1,7.9,1.22,8.92,2.48,18.15,2,27.11-.17,3.34-.59,6.72-1,10s-.83,6.7-1,10.08c-.08,1.49-.12,2.79-.13,4a.43.43,0,0,0-.35.05c-7.51,4.71-17.17,6.74-28.7,6-7.36-.45-14.72-1.94-21.85-3.37-2.54-.51-5.17-1-7.77-1.52-5.86-1.08-12.59-2-18.29.9-.77.39-1.51.85-2.22,1.29a23.15,23.15,0,0,1-2.8,1.55c-4.13,1.8-8.77,1-14-.12h0a45,45,0,0,0,.44-8.58c-.16-3.46-.59-6.94-1-10.3s-.83-6.65-1-10c-.45-9,.81-18.19,2-27.11.36-2.6.72-5.28,1-7.9a37.56,37.56,0,0,0,.29-10.22c-.11-.69-.26-1.36-.43-2l13.28,16.12a.48.48,0,0,0,.36.17.39.39,0,0,0,.18,0l12-5.16,4-.16a.46.46,0,0,0,0-.92l-4.07.16a.32.32,0,0,0-.16,0l-11.71,5.06L142.44,192a62.8,62.8,0,0,0-2.71-6.16c-.54-1.11-1.08-2.23-1.58-3.35-2.54-5.69-3.05-10.25-1.56-14a.46.46,0,1,0-.85-.34c-1.59,4-1.08,8.75,1.56,14.68.51,1.13,1,2.25,1.6,3.37.92,1.9,1.85,3.84,2.59,5.83a.43.43,0,0,0,.1.34l0,.05a21.62,21.62,0,0,1,1.05,4,36.62,36.62,0,0,1-.3,10c-.31,2.61-.68,5.29-1,7.89-1.23,9-2.49,18.23-2,27.28,0,.38.05.76.08,1.14a.53.53,0,0,0-.17.25c-1.69,7.39-4.31,12.94-7.77,16.51-2.77,2.86-6.45,4.79-10,6.53-20.62,10.15-35.18,12.48-57.22,16l-4,.63-.13.05a68.48,68.48,0,0,0-10.47,1.81c-2.42.55-4.92,1.13-7.88,1.56-3.69.55-6.6,1.1-9.18,1.58a78.75,78.75,0,0,1-18.1,1.82,2.64,2.64,0,0,1-1-.15,1.16,1.16,0,0,1-.59-.64.42.42,0,0,0-.06-.14,5.34,5.34,0,0,1,0-2.19c.1-.8.72-1.1,1.75-1.51l.37-.15a15.7,15.7,0,0,1,3.54-1,43.73,43.73,0,0,0,5.4-1.24A32.26,32.26,0,0,1,30,281.32a.46.46,0,0,0-.11-.92,32.69,32.69,0,0,0-6.27,1.2,43.84,43.84,0,0,1-5.3,1.21,16.7,16.7,0,0,0-3.73,1.05l-.36.15c-1,.37-2.15.85-2.33,2.24a8,8,0,0,0-.07,2c-1.64-.14-2.89-.22-4.61-.23H7a15,15,0,0,1-2.6-.16,4.35,4.35,0,0,1-3-2,3.15,3.15,0,0,1,.37-3.63,4.27,4.27,0,0,1,1.2-.95,3.85,3.85,0,0,1,1.28-.22h.24c.52,0,1-.1,1.51-.15a19.16,19.16,0,0,1,2.52-.18A78.57,78.57,0,0,0,19,280.22c2-.2,4-.41,6.66-.58a.48.48,0,0,0,.4-.28l.14,0a15.34,15.34,0,0,0,2.14-.84l.52-.23a30.05,30.05,0,0,1,5.5-1.82c.58-.13,1.16-.22,1.73-.31a12.38,12.38,0,0,0,3.74-1,30.76,30.76,0,0,0,4.52-2.94,29.7,29.7,0,0,1,4.41-2.86.46.46,0,0,0-.41-.83,31,31,0,0,0-4.54,2.95,31.19,31.19,0,0,1-4.39,2.86,11.69,11.69,0,0,1-3.47.91c-.59.09-1.19.19-1.8.33s-.94.22-1.4.35c.54-3,1.53-6.62,1.94-8.08a9.29,9.29,0,0,1,.45-1.35,4.43,4.43,0,0,1,.86-1.28.47.47,0,0,0,0-.66.48.48,0,0,0-.66,0,5.73,5.73,0,0,0-.85,1.21,7,7,0,0,0-2.66-2.29,12.2,12.2,0,0,0-3.77-1.11l-.29-.05c-1.08-.15-2.42-.35-3-1.05l0,0a9.58,9.58,0,0,0-.14-1,3.47,3.47,0,0,0-.54-1.37,1.77,1.77,0,0,0-1.49-.77,1.86,1.86,0,0,0-1.34.81,5.22,5.22,0,0,1,0-2.21c.4-.76,1.52-1,2.32-1.05a27,27,0,0,1,9.72.67,12.33,12.33,0,0,1,3.26,1.2,6.49,6.49,0,0,1,1,.74,7.42,7.42,0,0,0,1.19.9,20.55,20.55,0,0,0,6.09,2.23c.9.2,1.83.34,2.73.49a23,23,0,0,1,5.78,1.44c.73.33,1.44.74,2.13,1.13a22.72,22.72,0,0,0,2.07,1.12,15.09,15.09,0,0,0,6.17,1.31c.3,0,.59,0,.89,0a.43.43,0,0,0,.22.06h0a8.28,8.28,0,0,0,2.14-.42,11.29,11.29,0,0,0,1.91-.65.45.45,0,0,0,.24-.33l.84-.41,2.17-1c6.05-2.89,12.32-5.88,17.64-10,.78-.61,1.55-1.25,2.29-1.88,1.08-.91,2.19-1.85,3.36-2.65a42.69,42.69,0,0,1,5.26-2.82c4.26-2.05,8.94-4.3,11-8.09a.43.43,0,0,0,.28-.28c.06-.24.11-.47.17-.71a8.78,8.78,0,0,0,.53-2.62,71.27,71.27,0,0,0,.51-13,67.14,67.14,0,0,1,.63-13.74,70.21,70.21,0,0,1,3-10.37,60.18,60.18,0,0,0,3.41-12.78c.11-1,.28-2,.45-2.91a24.75,24.75,0,0,0,.55-5.81c-.07-1.28-.28-2.62-.48-3.92-.41-2.66-.84-5.41-.15-7.84a53.53,53.53,0,0,1,4.89-12.12A27.64,27.64,0,0,1,136,141.66c4-2.15,8.55-3,13.07-3.6a47.58,47.58,0,0,1,7.32.62c1.69.23,3.45.46,5.14.56.44,0,.89,0,1.32,0a19,19,0,0,0,11.25-3.49v1.38a.46.46,0,0,0,.46.46.45.45,0,0,0,.46-.46V118.6a22,22,0,0,0,15.13,6.55h.71a21.85,21.85,0,0,0,13.36-4.92v16.94a.45.45,0,0,0,.46.46.46.46,0,0,0,.46-.46v-2.33c4.24,4.06,10.69,4.65,16.5,4.68,2.2,0,4.45-.09,6.62-.19,2-.08,4-.17,6-.18a14.64,14.64,0,0,1,3.83.36l.12,0s.05,0,.08,0a25.05,25.05,0,0,1,16.1,13l.11.19.07.16s0,.06.07.09a54.29,54.29,0,0,1,4.64,11.68c.7,2.43.27,5.18-.14,7.84-.2,1.3-.41,2.64-.49,3.92a25.43,25.43,0,0,0,.56,5.82c.17,1,.34,1.92.45,2.9a59,59,0,0,0,3.41,12.78,71.81,71.81,0,0,1,3,10.37,67.13,67.13,0,0,1,.62,13.74,72.17,72.17,0,0,0,.51,13,8.71,8.71,0,0,0,.54,2.61c.06.24.1.48.17.72a.43.43,0,0,0,.28.28c2,3.79,6.7,6,11,8.09a42.5,42.5,0,0,1,5.25,2.82,41.19,41.19,0,0,1,3.36,2.65c.75.62,1.51,1.27,2.3,1.88,5.32,4.08,11.58,7.07,17.64,10l2.17,1a32.49,32.49,0,0,0,3,1.32,11.43,11.43,0,0,0,3.05.7h0a.45.45,0,0,0,.19-.05h.18a14.32,14.32,0,0,0,5.94-1.5c.72-.33,1.41-.73,2.08-1.12s1.4-.8,2.13-1.13a22.89,22.89,0,0,1,5.78-1.44c.9-.15,1.82-.29,2.73-.49a19.31,19.31,0,0,0,7.29-3c.44-.3.85-.58,1.29-.82,2-1.09,4.28-1.17,6.71-1.24.91,0,1.84-.06,2.75-.15l.81-.09a8.14,8.14,0,0,1,3.66.11,2,2,0,0,1,1.18.95,1.39,1.39,0,0,1-.58,1.29,1.59,1.59,0,0,0-.9-.35,1.81,1.81,0,0,0-1.49.77,3.44,3.44,0,0,0-.53,1.37c-.05.2-.07.39-.1.58a.58.58,0,0,0-.12.1,5.77,5.77,0,0,1-3.23,1.46,12.35,12.35,0,0,0-3.78,1.11,6.94,6.94,0,0,0-2.65,2.29,5.43,5.43,0,0,0-.86-1.21.46.46,0,1,0-.66.64,4.64,4.64,0,0,1,.86,1.28,10.68,10.68,0,0,1,.45,1.35c.64,2.26,1.45,5.48,1.92,8.07-.46-.12-.92-.24-1.39-.34s-1.21-.24-1.79-.33a11.69,11.69,0,0,1-3.47-.91,31.19,31.19,0,0,1-4.39-2.86,31.11,31.11,0,0,0-4.55-2.95.46.46,0,0,0-.4.83,29.61,29.61,0,0,1,4.4,2.86,31.4,31.4,0,0,0,4.53,2.94,12.31,12.31,0,0,0,3.74,1c.57.09,1.15.18,1.73.31a30.05,30.05,0,0,1,5.5,1.82l.52.23c.55.25,1.12.49,1.71.69a.47.47,0,0,0,.42.41c2.65.16,4.78.38,6.84.6a86.14,86.14,0,0,0,10.65.62h.28a13,13,0,0,1,1.74.14,12.83,12.83,0,0,0,1.86.14,3.58,3.58,0,0,1,2.54.65C378.7,282.51,378.73,283.49,378.42,284.82Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.12,268.61a9.16,9.16,0,0,0-6.28,3,.47.47,0,0,0,0,.66.51.51,0,0,0,.31.11.46.46,0,0,0,.34-.15,8.2,8.2,0,0,1,5.64-2.71.46.46,0,0,0,.43-.49A.42.42,0,0,0,324.12,268.61Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8,243.46a8.38,8.38,0,0,0-6.63,4.84.45.45,0,0,0,.23.6.43.43,0,0,0,.19,0,.45.45,0,0,0,.42-.27,7.47,7.47,0,0,1,5.89-4.3.46.46,0,0,0,.41-.51A.46.46,0,0,0,262.8,243.46Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,222.7a.46.46,0,0,0-.46.46v33.2a.45.45,0,0,0,.46.46.46.46,0,0,0,.46-.46v-33.2A.47.47,0,0,0,191,222.7Z",
    style: {
      fill: "url(#Degradado_sin_nombre_7-26)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Chakras"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/Ajna"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ajna",
    className: "chakraAnimated"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.12,84.78a8.33,8.33,0,0,0,2.17-1.14c2-1.57,2.8-4.45,5-5.68h0c-2.23-1.23-3-4.11-5-5.68a8.33,8.33,0,0,0-2.17-1.14,6.82,6.82,0,0,0-4.94-.2,5.4,5.4,0,0,0-2.8,3.21,9.79,9.79,0,0,0-.44,3.81,9.86,9.86,0,0,0,.44,3.82,5.41,5.41,0,0,0,2.8,3.2A6.82,6.82,0,0,0,205.12,84.78Z",
    style: {
      fill: "#5b26a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.25,85.27a8.4,8.4,0,0,0,3.31-2.15c.9-1,2.56-4.6,3.77-4.64a.52.52,0,0,0,.26-1h0v.9h0a.52.52,0,0,0-.26-1c-1.39,0-3-3.89-4.05-5a8.71,8.71,0,0,0-4-2.14c-3-.76-5.84.18-7.17,3.14a12,12,0,0,0,.18,9.36c1.67,3.17,4.84,3.42,8,2.43.63-.2.36-1.19-.27-1-5.14,1.63-7.5-1.74-7.52-6.32s2.36-8.22,7.52-6.32c2.64,1,3.46,3,5.13,5,.48.58,1.38,1.79,2.22,1.82l-.26-1h0a.53.53,0,0,0,0,.9h0l.26-1c-.79,0-1.81,1.32-2.22,1.82-1.66,2-2.56,4-5.13,5C204.37,84.52,204.64,85.52,205.25,85.27Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.75,71c2.53,1.92,4.48,4.71,3.83,8a9.84,9.84,0,0,1-4.22,5.81c-.25.17,0,.57.24.4,5.75-3.85,5.82-10.53.38-14.66-.24-.18-.47.23-.23.41Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.14,78.38h0a.36.36,0,0,0,0-.71h0a.36.36,0,0,0,0,.71Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.48,71.14a8.33,8.33,0,0,0-2.17,1.14c-2,1.57-2.8,4.45-5,5.68h0c2.24,1.23,3,4.11,5,5.68a8.33,8.33,0,0,0,2.17,1.14,6.82,6.82,0,0,0,4.94.2,5.37,5.37,0,0,0,2.79-3.2,9.67,9.67,0,0,0,.44-3.82,9.6,9.6,0,0,0-.44-3.81,5.36,5.36,0,0,0-2.79-3.21A6.82,6.82,0,0,0,178.48,71.14Z",
    style: {
      fill: "#5b26a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.34,70.65A8.55,8.55,0,0,0,175,72.8c-.89,1-2.55,4.6-3.76,4.64a.52.52,0,0,0-.26,1h0v-.9h0a.52.52,0,0,0,.26,1c1.38,0,3,3.89,4,5a8.75,8.75,0,0,0,4,2.14c3,.76,5.84-.18,7.16-3.14a12,12,0,0,0-.17-9.36c-1.68-3.17-4.84-3.42-8-2.43-.63.2-.36,1.19.28,1,5.14-1.63,7.5,1.74,7.52,6.32s-2.36,8.22-7.52,6.32c-2.64-1-3.47-3-5.13-5-.48-.58-1.38-1.79-2.22-1.82l.26,1h0a.52.52,0,0,0,0-.9h0l-.26,1c.79,0,1.81-1.32,2.22-1.82,1.65-2,2.55-4,5.13-5C179.23,71.4,179,70.4,178.34,70.65Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,84.9c-2.53-1.92-4.48-4.71-3.84-8a9.88,9.88,0,0,1,4.22-5.81c.25-.17,0-.57-.23-.4-5.75,3.85-5.83,10.53-.39,14.66.25.18.48-.23.24-.41Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.46,77.54h0a.36.36,0,0,0,0,.71h0a.36.36,0,0,0,0-.71Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.05,
    cy: 77.68,
    r: 12.95,
    style: {
      fill: "#763ffc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.09 71.34 203.01 71.34 192.03 90.64 181.09 71.34",
    style: {
      fill: "none",
      stroke: "#451a89",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.86921px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.05,90.19c-6.77-.34-12.52-5.46-12.52-12.51a12.68,12.68,0,0,1,12.52-12.52,12.55,12.55,0,0,1,12.39,11.27c.73,7.53-5.05,13.39-12.39,13.76-.57,0-.57.91,0,.88,7.28-.37,13.39-5.83,13.39-13.39a13.4,13.4,0,1,0-26.79,0c0,7.56,6.12,13,13.4,13.39C192.61,91.1,192.61,90.22,192.05,90.19Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.05,70.47a1.17,1.17,0,0,0,0-2.34,1.17,1.17,0,0,0,0,2.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.86,72.44a7.29,7.29,0,0,0,8.38,0c1.23-.86.06-2.89-1.19-2a5,5,0,0,1-6,0c-1.25-.86-2.43,1.17-1.19,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.32,78.13c2.26-1.9,3.61,1.23,2,1.67-.88.24-1.25,1.73-.28,2.14,2.21,1,1.51,3.42-.67,3.62-2,.18-2.9-1.44-2.82-3.24.07-1.51-2.28-1.5-2.35,0-.17,4,3.29,6.79,7.14,5.16a4.11,4.11,0,0,0-.11-7.56L194,82.06c2.4-.66,3-3.53,1.8-5.57-1.49-2.47-4.32-1.54-6.12,0-1.15,1,.51,2.62,1.66,1.66Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("a", {
    href: "/Vishuddha"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vishuddha",
    className: "chakraAnimated"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.84,108.64a6.7,6.7,0,0,0,.66-2c.31-2.16-.91-4.4-.26-6.47h0c-2.1.57-4.29-.74-6.45-.52a7,7,0,0,0-2,.59,5.81,5.81,0,0,0-3.16,2.8,4.64,4.64,0,0,0,.18,3.63,14.47,14.47,0,0,0,4.52,4.69,4.58,4.58,0,0,0,3.62.31A5.72,5.72,0,0,0,206.84,108.64Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.22,108.87a7.42,7.42,0,0,0,.77-3c0-1.23-1.22-4.55-.44-5.35a.45.45,0,0,0-.43-.74h0l.54.54h0a.44.44,0,0,0-.73-.43c-.85.78-4.82-.78-6.21-.63a8.05,8.05,0,0,0-4,1.76,4.81,4.81,0,0,0-1.27,5.91,10.4,10.4,0,0,0,5.47,5.18c2.91,1,5-.77,6.34-3.22.27-.5-.49-1-.76-.45-1.9,3.57-5.12,3.73-7.92,1-2.17-2.06-4.18-5.12-1.34-7.71,2.3-2.1,4.75-1.5,7.52-1.12.66.09,2.24.4,2.83-.15l-.74-.42h0a.45.45,0,0,0,.54.54h0l-.43-.74c-.47.48-.33,1.73-.29,2.31.15,2.22.8,4-.18,6.24C206.23,108.94,207,109.38,207.22,108.87Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.19,101.59c2.34-.29,4.93,0,6.6,1.89s1.91,4.58,1.41,6.85c0,.25.33.36.39.11.48-2.22.28-5-1.19-6.87-1.74-2.18-4.57-2.7-7.21-2.38-.25,0-.26.44,0,.4Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.15,101.73h0c.28-.27-.15-.69-.42-.43l0,0c-.28.27.15.69.43.42Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.49,131.21a6.55,6.55,0,0,0,1.94.79c2.13.46,4.44-.61,6.47.17h0c-.42-2.13,1-4.23.95-6.41a6.85,6.85,0,0,0-.45-2,5.8,5.8,0,0,0-2.58-3.34,4.62,4.62,0,0,0-3.63-.06,8.41,8.41,0,0,0-2.74,1.8,8.53,8.53,0,0,0-2.25,2.39,4.62,4.62,0,0,0-.56,3.58A5.79,5.79,0,0,0,197.49,131.21Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.27,131.59a7.42,7.42,0,0,0,3,1c1,.08,4.65-.86,5.36-.06.33.36.8,0,.74-.43h0l-.54.54h0c.46.15.67-.42.43-.74-.62-.78.95-4.29,1-5.31a7.27,7.27,0,0,0-.76-3.72c-1.08-2.31-3.12-3.73-5.71-3.15a10.11,10.11,0,0,0-6.35,5.38c-1.14,2.84.47,5.06,2.83,6.53.48.3.92-.46.44-.76-3.85-2.4-3-5.82.06-8.39,2.88-2.43,6.67-2.84,8.2,1.4.82,2.26,0,3.93-.42,6.09-.13.71-.44,1.94,0,2.56l.42-.74h0a.44.44,0,0,0-.54.54h0l.74-.42c-.43-.49-1.74-.42-2.29-.42-2.32,0-4,.57-6.22-.62C197.21,130.56,196.77,131.32,197.27,131.59Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.17,122.07c.15,2.53-.5,5.34-2.79,6.8a8.38,8.38,0,0,1-6.48.59.2.2,0,0,0-.1.38c2.32.67,5.28.61,7.24-1s2.68-4.28,2.54-6.81c0-.26-.42-.26-.41,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.45,131h0c.25.3.67-.13.43-.42l0,0c-.25-.29-.67.13-.42.43Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.23,122.69a7.15,7.15,0,0,0,1.93-.82c1.81-1.19,2.68-3.6,4.67-4.48h0c-1.82-1.19-2.29-3.7-3.89-5.18a6.82,6.82,0,0,0-1.78-1.11,5.78,5.78,0,0,0-4.18-.52,4.63,4.63,0,0,0-2.6,2.54,8.41,8.41,0,0,0-.64,3.22,8.18,8.18,0,0,0,.12,3.27,4.53,4.53,0,0,0,2.15,2.92A5.79,5.79,0,0,0,205.23,122.69Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.34,123.11a7.11,7.11,0,0,0,3-1.62c.69-.66,2.52-3.71,3.53-3.66.49,0,.54-.58.22-.82h0v.76h0c.42-.22.17-.78-.23-.82-1-.11-2.3-3.57-3-4.43a6.83,6.83,0,0,0-2.53-1.85c-2.52-1.14-5.36-1-6.93,1.57a10.17,10.17,0,0,0-.63,8.3c1.23,2.78,3.88,3.21,6.62,2.58.56-.13.32-1-.23-.85-4.39,1-6.25-2.05-5.93-5.93.35-4.1,3.17-7,7.39-4.55,2,1.17,2.44,3.18,3.84,4.86.34.4.84,1.12,1.42,1.18l-.22-.82h0a.45.45,0,0,0,0,.76h0l.22-.82c-.64,0-1.65,1-2,1.42-1.53,1.59-2.45,3.18-4.72,3.89C204.57,122.43,204.8,123.28,205.34,123.11Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.13,110.8c2,1.78,3.56,4.33,2.79,7.13a8.65,8.65,0,0,1-4,4.66c-.23.12,0,.47.2.34,5.14-2.87,5.68-8.55,1.34-12.42-.19-.17-.47.11-.28.29Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,117.59h0c.38,0,.38-.57,0-.6h0c-.39,0-.39.57,0,.6Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,130.75a6.57,6.57,0,0,0,1.72,1.2c2,.91,4.47.38,6.28,1.59h0c.05-2.17,1.93-3.9,2.33-6a6.66,6.66,0,0,0,0-2.09,5.75,5.75,0,0,0-1.78-3.83,4.6,4.6,0,0,0-3.53-.86,14.28,14.28,0,0,0-5.78,3,4.61,4.61,0,0,0-1.34,3.38A5.75,5.75,0,0,0,193,130.75Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.67,131.06a7.18,7.18,0,0,0,2.94,1.66c1.14.3,4.45.07,5,1.05a.44.44,0,0,0,.82-.22h0l-.66.38h0a.45.45,0,0,0,.6-.61c-.49-1,1.83-3.83,2.19-5a7.44,7.44,0,0,0,.08-3.75c-.58-2.66-2.4-4.48-5.24-4.32a10.11,10.11,0,0,0-7.21,4.14c-1.48,2.48-.39,4.81,1.49,6.67.41.4,1-.22.62-.62-3.13-3.1-1.75-6.36,1.88-8.18,3.07-1.54,6.7-1.66,7.61,2.55.55,2.58-.69,4.24-1.64,6.45-.25.57-.86,1.85-.54,2.51l.6-.6h0a.44.44,0,0,0-.66.38h0l.82-.22c-.31-.57-1.75-.85-2.26-1-2.16-.48-4-.38-5.81-1.93C192.87,130.07,192.24,130.69,192.67,131.06Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.49,123.52c-.38,2.29-1.38,4.55-3.53,5.71s-5.05.61-7.13-.53c-.23-.13-.43.22-.21.34,5.16,2.84,10.3.32,11.26-5.42,0-.25-.34-.36-.39-.1Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.81,132.07h0c.18.35.7,0,.52-.3v0c-.18-.34-.7,0-.52.31Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.72,128.44a6.69,6.69,0,0,0,2.08.28c2.17-.1,4.14-1.73,6.3-1.48h0c-.95-2-.08-4.36-.71-6.44a6.84,6.84,0,0,0-1-1.86,5.77,5.77,0,0,0-3.34-2.58,4.63,4.63,0,0,0-3.53.86,8.26,8.26,0,0,0-2.18,2.45,8.15,8.15,0,0,0-1.57,2.87,4.61,4.61,0,0,0,.37,3.62A5.73,5.73,0,0,0,199.72,128.44Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6,128.87a7,7,0,0,0,3.38.1c1-.21,4.08-1.88,4.9-1.35.3.2.8-.14.65-.5h0l-.43.56h0c.48,0,.53-.59.22-.82-.8-.61-.16-4.35-.35-5.38a7.34,7.34,0,0,0-1.67-3.44c-1.75-2.09-4.22-2.85-6.65-1.39a10.13,10.13,0,0,0-4.47,7c-.16,2.89,1.89,4.44,4.41,5.22.55.17.78-.68.24-.85-3.82-1.18-4.53-4.23-2.58-7.47s5.44-5.39,8.37-1.91c1.74,2.07,1.38,4.18,1.58,6.65.06.72.06,1.86.67,2.33l.23-.82h0a.44.44,0,0,0-.42.56h0l.65-.5c-.55-.36-1.87,0-2.46.21-2.12.59-3.72,1.49-6,1C199.29,127.89,199.05,128.74,199.6,128.87Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,117.65c.78,2.41.86,5.3-1,7.29a8.39,8.39,0,0,1-6.12,2.21.2.2,0,0,0,0,.4c2.42.06,5.26-.75,6.76-2.77s1.5-4.82.72-7.24c-.08-.24-.47-.13-.39.11Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4,126.47h0c.32.22.62-.3.31-.52h0c-.32-.22-.62.3-.3.52Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.44,106.38a6.66,6.66,0,0,0,0-2.09c-.37-2.15-2.23-3.9-2.25-6.08h0c-1.83,1.19-4.32.62-6.3,1.51a6.55,6.55,0,0,0-1.73,1.18,5.71,5.71,0,0,0-2.14,3.63,4.61,4.61,0,0,0,1.29,3.4,8.26,8.26,0,0,0,2.69,1.86,8.37,8.37,0,0,0,3,1.21,4.67,4.67,0,0,0,3.54-.82A5.75,5.75,0,0,0,203.44,106.38Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.88,106.38a7.09,7.09,0,0,0-.43-3.59c-.34-.87-2.26-3.55-1.86-4.36a.44.44,0,0,0-.6-.6h0l.66.38h0a.44.44,0,0,0-.82-.22c-.62,1.05-4.14.68-5.36,1.06a7.26,7.26,0,0,0-3.13,2c-1.77,1.87-2.35,4.29-.83,6.52a10.06,10.06,0,0,0,7.68,3.86c2.89-.16,4.21-2.36,4.68-5,.09-.56-.75-.79-.85-.24-.32,1.76-.84,3.51-2.84,4.17-1.76.59-3.42-.22-4.94-1-3.07-1.6-5.13-4.67-2.28-7.7,1.66-1.76,3.43-1.91,5.64-2.25.74-.11,2.53-.24,3-1l-.82-.22h0a.44.44,0,0,0,.66.38h0l-.6-.6c-.32.64.26,1.9.49,2.46.84,2.06,1.93,3.58,1.68,5.93C202.94,106.94,203.82,106.94,203.88,106.38Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.12,102.64c5.06-2.33,9.73.33,10.29,5.84,0,.26.42.26.4,0-.6-5.88-5.55-8.65-10.89-6.19-.23.11,0,.45.2.35Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,100h0c.18-.34-.34-.65-.52-.31v0c-.18.34.34.65.52.3Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.67,113.51a6.7,6.7,0,0,0,1.07-1.8c.77-2,0-4.49,1.13-6.37h0c-2.17.11-4-1.64-6.2-1.88a6.68,6.68,0,0,0-2.09.14,5.79,5.79,0,0,0-3.68,2.06,4.58,4.58,0,0,0-.6,3.58,8.39,8.39,0,0,0,1.38,3,8.36,8.36,0,0,0,2,2.58,4.62,4.62,0,0,0,3.47,1.08A5.75,5.75,0,0,0,206.67,113.51Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.05,113.73a7,7,0,0,0,1.4-3.09c.19-1-.12-4.43.65-4.93a.45.45,0,0,0-.23-.82h0l.38.66h0a.44.44,0,0,0-.6-.6c-1.06.59-3.91-1.5-5.15-1.79a7.42,7.42,0,0,0-3.74.18c-2.48.72-4.19,2.51-4,5.21a10,10,0,0,0,4.67,7.21c2.57,1.32,4.83.08,6.55-1.94.37-.43-.25-1-.62-.62-1.16,1.36-2.49,2.6-4.55,2.16C200,115,199,113.44,198.06,112c-1.79-2.94-2.11-6.61,1.93-7.79,2.32-.68,3.92.08,6,.9.71.29,2.31,1.07,3.11.62l-.6-.6h0a.44.44,0,0,0,.38.66h0l-.22-.82c-.45.3-.65,1.41-.74,1.89-.44,2.32-.12,4.42-1.62,6.45C206,113.74,206.72,114.18,207.05,113.73Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,104.56c5.48.51,8.25,5.15,5.91,10.24-.1.23.24.44.35.2,2.47-5.39-.44-10.3-6.26-10.84-.26,0-.26.38,0,.4Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.46,106.62h0c.33-.21,0-.73-.3-.52h0c-.33.2,0,.72.3.52Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.66,100.36a6.7,6.7,0,0,0-2-.66c-2.16-.31-4.4.93-6.47.28h0c.58,2.1-.72,4.3-.49,6.46a6.74,6.74,0,0,0,.59,2,5.78,5.78,0,0,0,2.81,3.15,4.57,4.57,0,0,0,3.62-.19,14,14,0,0,0,4.68-4.53,4.58,4.58,0,0,0,.31-3.62A5.76,5.76,0,0,0,184.66,100.36Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.89,100a7.63,7.63,0,0,0-3-.77c-1.24,0-4.52,1.23-5.35.46a.44.44,0,0,0-.73.43h0l.54-.54h0a.44.44,0,0,0-.43.73c.78.86-.77,4.82-.61,6.21a8,8,0,0,0,1.77,4,4.81,4.81,0,0,0,5.91,1.26,10.48,10.48,0,0,0,5.17-5.48c1-2.91-.79-5-3.24-6.33-.5-.27-.95.49-.45.76,3.57,1.89,3.74,5.1,1.07,7.92-2,2.17-5.11,4.19-7.71,1.35-2.1-2.29-1.51-4.74-1.14-7.51.09-.66.39-2.24-.15-2.83l-.43.73h0a.45.45,0,0,0,.54-.55h0l-.74.43c.49.46,1.72.32,2.3.28,2.22-.15,4.05-.81,6.25.17C185,101,185.4,100.21,184.89,100Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.64,110c-.3-2.34,0-4.93,1.86-6.61s4.58-1.92,6.86-1.43c.25.05.35-.33.1-.39-2.22-.47-5-.27-6.86,1.21-2.18,1.75-2.7,4.57-2.36,7.22,0,.25.43.25.4,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.75,101.07v0c-.27-.27-.7.15-.43.43h0c.27.28.69-.14.42-.42Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.78,123.26a6.83,6.83,0,0,0-.56,2c-.19,2.17,1.15,4.34.62,6.45h0c2.06-.68,4.32.51,6.47.16a6.76,6.76,0,0,0,2-.69,5.78,5.78,0,0,0,3-3,4.61,4.61,0,0,0-.37-3.61,14.37,14.37,0,0,0-4.77-4.45,4.56,4.56,0,0,0-3.62-.12A5.73,5.73,0,0,0,176.78,123.26Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.35,123.14a7,7,0,0,0-.53,3.36c.11,1.06,1.3,4.24.7,4.92a.45.45,0,0,0,.43.74h0l-.54-.55h0a.44.44,0,0,0,.74.42c.8-.8,4.85.49,6.16.29a7.84,7.84,0,0,0,3.44-1.51,4.79,4.79,0,0,0,1.7-6.07,10.19,10.19,0,0,0-6.25-5.32c-2.83-.59-4.68,1.2-5.8,3.61-.24.51.52,1,.76.44,3.83-8.21,14.14,1.88,9.62,6.19-2.31,2.2-4.63,1.68-7.44,1.48-.65-.05-2.25-.3-2.82.27l.74.43h0a.44.44,0,0,0-.54-.54h0l.42.73c.37-.41.27-1.53.22-2-.2-2.35-1.06-4.28-.16-6.64C177.41,122.85,176.56,122.62,176.35,123.14Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.75,129.79c-2.42.43-5,.14-6.83-1.69-1.59-1.63-1.95-4.43-1.6-6.6,0-.25-.35-.36-.39-.11-.37,2.33,0,5.23,1.71,7,1.89,2,4.66,2.26,7.22,1.8.25-.05.14-.43-.11-.39Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.85,130.12h0c-.27.28.16.71.42.43l0,0c.26-.28-.16-.71-.43-.42Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.78,122.69a6.89,6.89,0,0,1-1.93-.82c-1.82-1.19-2.69-3.6-4.68-4.48h0c1.82-1.19,2.29-3.7,3.9-5.18a6.61,6.61,0,0,1,1.77-1.11,5.81,5.81,0,0,1,4.19-.52,4.61,4.61,0,0,1,2.59,2.54,8.41,8.41,0,0,1,.64,3.22,8.36,8.36,0,0,1-.11,3.27,4.58,4.58,0,0,1-2.16,2.92A5.76,5.76,0,0,1,177.78,122.69Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.89,122.26c-2.3-.72-3.16-2.3-4.71-3.89-.39-.41-1.36-1.45-2-1.42l.22.82h0a.44.44,0,0,0,0-.76h0l-.22.82c.59-.06,1.07-.76,1.42-1.18,1.4-1.67,1.82-3.69,3.84-4.86a6,6,0,0,1,5-.52c1.9.79,2.2,3.36,2.34,5.07.32,3.92-1.54,6.94-5.93,5.93-.55-.12-.78.72-.23.85,2.72.63,5.4.21,6.63-2.58a10.09,10.09,0,0,0-.64-8.3c-1.6-2.52-4.37-2.72-6.93-1.57a7,7,0,0,0-2.53,1.85c-.68.8-2,4.33-3,4.43-.4,0-.65.6-.22.82h0V117h0c-.32.24-.26.84.22.82,1,0,2.9,3.06,3.53,3.66a7.11,7.11,0,0,0,3,1.62C178.2,123.28,178.43,122.43,177.89,122.26Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.59,110.51c-4.33,3.87-3.79,9.55,1.35,12.42.22.13.42-.22.2-.34a8.7,8.7,0,0,1-4.06-4.66c-.76-2.77.8-5.36,2.79-7.13.2-.18-.09-.46-.28-.29Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,117h0c-.39,0-.39.63,0,.6h0c.38,0,.38-.63,0-.6Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,130.75a6.69,6.69,0,0,1-1.71,1.2c-2,.91-4.48.38-6.28,1.59h0c-.05-2.17-1.93-3.9-2.33-6a6.66,6.66,0,0,1,0-2.09,5.84,5.84,0,0,1,1.78-3.83,4.61,4.61,0,0,1,3.53-.86,8.37,8.37,0,0,1,3.07,1.16,8.52,8.52,0,0,1,2.72,1.83,4.6,4.6,0,0,1,1.33,3.38A5.75,5.75,0,0,1,190,130.75Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.71,130.44c-1.81,1.55-3.65,1.47-5.81,1.93-.54.12-2,.39-2.26,1l.82.22h0a.44.44,0,0,0-.66-.38h0l.6.6c.31-.67-.28-1.93-.53-2.51-1-2.19-2.19-3.9-1.64-6.45.91-4.25,4.53-4.09,7.6-2.55,3.63,1.83,5,5.08,1.88,8.18-.41.4.22,1,.62.62,1.77-1.74,2.91-3.92,1.69-6.35s-4.78-4.3-7.4-4.46a4.83,4.83,0,0,0-5.15,4,7.45,7.45,0,0,0-.11,3.75c.32,1.25,2.76,4.33,2.28,5.35-.17.38.2.85.6.61h0l-.67-.38h0a.44.44,0,0,0,.82.22c.51-.93,4-.79,5-1.05a7,7,0,0,0,2.94-1.66C190.76,130.69,190.14,130.07,189.71,130.44Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.12,123.62c1,5.73,6.1,8.26,11.26,5.42.22-.12,0-.47-.2-.34-2.09,1.14-5,1.71-7.14.53s-3.15-3.42-3.53-5.71c0-.26-.43-.15-.39.1Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,131.76v0c-.17.34.34.65.52.3h0c.18-.35-.34-.65-.52-.31Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.28,128.44a6.63,6.63,0,0,1-2.07.28c-2.18-.1-4.15-1.73-6.31-1.48h0c1-2,.08-4.36.72-6.44a6.54,6.54,0,0,1,.95-1.86,5.76,5.76,0,0,1,3.35-2.58,4.61,4.61,0,0,1,3.52.86,14.36,14.36,0,0,1,3.76,5.32,4.65,4.65,0,0,1-.37,3.62A5.75,5.75,0,0,1,183.28,128.44Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.16,128c-2.34.55-3.89-.37-6-1-.64-.18-1.88-.58-2.45-.21l.6.6h0c.12-.27,0-.69-.38-.66h0l.31.75c.59-.46.57-1.94.61-2.66.15-2.63-.06-4.72,2-6.77,5-5,14.1,7.2,5.36,9.9-.53.17-.3,1,.24.85,2.36-.73,4.39-2.13,4.44-4.84s-2.26-6-4.5-7.38a4.83,4.83,0,0,0-6.4,1.12,7.64,7.64,0,0,0-1.84,3.31c-.29,1.26.47,5.08-.52,5.85a.45.45,0,0,0,.32.75h0l-.38-.66h0c-.17.36.2.86.6.6.83-.54,4,1.15,4.9,1.35a7,7,0,0,0,3.38-.1C184,128.74,183.72,127.89,183.16,128Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.79,117.54c-.78,2.42-.87,5.11.71,7.24s4.35,2.83,6.76,2.77a.2.2,0,0,0,0-.4,8.45,8.45,0,0,1-6.12-2.21c-1.83-2-1.74-4.88-1-7.29.08-.24-.3-.35-.38-.11Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3,126h0c-.32.22,0,.74.3.52h0c.31-.22,0-.74-.31-.52Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.56,106.38a6.66,6.66,0,0,1,0-2.09c.37-2.15,2.23-3.9,2.25-6.08h0c1.82,1.19,4.31.62,6.3,1.51a6.72,6.72,0,0,1,1.73,1.18,5.8,5.8,0,0,1,2.14,3.63,4.61,4.61,0,0,1-1.29,3.4,8.41,8.41,0,0,1-2.7,1.86,8.31,8.31,0,0,1-3,1.21,4.67,4.67,0,0,1-3.54-.82A5.75,5.75,0,0,1,179.56,106.38Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,106.38c-.25-2.35.84-3.87,1.69-5.93.23-.58.8-1.81.48-2.46l-.6.6h0a.45.45,0,0,0,.67-.38h0l-.82.22c.44.79,2.25.92,3,1,2.23.35,4,.49,5.64,2.25,2.86,3,.78,6.11-2.28,7.7-1.52.79-3.17,1.61-4.94,1-2-.66-2.52-2.41-2.83-4.17-.1-.55-1-.32-.85.24.44,2.46,1.6,4.6,4.29,5s6.53-1.62,8.06-3.84a4.84,4.84,0,0,0-.59-6.25,7.58,7.58,0,0,0-3-2.19c-1.2-.44-5.12-.15-5.69-1.18a.44.44,0,0,0-.82.22h0l.66-.38h0a.45.45,0,0,0-.61.6c.42.89-1.52,3.49-1.86,4.36a7.08,7.08,0,0,0-.43,3.59C179.18,106.94,180.06,106.94,180,106.38Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.08,102.29c-5.34-2.46-10.29.31-10.88,6.19,0,.26.37.26.4,0,.55-5.51,5.23-8.17,10.28-5.84.23.1.44-.24.2-.35Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.88,99.73v0c-.18-.34-.7,0-.52.31h0c.19.35.71,0,.52-.3Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.33,113.51a7,7,0,0,1-1.07-1.8c-.76-2,0-4.49-1.13-6.37h0c2.18.11,4-1.64,6.2-1.88a6.68,6.68,0,0,1,2.09.14,5.77,5.77,0,0,1,3.68,2.06,4.58,4.58,0,0,1,.61,3.58,8.59,8.59,0,0,1-1.39,3,8.36,8.36,0,0,1-2,2.58,4.6,4.6,0,0,1-3.47,1.08A5.78,5.78,0,0,1,176.33,113.51Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.71,113.29c-1.52-2.06-1.16-4.12-1.61-6.45-.11-.54-.26-1.56-.75-1.89l-.22.82h0a.44.44,0,0,0,.38-.66h0l-.6.6c.8.45,2.4-.34,3.11-.62,2.09-.82,3.67-1.58,6-.9,4.08,1.19,3.74,4.86,1.93,7.79-.9,1.46-1.94,3-3.75,3.38-2.06.44-3.39-.8-4.55-2.16-.36-.43-1,.19-.62.62,1.63,1.91,3.71,3.17,6.22,2.11s4.81-4.7,5-7.38a4.85,4.85,0,0,0-3.65-5.1,7.53,7.53,0,0,0-3.73-.36c-1.28.24-4.46,2.45-5.51,1.86a.44.44,0,0,0-.6.6h0l.38-.66h0a.44.44,0,0,0-.22.82c.77.52.47,3.93.64,4.93a7,7,0,0,0,1.4,3.09C176.29,114.18,177.05,113.74,176.71,113.29Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.21,104.16c-5.83.54-8.74,5.45-6.27,10.84.11.24.46,0,.35-.2-2.33-5.09.43-9.73,5.92-10.24.25,0,.25-.42,0-.4Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.84,106.1h0c-.33-.21-.64.31-.31.52h0c.33.2.63-.32.3-.52Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.68,129.6a7.1,7.1,0,0,0,1,1.85c1.34,1.72,3.81,2.39,4.85,4.3h0c1.05-1.91,3.51-2.58,4.85-4.3a6.81,6.81,0,0,0,1-1.85,5.77,5.77,0,0,0,.18-4.22,4.62,4.62,0,0,0-2.74-2.38,14.13,14.13,0,0,0-6.51,0,4.59,4.59,0,0,0-2.74,2.38A5.82,5.82,0,0,0,185.68,129.6Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.26,129.71a7.2,7.2,0,0,0,1.84,2.83c.85.77,3.92,2.17,4,3.21a.45.45,0,0,0,.82.23h-.76a.45.45,0,0,0,.82-.23c0-1.16,3.34-2.54,4.24-3.45a7.4,7.4,0,0,0,1.83-3.42c.65-2.58-.15-5-2.68-6.11a10.21,10.21,0,0,0-8,.14c-2.71,1.43-2.92,4.14-2.08,6.8.17.54,1,.31.85-.23-1.39-4.39,1.48-6.41,5.39-6.42s7,2,5.4,6.42c-.83,2.25-2.58,3-4.28,4.38-.49.4-1.54,1.18-1.56,1.89l.82-.22h0a.44.44,0,0,0-.76,0h0l.82.22c0-.67-1.13-1.54-1.55-1.89-1.69-1.41-3.39-2.18-4.28-4.38C185.9,129,185.05,129.19,185.26,129.71Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.43,127.57c-1.64,2.17-4,3.83-6.86,3.28a8.42,8.42,0,0,1-5-3.6c-.14-.22-.49,0-.34.2,3.29,4.91,9,5,12.51.33.16-.21-.19-.41-.34-.21Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.15,133.89v0a.3.3,0,0,0,.6,0v0a.3.3,0,0,0-.6,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,102a6.67,6.67,0,0,0-1-1.85c-1.34-1.72-3.8-2.39-4.85-4.3h0c-1,1.91-3.51,2.58-4.85,4.3a7,7,0,0,0-1,1.85,5.82,5.82,0,0,0-.17,4.22,4.59,4.59,0,0,0,2.74,2.38,14.13,14.13,0,0,0,6.51,0,4.62,4.62,0,0,0,2.74-2.38A5.77,5.77,0,0,0,197.32,102Z",
    style: {
      fill: "#04b2d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,101.89a7.09,7.09,0,0,0-1.84-2.83c-.83-.75-3.93-2.2-4-3.21a.45.45,0,0,0-.82-.23h.76a.44.44,0,0,0-.82.23c-.05,1.18-3.32,2.52-4.23,3.45a7.31,7.31,0,0,0-1.83,3.42c-.65,2.58.15,5,2.68,6.11a10.21,10.21,0,0,0,8-.14c2.7-1.43,2.92-4.14,2.07-6.8-.17-.54-1-.31-.84.23,1.39,4.39-1.49,6.4-5.4,6.42s-7-2-5.39-6.42c.83-2.25,2.58-3,4.28-4.38.49-.41,1.52-1.18,1.55-1.89l-.82.22h0a.44.44,0,0,0,.76,0h0l-.82-.22c0,.66,1.14,1.55,1.56,1.89,1.69,1.41,3.39,2.18,4.28,4.38C197.11,102.64,198,102.41,197.74,101.89Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.58,104c1.64-2.17,4-3.83,6.86-3.28a8.37,8.37,0,0,1,5,3.6c.14.22.49,0,.35-.2-3.29-4.91-9-5-12.52-.33-.16.21.19.41.35.21Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.86,97.71v0a.3.3,0,0,0-.6,0v0a.3.3,0,0,0,.6,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.6,
    cy: 115.52,
    r: 12.95,
    transform: "translate(-29.51 81.4) rotate(-22.31)",
    style: {
      fill: "#5ed7f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.66 108.81 202.58 108.81 191.6 128.11 180.66 108.81",
    style: {
      fill: "none",
      stroke: "#089fb7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.86921px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.6,128c-6.77-.34-12.51-5.46-12.51-12.51A12.68,12.68,0,0,1,191.6,103,12.55,12.55,0,0,1,204,114.27c.73,7.53-5.05,13.39-12.39,13.76-.56,0-.57.91,0,.88,7.28-.37,13.39-5.83,13.39-13.39a13.39,13.39,0,1,0-26.78,0c0,7.56,6.11,13,13.39,13.39C192.17,128.94,192.16,128.06,191.6,128Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76,112.06h13a1.18,1.18,0,0,0,0-2.35h-13a1.18,1.18,0,0,0,0,2.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.1,111.61c.71,2.23-2.17,1.34-3.4,1.31a4.07,4.07,0,0,0-3.12,1.13,3.42,3.42,0,0,0,.89,5.27c1.29.79,2.47-1.24,1.18-2a1,1,0,0,1,.22-2,4.39,4.39,0,0,1,1.84,0,5.6,5.6,0,0,0,3-.17c1.75-.72,2.18-2.54,1.65-4.23-.46-1.43-2.72-.82-2.27.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67,123.07c-1-1-2.28-3.13-.18-3.74a4.23,4.23,0,0,1,4,1c1.1,1,2.76-.63,1.66-1.66-2-1.85-5.2-2.61-7.62-1.11-2.85,1.75-1.32,5.24.43,7.12,1,1.11,2.68-.56,1.66-1.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.65,108.36a1.18,1.18,0,0,0,0-2.35,1.18,1.18,0,0,0,0,2.35Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("a", {
    href: "/Sahasrara"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sahasrara",
    className: "chakraAnimated"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.43,40.74A6.69,6.69,0,0,0,209,39.42c1.37-1.64,1.5-4.14,3.12-5.54h0c-2-.61-3.21-2.83-5.13-3.76a6.78,6.78,0,0,0-2-.55,5.72,5.72,0,0,0-4.09.71,4.55,4.55,0,0,0-1.72,3.12,8.27,8.27,0,0,0,.32,3.2,8.19,8.19,0,0,0,1,3,4.51,4.51,0,0,0,2.85,2.13A5.67,5.67,0,0,0,207.43,40.74Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.65,41.11A7,7,0,0,0,210,38.75c.58-1,1.21-4.19,2.28-4.45a.44.44,0,0,0,0-.84h0l.19.72h0c.33-.32,0-.79-.43-.72-1.11.19-3.11-2.69-4.18-3.36a7.28,7.28,0,0,0-3.52-1c-2.48-.14-4.69,1-5.37,3.49a10,10,0,0,0,1.75,8c1.94,2.29,4.58,1.92,7,.56a.43.43,0,0,0-.44-.74c-3.89,2.22-6.48,0-7.26-3.88s.67-7.07,5-6.47c2.28.32,3.42,1.83,5.11,3.16.48.38,1.49,1.24,2.19,1.11l-.42-.72h0a.45.45,0,0,0,.19.73h0v-.84c-.62.16-1.25,1.45-1.49,1.9-1,1.92-1.38,3.69-3.32,5C206.75,40.68,207.19,41.42,207.65,41.11Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,29.87c2.39,1.11,4.59,3.06,4.66,5.91a8.33,8.33,0,0,1-2.48,5.53c-.18.18.1.46.27.28,4-4.16,2.93-9.65-2.25-12.06-.23-.1-.43.24-.2.34Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.43,34.6h0c.37-.08.21-.65-.16-.57h0c-.37.08-.21.64.16.56Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22,49.36a6.37,6.37,0,0,0,2-.18c2.07-.56,3.61-2.54,5.73-2.76h0c-1.33-1.67-1-4.16-2.06-6a6.61,6.61,0,0,0-1.31-1.58,5.66,5.66,0,0,0-3.75-1.75,4.53,4.53,0,0,0-3.2,1.57,8.27,8.27,0,0,0-1.57,2.81,8.31,8.31,0,0,0-.89,3.09,4.54,4.54,0,0,0,1.12,3.38A5.64,5.64,0,0,0,203.22,49.36Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22,49.79a6.84,6.84,0,0,0,3.25-.62c.85-.41,3.52-2.68,4.41-2.33a.44.44,0,0,0,.49-.64h0l-.26.64h0a.44.44,0,0,0,.1-.79c-1-.5-1.14-4.15-1.58-5.17A7.16,7.16,0,0,0,207.3,38c-2-1.52-4.4-1.83-6.4-.15a9.87,9.87,0,0,0-3.1,7.56c.29,3,2.7,4.18,5.42,4.4.55.05.55-.82,0-.86-4.29-.35-5.25-3.66-3.75-7.26,1.34-3.22,4.05-5.5,7.33-3,1.93,1.5,2.23,3.36,2.8,5.58.17.66.49,2.17,1.18,2.49l.1-.79h0a.44.44,0,0,0-.26.64h0l.49-.63c-.58-.23-1.8.45-2.31.73-1.91,1-3.24,2.22-5.58,2.19A.43.43,0,0,0,203.22,49.79Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.82,37.94c2.75,4.74.6,9.55-4.79,10.61-.25.05-.14.43.11.38,5.69-1.13,7.88-6.26,5-11.19-.12-.22-.46,0-.33.2Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.2,46.05h0c.35.14.5-.43.16-.57h0c-.35-.15-.5.42-.16.57Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.91,24.78a6.86,6.86,0,0,0-.47-2c-.85-2-3-3.2-3.56-5.27h0c-1.46,1.56-4,1.59-5.66,2.9a6.72,6.72,0,0,0-1.38,1.53,5.6,5.6,0,0,0-1.19,4,4.49,4.49,0,0,0,2,2.94,8.18,8.18,0,0,0,3,1.15,8.25,8.25,0,0,0,3.19.44,4.52,4.52,0,0,0,3.18-1.6A5.64,5.64,0,0,0,200.91,24.78Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.34,24.78a7.07,7.07,0,0,0-1.06-3.14c-.61-.93-3.19-3-3-4a.43.43,0,0,0-.72-.42h0l.72.19h0a.44.44,0,0,0-.84,0c-.33,1.12-3.77,1.6-4.87,2.25a7.36,7.36,0,0,0-2.57,2.8c-1.33,2.42-1,5.07,1.34,6.7,2.06,1.44,5.63,2.31,8,1.38s3.09-3.29,2.94-5.74c0-.55-.9-.55-.87,0,.24,3.78-2.28,5.74-5.9,5s-7.09-3.16-4.58-7.27c1.31-2.15,3.23-2.48,5.32-3.46.52-.25,1.79-.78,2-1.44h-.84a.44.44,0,0,0,.73.19h0l-.72-.42c-.15.66.69,1.74,1,2.19,1.26,1.75,2.69,2.9,3,5.2C200.55,25.32,201.41,25.33,201.34,24.78Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.25,23.83c2.09-1.65,4.75-2.65,7.32-1.43A8.21,8.21,0,0,1,200.41,27c.08.24.46.14.38-.1-1.93-5.47-7.34-6.93-11.82-3.38-.2.16.08.44.28.28Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.76,19.37v0c.09-.36-.48-.52-.57-.15v0c-.09.36.48.52.57.15Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.4,54.62a6.44,6.44,0,0,0,1.39,1.51c1.7,1.3,4.2,1.32,5.67,2.86h0c.51-2.07,2.68-3.33,3.52-5.29a6.53,6.53,0,0,0,.45-2,5.64,5.64,0,0,0-.89-4,4.54,4.54,0,0,0-3.2-1.58,8.44,8.44,0,0,0-3.18.46,8.3,8.3,0,0,0-3,1.18,4.54,4.54,0,0,0-2,2.95A5.68,5.68,0,0,0,190.4,54.62Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,54.83a7,7,0,0,0,2.45,2.22c1,.51,4.29,1.1,4.57,2.06a.43.43,0,0,0,.83,0h0l-.72.19h0a.43.43,0,0,0,.72-.42c-.25-1.13,2.53-3.23,3.16-4.33a7.39,7.39,0,0,0,.87-3.57c0-2.48-1.16-4.64-3.71-5.21a9.94,9.94,0,0,0-7.91,2.09c-2.21,2-1.74,4.65-.26,7,.29.47,1,0,.74-.43-2.4-3.79-.26-6.45,3.51-7.45,3.5-.92,7,.1,6.75,4.39-.14,2.47-1.62,3.68-2.95,5.53-.35.49-1.18,1.56-1,2.24l.72-.42h0a.43.43,0,0,0-.72.19h.83c-.18-.62-1.47-1.18-1.95-1.4-2-.92-3.76-1.22-5.16-3.08C190.44,54,189.69,54.39,190,54.83Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,49.75c-1.08,2.61-3,4.77-6,4.78a8.19,8.19,0,0,1-5.28-2.12c-.19-.17-.47.11-.27.28,4.36,3.83,9.78,2.45,12-2.84.09-.23-.29-.33-.38-.1Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.66,57.32v0a.3.3,0,0,0,.57-.16v0a.3.3,0,0,0-.57.16Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,31.57a6.36,6.36,0,0,0,.66-1.94c.3-2.12-.9-4.32-.27-6.36h0c-2.06.56-4.21-.73-6.34-.5a6.56,6.56,0,0,0-2,.58,5.7,5.7,0,0,0-3.1,2.74,4.51,4.51,0,0,0,.18,3.56,8.26,8.26,0,0,0,1.95,2.56,8.42,8.42,0,0,0,2.48,2,4.5,4.5,0,0,0,3.55.31A5.64,5.64,0,0,0,206.56,31.57Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.94,31.79a7.41,7.41,0,0,0,.76-3c0-1.21-1.2-4.47-.44-5.26a.43.43,0,0,0-.42-.72h0l.53.53h0a.44.44,0,0,0-.72-.42c-.84.76-4.73-.77-6.09-.62a8,8,0,0,0-4,1.73,4.73,4.73,0,0,0-1.25,5.8A10.25,10.25,0,0,0,200.72,35c2.85.95,4.93-.76,6.22-3.17.26-.49-.49-.93-.75-.43-1.86,3.5-5,3.65-7.78,1-2.12-2-4.1-5-1.31-7.58,2.26-2,4.66-1.47,7.39-1.09.64.08,2.19.38,2.77-.15l-.72-.42h0a.44.44,0,0,0,.53.54h0l-.42-.73c-.46.48-.32,1.7-.28,2.26.14,2.18.79,4-.18,6.14C206,31.86,206.71,32.3,206.94,31.79Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.09,24.65c2.3-.28,4.84.05,6.48,1.85s1.87,4.5,1.39,6.73c-.06.25.32.35.38.11.47-2.19.27-5-1.17-6.75-1.71-2.14-4.48-2.65-7.08-2.33-.25,0-.25.42,0,.39Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.88,24.79l0,0c.27-.26-.15-.68-.42-.41h0c-.28.27.14.68.41.42Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.39,53.72a6.48,6.48,0,0,0,1.9.79c2.09.44,4.36-.61,6.35.16h0c-.42-2.09,1-4.15.92-6.29a6.64,6.64,0,0,0-.44-2,5.65,5.65,0,0,0-2.53-3.27A4.49,4.49,0,0,0,200,43a8,8,0,0,0-2.69,1.78,8.21,8.21,0,0,0-2.21,2.34,4.51,4.51,0,0,0-.55,3.52A5.67,5.67,0,0,0,197.39,53.72Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.17,54.1a7.12,7.12,0,0,0,2.91.94c1,.08,4.54-.85,5.26-.06.32.35.78,0,.72-.42h0l-.53.53h0c.34.11.72-.33.49-.63-.7-.93.86-4.19.95-5.31a7.19,7.19,0,0,0-.73-3.65c-1.07-2.26-3.07-3.66-5.61-3.1a10,10,0,0,0-6.23,5.29c-1.13,2.79.45,5,2.77,6.41.47.29.91-.46.43-.75-3.33-2.08-3.25-5.14-.58-7.73s6.51-3.76,8.42.27c1.05,2.21.45,4-.06,6.23-.15.67-.56,2.17-.11,2.77l.49-.63h0c-.34-.12-.58.23-.53.53h0l.72-.42c-.43-.47-1.69-.41-2.24-.41-2.28,0-3.9.56-6.11-.61C197.11,53.09,196.68,53.84,197.17,54.1Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.93,44.75c.14,2.48-.5,5.25-2.74,6.68a8.22,8.22,0,0,1-6.36.58.19.19,0,0,0-.11.37c2.29.66,5.19.6,7.12-.94s2.62-4.2,2.48-6.69c0-.25-.4-.25-.39,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.22,53.52h0c.24.29.66-.13.42-.42h0c-.24-.29-.66.13-.41.42Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.58,51a6.37,6.37,0,0,0,2,.27c2.14-.1,4.07-1.69,6.19-1.45h0c-.93-1.91-.08-4.27-.7-6.31a6.61,6.61,0,0,0-.94-1.83,5.61,5.61,0,0,0-3.28-2.53,4.5,4.5,0,0,0-3.46.85,8.25,8.25,0,0,0-2.15,2.4,8.26,8.26,0,0,0-1.54,2.82,4.5,4.5,0,0,0,.37,3.54A5.63,5.63,0,0,0,199.58,51Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.46,51.43a6.91,6.91,0,0,0,3.32.1c.93-.21,4-1.85,4.81-1.33.4.26.75-.23.59-.59h0l-.37.65h0c.47,0,.53-.57.22-.81-.78-.59-.16-4.27-.34-5.28A7.21,7.21,0,0,0,206,40.8c-1.71-2-4.14-2.8-6.53-1.37a10,10,0,0,0-4.38,6.88c-.16,2.83,1.85,4.35,4.33,5.12.53.16.76-.67.23-.84-3.75-1.16-4.45-4.15-2.53-7.32s5.34-5.3,8.21-1.88c1.71,2,1.36,4.1,1.56,6.53,0,.7.06,1.82.66,2.28l.22-.8h0a.44.44,0,0,0-.38.65h0l.59-.59c-.54-.35-1.83,0-2.41.2-2.08.58-3.65,1.47-5.92.93C199.15,50.47,198.92,51.3,199.46,51.43Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.59,40.42c.76,2.36.85,5.2-1,7.15a8.22,8.22,0,0,1-6,2.17.2.2,0,0,0,0,.4c2.37,0,5.17-.75,6.64-2.72s1.47-4.74.7-7.11c-.08-.24-.46-.14-.38.11Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.13,49.07h0c.32.22.61-.29.3-.51h0c-.31-.22-.61.29-.3.51Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4,36.35a6.84,6.84,0,0,0,1-1.76c.75-2,.05-4.41,1.11-6.26h0c-2.14.11-4-1.61-6.09-1.85a6.76,6.76,0,0,0-2.05.15,5.66,5.66,0,0,0-3.62,2,4.56,4.56,0,0,0-.59,3.52,8.29,8.29,0,0,0,1.36,2.92,8.33,8.33,0,0,0,2,2.53,4.52,4.52,0,0,0,3.4,1.06A5.67,5.67,0,0,0,206.4,36.35Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.77,36.57a6.87,6.87,0,0,0,1.38-3c.18-1-.13-4.34.63-4.84a.44.44,0,0,0-.22-.81h0l.37.65h0a.43.43,0,0,0-.59-.59c-1,.58-3.84-1.48-5.06-1.76a7.15,7.15,0,0,0-3.67.18c-2.43.7-4.11,2.46-3.92,5.11a9.89,9.89,0,0,0,4.58,7.08c2.53,1.29,4.74.08,6.43-1.9.36-.42-.25-1-.61-.61-1.14,1.33-2.44,2.55-4.46,2.12-1.78-.38-2.81-1.89-3.68-3.32-1.77-2.89-2.08-6.49,1.89-7.65,2.28-.67,3.85.08,5.88.89.7.28,2.27,1,3.06.6l-.59-.59h0a.43.43,0,0,0,.37.65h0l-.22-.8c-.44.3-.64,1.38-.73,1.85-.43,2.28-.11,4.34-1.59,6.33C205.69,36.58,206.44,37,206.77,36.57Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.67,27.56c5.38.5,8.1,5.06,5.81,10.06-.11.23.23.43.34.2,2.42-5.3-.44-10.12-6.15-10.65-.25,0-.25.37,0,.39Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.18,29.58h0a.3.3,0,0,0-.3-.51h0c-.32.2,0,.71.3.51Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,45.36a6.44,6.44,0,0,0,1.89-.8c1.79-1.18,2.64-3.53,4.59-4.41h0c-1.78-1.17-2.24-3.64-3.82-5.08A6.57,6.57,0,0,0,205.9,34a5.64,5.64,0,0,0-4.11-.5A4.49,4.49,0,0,0,199.24,36a8.06,8.06,0,0,0-.62,3.16,8.06,8.06,0,0,0,.11,3.21,4.52,4.52,0,0,0,2.11,2.87A5.68,5.68,0,0,0,205,45.36Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.1,45.78a6.91,6.91,0,0,0,2.9-1.6c.68-.64,2.47-3.64,3.47-3.59.46,0,.54-.58.21-.81h0v.75h0c.43-.22.17-.76-.21-.81-1-.13-2.25-3.49-3-4.35A6.63,6.63,0,0,0,206,33.56c-2.48-1.13-5.27-1-6.81,1.53a10,10,0,0,0-.62,8.16c1.21,2.73,3.82,3.14,6.51,2.53.54-.13.31-1-.23-.84-4.32,1-6.14-2-5.82-5.82.33-4,3.1-6.84,7.25-4.46,2,1.14,2.39,3.12,3.77,4.76.34.41.82,1.09,1.4,1.16l-.22-.8h0a.44.44,0,0,0,0,.75h0l.22-.81c-.64,0-1.63,1-2,1.4-1.5,1.56-2.4,3.13-4.63,3.82C204.34,45.11,204.56,45.94,205.1,45.78Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.9,33.69c2,1.75,3.5,4.25,2.74,7a8.45,8.45,0,0,1-4,4.57c-.22.12,0,.46.2.34,5-2.82,5.58-8.39,1.32-12.19-.19-.17-.47.11-.28.28Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.63,40.36h0c.38,0,.38-.56,0-.59h0c-.37,0-.37.56,0,.59Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,53.28a7,7,0,0,0,1.68,1.18c1.94.89,4.4.36,6.17,1.56h0c.05-2.14,1.9-3.84,2.29-5.94a6.41,6.41,0,0,0,0-2,5.68,5.68,0,0,0-1.75-3.76,4.52,4.52,0,0,0-3.46-.84,8.23,8.23,0,0,0-3,1.14,8.12,8.12,0,0,0-2.67,1.8,4.51,4.51,0,0,0-1.31,3.31A5.65,5.65,0,0,0,193,53.28Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.66,53.58a7,7,0,0,0,2.88,1.63c1.14.29,4.34.06,4.9,1a.43.43,0,0,0,.8-.22h0l-.65.37h0c.4.24.77-.22.6-.59-.48-1,1.79-3.75,2.15-4.91a7.4,7.4,0,0,0,.07-3.68c-.57-2.61-2.35-4.4-5.14-4.24A9.92,9.92,0,0,0,191.19,47c-1.46,2.44-.38,4.73,1.47,6.55a.43.43,0,0,0,.61-.61c-3.08-3-1.73-6.24,1.84-8,3-1.51,6.58-1.63,7.47,2.5.54,2.53-.68,4.17-1.61,6.34-.25.56-.84,1.8-.53,2.46l.59-.59h0a.43.43,0,0,0-.65.37h0l.8-.22c-.32-.56-1.7-.82-2.21-.94-2.12-.46-3.93-.36-5.7-1.89C192.85,52.61,192.23,53.22,192.66,53.58Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.3,46.17c-.38,2.26-1.36,4.47-3.47,5.61s-5,.6-7-.52c-.23-.12-.42.22-.2.34,5.06,2.78,10.1.31,11.05-5.32,0-.25-.34-.36-.38-.11Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.66,54.57h0c.18.34.69,0,.51-.29v0c-.17-.34-.68,0-.51.3Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.23,29.35a7,7,0,0,0,0-2.05c-.37-2.11-2.19-3.83-2.21-6h0c-1.78,1.17-4.23.61-6.18,1.48a6.57,6.57,0,0,0-1.7,1.16,5.69,5.69,0,0,0-2.1,3.57,4.49,4.49,0,0,0,1.27,3.33A8.08,8.08,0,0,0,195,32.7a8.09,8.09,0,0,0,3,1.18,4.49,4.49,0,0,0,3.47-.8A5.66,5.66,0,0,0,203.23,29.35Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.66,29.35a6.92,6.92,0,0,0-.42-3.52c-.34-.87-2.22-3.48-1.83-4.28.18-.37-.2-.83-.59-.59h0l.65.37h0a.44.44,0,0,0-.81-.22c-.59,1-4.07.68-5.26,1a7.31,7.31,0,0,0-3.07,2c-1.74,1.84-2.31,4.21-.81,6.4a9.85,9.85,0,0,0,7.54,3.79c2.83-.16,4.13-2.32,4.58-4.88.1-.55-.73-.78-.83-.23C202.5,31,202,32.68,200,33.33c-1.73.57-3.36-.22-4.85-1-3-1.58-5-4.59-2.24-7.56,1.63-1.73,3.37-1.88,5.54-2.21.72-.11,2.49-.24,2.93-1l-.81-.22h0a.43.43,0,0,0,.65.37h0l-.6-.59c-.31.64.25,1.86.48,2.42.83,2,1.9,3.51,1.66,5.82C202.74,29.9,203.6,29.9,203.66,29.35Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.12,25.68c5-2.29,9.55.32,10.09,5.73,0,.25.42.26.39,0-.58-5.77-5.44-8.49-10.68-6.07-.23.1,0,.44.2.34Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.48,23.12v0c.18-.33-.33-.63-.51-.29h0c-.18.34.33.64.51.3Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.9,38.51a6.7,6.7,0,0,0-1.37,1.54c-1.11,1.82-.88,4.32-2.27,5.94h0c2.12.3,3.59,2.33,5.63,3a6.64,6.64,0,0,0,2,.24,5.66,5.66,0,0,0,3.93-1.29,4.49,4.49,0,0,0,1.24-3.34,8.11,8.11,0,0,0-.78-3.12,8.07,8.07,0,0,0-1.47-2.87,4.54,4.54,0,0,0-3.14-1.68A5.66,5.66,0,0,0,175.9,38.51Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6,38.21a6.72,6.72,0,0,0-1.93,2.69c-.31.79-.77,4.37-1.53,4.67-.35.14-.46.74,0,.83h0l-.26-.64h0a.43.43,0,0,0,.48.64c1-.37,3.63,2.21,4.64,2.66a7,7,0,0,0,3.63.53c2.51-.22,4.52-1.6,4.85-4.24a9.93,9.93,0,0,0-3.13-7.84c-2.29-1.8-4.68-1-6.76.69-.44.34.17.95.61.61,3.94-3.1,6.81-.25,8,3.5,1.1,3.46-.36,6.44-4.28,6.45-2.36,0-3.6-1.3-5.5-2.39-.58-.33-1.64-1-2.29-.81l.49.64h0a.44.44,0,0,0-.26-.64h0v.83c.64-.25.92-1.22,1.15-1.82.8-2.17.86-4.08,2.69-5.76C176.62,38.44,176,37.83,175.6,38.21Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.84,48.61c-5.26-1.56-7-6.56-3.79-11,.15-.2-.19-.4-.34-.19-3.38,4.73-1.43,10,4,11.58.24.07.34-.31.1-.38Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.88,45h0c-.35.14-.2.71.15.57h0c.35-.14.2-.71-.15-.57Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.81,29.34a6.52,6.52,0,0,0-2,.44c-2,.82-3.25,3-5.33,3.47h0c1.54,1.49,1.53,4,2.81,5.71a6.66,6.66,0,0,0,1.5,1.4,5.68,5.68,0,0,0,3.95,1.26,4.57,4.57,0,0,0,3-2,8.4,8.4,0,0,0,1.2-3,8.24,8.24,0,0,0,.49-3.18,4.51,4.51,0,0,0-1.55-3.21A5.61,5.61,0,0,0,178.81,29.34Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.81,28.91a7,7,0,0,0-3.16,1c-.93.59-3.09,3.15-4.07,2.91a.43.43,0,0,0-.42.72h0l.19-.72h0a.44.44,0,0,0,0,.84c1.11.35,1.53,3.8,2.17,4.91a7.36,7.36,0,0,0,2.76,2.61c2.4,1.37,5.05,1.08,6.72-1.24,1.47-2,2.4-5.6,1.5-8s-3.26-3.14-5.69-3c-.56,0-.56.89,0,.86,3.83-.18,5.71,2.33,4.91,6s-3.29,7-7.36,4.45c-2.12-1.35-2.42-3.28-3.37-5.38-.24-.53-.74-1.8-1.41-2v.84h0a.44.44,0,0,0,.19-.73h0l-.42.72c.64.16,1.77-.67,2.21-1,1.77-1.23,2.94-2.64,5.25-2.91C179.35,29.71,179.36,28.84,178.81,28.91Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.7,41c-1.46-1.9-2.48-4.34-1.66-6.75.73-2.14,3-3.7,5-4.4.24-.08.14-.46-.1-.37-5.47,1.82-7.07,7.18-3.59,11.72.15.2.49,0,.34-.2Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.33,33.39h0a.3.3,0,0,0-.16.57h0a.3.3,0,0,0,.16-.57Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.79,23.44a6.69,6.69,0,0,0-1.95-.65c-2.11-.3-4.31.91-6.35.28h0c.57,2.06-.72,4.22-.49,6.34a6.79,6.79,0,0,0,.59,2,5.64,5.64,0,0,0,2.75,3.1,4.55,4.55,0,0,0,3.56-.19,8.1,8.1,0,0,0,2.55-2,8.15,8.15,0,0,0,2-2.49,4.5,4.5,0,0,0,.31-3.55A5.68,5.68,0,0,0,184.79,23.44Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,23.07a7.41,7.41,0,0,0-3-.76c-1.22,0-4.45,1.21-5.26.45a.43.43,0,0,0-.72.42h0l.53-.53h0a.43.43,0,0,0-.42.72c.77.85-.75,4.73-.6,6.1a7.8,7.8,0,0,0,1.74,4,4.71,4.71,0,0,0,5.8,1.23,10.17,10.17,0,0,0,5.07-5.38c.95-2.85-.76-4.94-3.18-6.21-.49-.26-.93.48-.43.74,3.5,1.86,3.67,5,1,7.78-2,2.13-5,4.11-7.57,1.33-2.06-2.25-1.49-4.66-1.12-7.38.09-.65.38-2.19-.15-2.78l-.42.73h0a.45.45,0,0,0,.54-.54h0l-.72.42c.49.46,1.69.32,2.26.28,2.18-.15,4-.8,6.14.16C185.08,24,185.52,23.29,185,23.07Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9,32.93c-.29-2.29,0-4.84,1.83-6.49s4.49-1.88,6.73-1.4c.24.05.35-.33.1-.38-2.18-.47-4.95-.26-6.74,1.18-2.14,1.72-2.64,4.5-2.32,7.09,0,.25.43.25.4,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,24.14v0c-.27-.27-.68.15-.42.42h0a.29.29,0,0,0,.42-.41Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,22a6.71,6.71,0,0,0-1.39-1.52c-1.7-1.29-4.21-1.31-5.68-2.86h0c-.51,2.07-2.68,3.33-3.52,5.29a6.91,6.91,0,0,0-.46,2,5.63,5.63,0,0,0,.9,4,4.5,4.5,0,0,0,3.19,1.58,8.27,8.27,0,0,0,3.19-.46,8.18,8.18,0,0,0,3-1.18,4.49,4.49,0,0,0,2-2.95A5.66,5.66,0,0,0,193,22Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4,21.79a7.08,7.08,0,0,0-2.46-2.22c-1-.51-4.28-1.09-4.56-2.06a.44.44,0,0,0-.84,0h0l.72-.19h0a.43.43,0,0,0-.72.42c.25,1.13-2.52,3.23-3.15,4.34a7.23,7.23,0,0,0-.88,3.56c0,2.49,1.17,4.64,3.72,5.22a10,10,0,0,0,7.91-2.09c2.2-2,1.73-4.66.26-7-.3-.47-1.05,0-.75.44,2.41,3.78.27,6.44-3.51,7.44-3.49.92-7-.1-6.74-4.38.14-2.48,1.62-3.69,2.94-5.54.35-.48,1.19-1.55,1-2.24l-.72.42h0a.44.44,0,0,0,.73-.19h-.84c.18.63,1.48,1.18,2,1.41,2,.91,3.77,1.21,5.16,3.08C193,22.67,193.73,22.24,193.4,21.79Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.39,26.88c1.07-2.61,3-4.78,6-4.79a8.16,8.16,0,0,1,5.28,2.13c.19.16.47-.11.28-.28-4.37-3.84-9.79-2.46-12,2.83-.1.24.28.34.38.11Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.77,19.31v0a.29.29,0,0,0-.57.15v0a.29.29,0,0,0,.57-.15Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.52,51.84a6.49,6.49,0,0,0,.47,2c.85,2,3,3.2,3.55,5.27h0c1.46-1.55,4-1.59,5.65-2.89a6.49,6.49,0,0,0,1.38-1.53,5.69,5.69,0,0,0,1.2-4,4.53,4.53,0,0,0-2-2.93,13.91,13.91,0,0,0-6.19-1.6,4.56,4.56,0,0,0-3.19,1.6A5.65,5.65,0,0,0,182.52,51.84Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.09,51.84a7,7,0,0,0,1,3.14c.61.93,3.2,3.05,3,4a.43.43,0,0,0,.72.42h0l-.72-.19h0a.43.43,0,0,0,.83,0c.32-1.11,3.79-1.6,4.87-2.25a7.25,7.25,0,0,0,2.58-2.8c1.32-2.42,1-5.06-1.34-6.7-2.06-1.43-5.64-2.31-8-1.37s-3.09,3.29-2.93,5.73c0,.55.9.56.86,0-.24-3.78,2.28-5.74,5.91-5S196,50,193.43,54.11c-1.3,2.14-3.23,2.48-5.31,3.46-.52.24-1.8.77-2,1.43H187a.44.44,0,0,0-.72-.19h0l.72.42c.14-.65-.69-1.74-1-2.19-1.26-1.75-2.69-2.89-3-5.2C182.88,51.3,182,51.29,182.09,51.84Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.18,52.79c-2.09,1.66-4.76,2.66-7.33,1.44A8.25,8.25,0,0,1,183,49.59c-.09-.24-.47-.13-.38.11,1.93,5.47,7.33,6.92,11.82,3.37.2-.16-.08-.44-.28-.28Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.66,57.25v0a.3.3,0,0,0,.57.16v0c.09-.37-.48-.53-.57-.16Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.05,45.92a6.94,6.94,0,0,0-.54,2c-.19,2.13,1.13,4.26.6,6.33h0c2-.67,4.25.5,6.36.16a6.52,6.52,0,0,0,1.94-.69,5.63,5.63,0,0,0,2.94-2.9,4.55,4.55,0,0,0-.36-3.55,8.19,8.19,0,0,0-2.09-2.45,8.22,8.22,0,0,0-2.59-1.91,4.5,4.5,0,0,0-3.56-.12A5.71,5.71,0,0,0,177.05,45.92Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.64,45.81a6.78,6.78,0,0,0-.52,3.29c.1,1,1.27,4.17.68,4.83a.43.43,0,0,0,.42.72h0l-.53-.53h0a.44.44,0,0,0,.72.43c.79-.8,4.77.48,6.06.28a7.75,7.75,0,0,0,3.37-1.48,4.72,4.72,0,0,0,1.67-6,10,10,0,0,0-6.14-5.22c-2.78-.57-4.59,1.18-5.69,3.55-.23.5.51.94.75.43,3.75-8.06,13.88,1.85,9.44,6.07-2.26,2.16-4.54,1.65-7.3,1.46-.64-.05-2.21-.29-2.77.26l.73.42h0a.44.44,0,0,0-.54-.53h0l.42.72c.36-.4.26-1.5.22-2-.2-2.31-1-4.21-.16-6.52C177.67,45.52,176.84,45.29,176.64,45.81Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.84,52.33c-2.37.43-4.93.14-6.7-1.66-1.57-1.6-1.92-4.35-1.57-6.48,0-.25-.34-.35-.38-.1-.37,2.28,0,5.13,1.67,6.86,1.86,1.91,4.58,2.21,7.09,1.76.25,0,.14-.42-.11-.38Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.11,52.65v0c-.26.27.15.69.41.41h0c.25-.28-.16-.7-.42-.42Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44,51a6.44,6.44,0,0,1-2,.27c-2.13-.1-4.07-1.69-6.19-1.45h0c.94-1.91.08-4.27.7-6.31a6.61,6.61,0,0,1,.94-1.83,5.67,5.67,0,0,1,3.28-2.53,4.52,4.52,0,0,1,3.47.85,8.08,8.08,0,0,1,2.14,2.4,8.1,8.1,0,0,1,1.54,2.82,4.54,4.54,0,0,1-.36,3.54A5.69,5.69,0,0,1,183.44,51Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.32,50.59c-2.3.55-3.82-.36-5.92-.93-.63-.17-1.84-.57-2.41-.2l.59.59h0a.44.44,0,0,0-.37-.65h0l.3.73c.58-.45.56-1.91.6-2.61.15-2.58-.06-4.64,1.95-6.65,4.9-4.9,13.84,7.07,5.26,9.72-.53.17-.3,1,.23.84,2.33-.72,4.32-2.1,4.36-4.76s-2.22-5.92-4.41-7.24a4.76,4.76,0,0,0-6.29,1.1,7.52,7.52,0,0,0-1.8,3.25c-.29,1.23.45,5-.51,5.74-.3.24,0,.75.31.74h0l-.37-.65h0c-.15.36.19.85.6.59.82-.53,3.94,1.13,4.8,1.33a6.91,6.91,0,0,0,3.32-.1C184.09,51.3,183.86,50.47,183.32,50.59Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,40.31c-.76,2.37-.85,5,.71,7.11s4.26,2.77,6.63,2.72a.2.2,0,0,0,0-.4,8.24,8.24,0,0,1-6-2.17c-1.8-2-1.72-4.79-1-7.15.08-.25-.3-.35-.38-.11Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.59,48.56h0c-.31.22,0,.73.3.51h0c.3-.22,0-.73-.3-.51Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,45.36a6.44,6.44,0,0,1-1.89-.8c-1.79-1.18-2.64-3.53-4.59-4.41h0c1.79-1.17,2.25-3.64,3.82-5.08a6.74,6.74,0,0,1,1.74-1.1,5.65,5.65,0,0,1,4.11-.5A4.49,4.49,0,0,1,183.77,36a8.25,8.25,0,0,1,.63,3.16,8.25,8.25,0,0,1-.11,3.21,4.53,4.53,0,0,1-2.12,2.87A5.68,5.68,0,0,1,178,45.36Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.15,44.94c-2.27-.7-3.11-2.26-4.63-3.82-.39-.4-1.34-1.42-2-1.4l.22.81h0a.44.44,0,0,0,0-.75h0l-.22.8c.58-.07,1-.74,1.4-1.16,1.36-1.64,1.78-3.62,3.76-4.76a5.89,5.89,0,0,1,5-.51c1.87.77,2.16,3.29,2.3,5,.31,3.85-1.51,6.81-5.82,5.82-.54-.12-.78.71-.23.84,2.67.61,5.3.2,6.5-2.53a9.91,9.91,0,0,0-.62-8.16c-1.57-2.47-4.29-2.67-6.8-1.53a6.86,6.86,0,0,0-2.49,1.81c-.68.81-1.95,4.22-3,4.35-.38.05-.64.58-.22.81h0v-.75h0c-.32.23-.25.83.22.81,1-.05,2.84,3,3.47,3.59a6.9,6.9,0,0,0,2.9,1.6C178.45,45.94,178.68,45.11,178.15,44.94Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.83,33.41c-4.25,3.8-3.72,9.37,1.32,12.19.22.12.42-.22.2-.34a8.56,8.56,0,0,1-4-4.57c-.75-2.72.78-5.26,2.74-7,.19-.17-.09-.45-.28-.28Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.38,39.77h0c-.38,0-.38.62,0,.59h0c.38,0,.38-.62,0-.59Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.05,53.28a6.79,6.79,0,0,1-1.68,1.18c-1.94.89-4.39.36-6.16,1.56h0c0-2.14-1.89-3.84-2.29-5.94a6.71,6.71,0,0,1,0-2,5.67,5.67,0,0,1,1.74-3.76,4.53,4.53,0,0,1,3.47-.84,8.18,8.18,0,0,1,3,1.14,8,8,0,0,1,2.67,1.8,4.52,4.52,0,0,1,1.32,3.31A5.71,5.71,0,0,1,190.05,53.28Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.75,53c-1.77,1.52-3.59,1.44-5.7,1.89-.55.12-1.9.39-2.22.94l.81.22h0a.43.43,0,0,0-.65-.37h0l.59.59c.31-.65-.27-1.9-.52-2.46-1-2.16-2.15-3.84-1.61-6.34.9-4.17,4.45-4,7.47-2.5,3.56,1.79,4.92,5,1.84,8-.4.39.21,1,.61.61,1.73-1.71,2.85-3.85,1.65-6.23s-4.69-4.23-7.26-4.38a4.74,4.74,0,0,0-5.06,3.89,7.52,7.52,0,0,0-.1,3.68c.31,1.22,2.71,4.27,2.24,5.26a.43.43,0,0,0,.59.59h0l-.65-.37h0a.44.44,0,0,0,.81.22c.53-.92,3.88-.77,4.89-1a7,7,0,0,0,2.89-1.63C190.78,53.22,190.17,52.61,189.75,53Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.34,46.28c.94,5.62,6,8.1,11,5.32.22-.12,0-.46-.2-.34-2.05,1.12-4.87,1.68-7,.52a7.39,7.39,0,0,1-3.46-5.61c0-.25-.42-.14-.38.11Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.84,54.27v0c-.17.33.34.63.51.29h0c.17-.34-.34-.64-.51-.3Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.79,29.35a6.41,6.41,0,0,1,0-2.05c.36-2.11,2.19-3.83,2.21-6h0c1.79,1.17,4.23.61,6.18,1.48a6.57,6.57,0,0,1,1.7,1.16,5.61,5.61,0,0,1,2.1,3.57,4.52,4.52,0,0,1-1.26,3.33,8.12,8.12,0,0,1-2.65,1.83,8.11,8.11,0,0,1-3,1.18,4.51,4.51,0,0,1-3.48-.8A5.65,5.65,0,0,1,179.79,29.35Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.22,29.35c-.25-2.31.82-3.8,1.65-5.82.23-.56.79-1.78.48-2.42l-.59.59h0a.43.43,0,0,0,.65-.37h0l-.8.22c.44.77,2.21.9,2.93,1,2.18.34,3.9.48,5.53,2.21,2.81,3,.77,6-2.24,7.56-1.49.78-3.11,1.57-4.84,1-2-.65-2.48-2.37-2.79-4.09-.09-.55-.93-.32-.83.23.43,2.41,1.57,4.51,4.22,4.86s6.41-1.59,7.9-3.77a4.75,4.75,0,0,0-.57-6.13,7.55,7.55,0,0,0-3-2.16c-1.2-.43-5-.14-5.6-1.16a.43.43,0,0,0-.8.22h0l.65-.37h0a.44.44,0,0,0-.59.59c.42.85-1.49,3.43-1.83,4.28a7,7,0,0,0-.42,3.52C179.41,29.9,180.28,29.9,180.22,29.35Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.09,25.34c-5.23-2.42-10.1.3-10.68,6.07,0,.26.37.25.39,0,.55-5.41,5.14-8,10.1-5.73.22.1.42-.24.19-.34Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.05,22.82h0c-.18-.34-.69,0-.51.29v0c.18.34.68,0,.51-.3Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62,36.35a6.6,6.6,0,0,1-1.06-1.76c-.75-2,0-4.41-1.1-6.26h0c2.13.11,4-1.61,6.08-1.85a6.72,6.72,0,0,1,2.05.15,5.63,5.63,0,0,1,3.62,2,4.52,4.52,0,0,1,.59,3.52,8.29,8.29,0,0,1-1.36,2.92,8.18,8.18,0,0,1-2,2.53,4.52,4.52,0,0,1-3.4,1.06A5.65,5.65,0,0,1,176.62,36.35Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,36.13c-1.49-2-1.14-4-1.59-6.33-.1-.53-.25-1.53-.73-1.85l-.22.8h0a.44.44,0,0,0,.37-.65h0l-.59.59c.77.45,2.36-.33,3-.6,2.06-.81,3.61-1.56,5.88-.89,4,1.17,3.67,4.77,1.9,7.65-.88,1.43-1.91,2.94-3.68,3.32-2,.43-3.33-.79-4.47-2.12-.36-.43-1,.19-.61.61,1.6,1.87,3.64,3.1,6.1,2.07s4.73-4.62,4.92-7.25a4.76,4.76,0,0,0-3.59-5,7.48,7.48,0,0,0-3.66-.36c-1.25.23-4.4,2.41-5.41,1.83a.43.43,0,0,0-.59.59h0l.38-.65h0a.44.44,0,0,0-.22.81c.76.5.46,3.85.64,4.84a6.84,6.84,0,0,0,1.37,3C176.57,37,177.32,36.58,177,36.13Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.35,27.17c-5.72.53-8.58,5.35-6.15,10.65.1.23.44,0,.34-.2-2.29-5,.42-9.56,5.81-10.06.25,0,.25-.41,0-.39Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14,29.07h0c-.33-.2-.62.31-.3.51h0c.32.2.62-.31.3-.51Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.8,52.14a6.45,6.45,0,0,0,.95,1.82c1.31,1.69,3.73,2.35,4.76,4.22h0c1-1.87,3.44-2.53,4.76-4.22a6.71,6.71,0,0,0,.95-1.82,5.66,5.66,0,0,0,.17-4.14,4.54,4.54,0,0,0-2.68-2.34,14,14,0,0,0-6.4,0A4.55,4.55,0,0,0,185.62,48,5.66,5.66,0,0,0,185.8,52.14Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.38,52.26A7.1,7.1,0,0,0,187.19,55c.83.75,3.84,2.13,3.88,3.16a.44.44,0,0,0,.81.21h-.74a.43.43,0,0,0,.8-.21c0-1.14,3.28-2.5,4.16-3.39a7.32,7.32,0,0,0,1.79-3.36c.64-2.54-.14-4.89-2.63-6a10,10,0,0,0-7.84.14c-2.65,1.41-2.87,4.06-2,6.68.17.53,1,.3.83-.23-1.36-4.31,1.46-6.29,5.3-6.3s6.88,2,5.29,6.3c-.81,2.21-2.53,2.9-4.2,4.29-.48.4-1.51,1.17-1.52,1.87l.8-.22h0a.43.43,0,0,0-.74,0h0l.81.22c0-.67-1.11-1.52-1.53-1.87-1.65-1.38-3.33-2.13-4.2-4.29C186,51.52,185.17,51.74,185.38,52.26Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.33,50.16c-1.61,2.12-4,3.75-6.74,3.21a8.21,8.21,0,0,1-4.87-3.53c-.14-.21-.48,0-.34.19,3.23,4.82,8.83,4.88,12.29.32.15-.2-.19-.39-.34-.19Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.16,56.35v0a.3.3,0,0,0,.59,0v0a.3.3,0,0,0-.59,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.22,25.05a7,7,0,0,0-.95-1.82c-1.32-1.68-3.73-2.34-4.76-4.21h0c-1,1.87-3.45,2.53-4.76,4.21a6.73,6.73,0,0,0-.95,1.82,5.66,5.66,0,0,0-.18,4.14,4.52,4.52,0,0,0,2.69,2.34,14,14,0,0,0,6.4,0,4.5,4.5,0,0,0,2.68-2.34A5.66,5.66,0,0,0,197.22,25.05Z",
    style: {
      fill: "#9600b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.64,24.94a7,7,0,0,0-1.81-2.77C195,21.43,192,20,191.94,19a.43.43,0,0,0-.8-.22h.74a.44.44,0,0,0-.81.22c0,1.17-3.26,2.48-4.15,3.39a7.29,7.29,0,0,0-1.8,3.36c-.63,2.53.15,4.89,2.64,6a10,10,0,0,0,7.84-.15c2.65-1.4,2.87-4.05,2-6.67-.17-.53-1-.3-.84.23,1.37,4.3-1.45,6.29-5.29,6.3s-6.89-2-5.3-6.3c.82-2.21,2.54-2.91,4.2-4.3.49-.4,1.5-1.15,1.53-1.86l-.81.22h0a.43.43,0,0,0,.74,0h0l-.8-.22c0,.66,1.12,1.52,1.52,1.86,1.66,1.39,3.33,2.14,4.2,4.3C197,25.68,197.84,25.46,197.64,24.94Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.69,27c1.61-2.12,3.95-3.76,6.74-3.22a8.27,8.27,0,0,1,4.87,3.54c.14.21.48,0,.34-.2-3.23-4.82-8.83-4.88-12.29-.32-.15.2.19.4.34.2Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.86,20.84v0a.3.3,0,0,0-.59,0v0a.3.3,0,0,0,.59,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.6,
    cy: 38.32,
    r: 12.72,
    style: {
      fill: "#d519ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.6,50.61c-6.65-.36-12.28-5.35-12.28-12.29A12.25,12.25,0,0,1,203.75,37c.77,7.42-4.91,13.21-12.15,13.6-.55,0-.55.89,0,.86,7.15-.39,13.15-5.7,13.15-13.15a13.14,13.14,0,0,0-26.26-.69c-.4,7.72,5.69,13.44,13.11,13.84C192.16,51.5,192.16,50.63,191.6,50.61Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.62,32.35a1.16,1.16,0,0,0,0-2.31,1.16,1.16,0,0,0,0,2.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.51,34.28a7.14,7.14,0,0,0,8.22,0c1.22-.84.07-2.84-1.16-2a4.9,4.9,0,0,1-5.89,0c-1.23-.84-2.38,1.16-1.17,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,36.78c2.21-1.86,3.54,1.21,2,1.64-.87.24-1.23,1.7-.27,2.11,2.16.93,1.48,3.35-.67,3.55-1.94.17-2.84-1.42-2.76-3.18.06-1.48-2.24-1.48-2.31,0-.17,3.93,3.23,6.66,7,5.06a4,4,0,0,0-.11-7.42l-.28,2.1c2.36-.65,3-3.46,1.77-5.46-1.46-2.43-4.23-1.51-6,0-1.14,1,.5,2.58,1.63,1.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.17,40.65a3.53,3.53,0,0,0,3.87.67c.76-.31,1.36-.89,2.12-1.19a1.77,1.77,0,0,1,1.66,0c.55.44.71,2.24-.41,2.23a1.16,1.16,0,0,0,0,2.31c2.69,0,4.07-3.45,2.62-5.57a3.76,3.76,0,0,0-3.42-1.46C194.24,37.74,192,40,190.8,39s-2.76.68-1.63,1.63Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("a", {
    href: "/Manipura"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manipura",
    className: "chakraAnimated"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.67,220.48a6.78,6.78,0,0,0,1.9.86c2.12.53,4.47-.46,6.47.39h0c-.35-2.15,1.17-4.19,1.17-6.37a6.94,6.94,0,0,0-.38-2.06,5.75,5.75,0,0,0-2.47-3.42,4.55,4.55,0,0,0-3.62-.19,14.24,14.24,0,0,0-5.13,4,4.62,4.62,0,0,0-.68,3.57A5.74,5.74,0,0,0,195.67,220.48Z",
    style: {
      fill: "#d86d18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.45,220.86a7.27,7.27,0,0,0,2.93,1c1,.12,4.64-.69,5.35.14.24.27.8.06.75-.31h0l-.55.43h0a.45.45,0,0,0,.5-.65c-.68-.91,1-4.27,1.16-5.37a7.29,7.29,0,0,0-.63-3.74c-1-2.34-3-3.83-5.61-3.33a10.11,10.11,0,0,0-6.52,5.17c-1.24,2.81.31,5.07,2.62,6.62.47.31.91-.45.44-.76-3.64-2.45-2.85-5.86.28-8.32,2.78-2.19,6.3-3,8,1,1,2.29.31,4.09-.29,6.34-.17.67-.65,2.2-.19,2.82l.49-.65h0a.44.44,0,0,0-.56.42h0l.75-.31c-.45-.53-1.62-.47-2.27-.49-2.28-.08-4.06.39-6.19-.84A.44.44,0,0,0,195.45,220.86Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.66,211.61c.06,2.57-.71,5.29-3,6.7a8.29,8.29,0,0,1-6.5.36c-.24-.08-.35.31-.1.39,2.3.75,5.26.78,7.27-.72s2.82-4.19,2.76-6.73a.2.2,0,0,0-.4,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.64,220.51v0c.24.3.66-.12.42-.43h0c-.24-.31-.66.12-.42.42Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,216.17a6.6,6.6,0,0,0,2.07-.29c2.06-.69,3.52-2.79,5.66-3.14h0c-1.45-1.62-1.26-4.16-2.43-6a6.92,6.92,0,0,0-1.43-1.53,5.8,5.8,0,0,0-3.92-1.57,4.62,4.62,0,0,0-3.16,1.79,14.33,14.33,0,0,0-2.17,6.14,4.62,4.62,0,0,0,1.34,3.38A5.75,5.75,0,0,0,203,216.17Z",
    style: {
      fill: "#d86d18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,216.61a6.92,6.92,0,0,0,3.27-.81c.84-.45,3.39-2.94,4.35-2.64.34.11.74-.33.5-.64h0l-.27.65h0c.46-.09.36-.71,0-.85-1-.37-1.34-4.1-1.79-5.06a7,7,0,0,0-2-2.43c-2.31-1.88-5.18-2.28-7.35,0a10.06,10.06,0,0,0-2.41,7.95c.63,2.81,3,3.76,5.67,3.82.56,0,.56-.86,0-.88-3.9-.09-5.54-2.84-4.52-6.47,1.08-3.81,4.2-6.91,8-3.74,2,1.62,2,3.61,2.9,5.8.24.6.55,1.59,1.2,1.84v-.85h0a.44.44,0,0,0-.26.65h0l.49-.65c-.61-.19-1.86.59-2.3.86-1.88,1.15-3.18,2.46-5.55,2.56C202.38,215.76,202.38,216.64,203,216.61Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.93,204.4c3.06,4.65,1.19,9.68-4.24,11.07a.2.2,0,0,0,.11.39c5.71-1.47,7.68-6.81,4.47-11.66-.14-.22-.49,0-.34.2Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.83,212.46h0c.36.12.52-.46.16-.58h0c-.37-.13-.52.45-.16.58Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.74,198.6a6.9,6.9,0,0,0,.35-2.06c0-2.18-1.58-4.2-1.26-6.36h0c-2,.89-4.36-.07-6.46.49a6.73,6.73,0,0,0-1.9.89,5.81,5.81,0,0,0-2.69,3.25,4.66,4.66,0,0,0,.74,3.56,8.28,8.28,0,0,0,2.37,2.27,8.5,8.5,0,0,0,2.82,1.67,4.6,4.6,0,0,0,3.62-.25A5.78,5.78,0,0,0,204.74,198.6Z",
    style: {
      fill: "#d86d18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.16,198.72a7,7,0,0,0,.22-3.38c-.19-1-1.74-4.13-1.17-4.94a.45.45,0,0,0-.5-.65h0l.56.42h0a.44.44,0,0,0-.75-.31c-.72.88-4.35.07-5.47.23a7.43,7.43,0,0,0-3.49,1.56c-2.14,1.67-3,4.13-1.6,6.6,1.24,2.22,4.27,4.48,6.85,4.7,2.88.26,4.48-1.74,5.35-4.24.19-.54-.66-.77-.85-.24-1.45,4.18-5,4.21-8.11,1.85-2.52-1.91-4.48-4.83-1.58-7.58,2.06-1.95,4.24-1.67,6.84-1.73.74,0,2.19.07,2.68-.53l-.75-.31h0a.43.43,0,0,0,.55.42h0l-.5-.64c-.37.52,0,1.88.13,2.46.52,2.14,1.36,3.77.73,6.06A.44.44,0,0,0,205.16,198.72Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.14,193.12c2.46-.71,5.29-.66,7.25,1.23,1.54,1.49,2.11,4.11,2,6.19,0,.26.39.26.4,0,.14-2.41-.58-5.28-2.54-6.85s-4.77-1.66-7.21-1a.2.2,0,0,0,.11.39Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,191.85h0c.23-.31-.29-.61-.52-.31v0c-.24.31.28.61.51.3Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.68,207.74a6.5,6.5,0,0,0,1.51-1.45c1.27-1.77,1.21-4.32,2.75-5.87h0c-2.12-.46-3.46-2.64-5.49-3.43a6.79,6.79,0,0,0-2.05-.41,5.82,5.82,0,0,0-4.1,1,4.65,4.65,0,0,0-1.51,3.3,8.34,8.34,0,0,0,.56,3.23,8.45,8.45,0,0,0,1.29,3,4.65,4.65,0,0,0,3.06,2A5.78,5.78,0,0,0,206.68,207.74Z",
    style: {
      fill: "#d86d18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,208.05a7.07,7.07,0,0,0,2.26-2.82c.38-.87.93-4.09,1.81-4.38a.45.45,0,0,0,0-.85h0l.2.73h0a.45.45,0,0,0-.43-.74c-1.15.31-3.37-2.44-4.5-3.07a7.35,7.35,0,0,0-3.66-.8c-2.52,0-4.69,1.32-5.21,3.93a10.15,10.15,0,0,0,2.35,8c2.13,2.19,4.78,1.65,7.1.08.47-.31,0-1.07-.44-.76-3.78,2.56-6.56.48-7.69-3.34-1.06-3.55-.09-7.1,4.25-7,2.4.06,3.68,1.33,5.48,2.65.54.4,1.78,1.39,2.56,1.18l-.43-.73h0a.45.45,0,0,0,.19.74h0V200c-.67.22-1.16,1.51-1.4,2.07-.88,2.05-1.2,3.89-3,5.36C205.93,207.78,206.55,208.4,207,208.05Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.41,197.05c2.54,1,4.81,2.75,5.09,5.65a8.41,8.41,0,0,1-2,5.78c-.17.2.11.48.28.28,3.77-4.54,2.24-10-3.22-12.09-.24-.1-.35.29-.11.38Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.24,201.29h0a.3.3,0,0,0-.16-.58h0a.3.3,0,0,0,.16.58Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.28,220.48a6.71,6.71,0,0,1-1.91.86c-2.11.53-4.46-.46-6.46.39h0c.35-2.15-1.18-4.19-1.17-6.37a6.94,6.94,0,0,1,.38-2.06,5.78,5.78,0,0,1,2.46-3.42,4.58,4.58,0,0,1,3.63-.19,14.24,14.24,0,0,1,5.13,4,4.62,4.62,0,0,1,.68,3.57A5.74,5.74,0,0,1,187.28,220.48Z",
    style: {
      fill: "#d86d18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.06,220.1c-2.11,1.22-3.89.76-6.19.84-.61,0-1.85,0-2.27.49l.75.31h0a.44.44,0,0,0-.56-.42h0l.49.65c.42-.56.05-1.82-.09-2.47-.54-2.4-1.43-4.22-.39-6.69,1.66-3.94,5.16-3.23,7.94-1.06,3.17,2.49,4,5.89.32,8.36-.47.31,0,1.08.44.76,2.32-1.56,3.85-3.79,2.62-6.62a10.14,10.14,0,0,0-6.52-5.17c-2.62-.5-4.61,1-5.61,3.33a7.41,7.41,0,0,0-.64,3.68c.12,1.12,1.85,4.51,1.17,5.43a.45.45,0,0,0,.5.65h0l-.55-.43h0a.44.44,0,0,0,.75.31c.75-.9,4.2,0,5.35-.14a7,7,0,0,0,2.93-1A.44.44,0,0,0,187.06,220.1Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.89,211.61c-.06,2.54.63,5.15,2.76,6.73s5,1.47,7.27.72c.25-.08.14-.47-.11-.39-2,.65-4.66.76-6.49-.36-2.32-1.4-3.09-4.14-3-6.7a.2.2,0,0,0-.4,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.89,220.09h0c-.24.3.18.73.42.43v0c.24-.3-.18-.72-.42-.42Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,216.17a6.56,6.56,0,0,1-2.07-.29c-2.06-.69-3.52-2.79-5.66-3.14h0c1.46-1.62,1.27-4.16,2.44-6a6.92,6.92,0,0,1,1.43-1.53,5.8,5.8,0,0,1,3.92-1.57,4.62,4.62,0,0,1,3.16,1.79,14.15,14.15,0,0,1,2.16,6.14,4.61,4.61,0,0,1-1.33,3.38A5.77,5.77,0,0,1,180,216.17Z",
    style: {
      fill: "#d86d18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,215.73c-2.41-.1-3.64-1.41-5.55-2.56-.48-.29-1.68-1-2.31-.86l.43.74h0c.19-.24.17-.67-.19-.74h0v.85c.54-.21.84-1,1.07-1.51,1.05-2.26.93-4.4,3-6.13,3.71-3.06,6.67-.31,7.89,3.35s-.23,6.76-4.37,6.86c-.56,0-.56.9,0,.88,2.48-.06,4.81-.86,5.59-3.45s-.52-6.42-2.33-8.32c-2-2.17-4.72-2-7-.28a7,7,0,0,0-2.3,2.64c-.45.92-.88,4.75-1.82,5.11-.36.14-.47.76,0,.85h0l-.2-.73h0c-.25.31,0,.88.43.73,1-.3,3.58,2.23,4.34,2.64a7.07,7.07,0,0,0,3.28.81C180.57,216.64,180.57,215.76,180,215.73Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.68,204.2c-3.21,4.85-1.25,10.19,4.47,11.66a.2.2,0,0,0,.11-.39c-5.43-1.39-7.3-6.42-4.24-11.07.15-.22-.2-.42-.34-.2Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,211.88h0c-.36.12-.2.7.16.58h0c.36-.13.21-.71-.16-.58Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.21,198.6a6.6,6.6,0,0,1-.35-2.06c0-2.18,1.58-4.2,1.26-6.36h0c2,.89,4.36-.07,6.46.49a6.73,6.73,0,0,1,1.9.89,5.81,5.81,0,0,1,2.69,3.25,4.66,4.66,0,0,1-.74,3.56,8.41,8.41,0,0,1-2.37,2.27,8.5,8.5,0,0,1-2.82,1.67,4.6,4.6,0,0,1-3.62-.25A5.74,5.74,0,0,1,178.21,198.6Z",
    style: {
      fill: "#d86d18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.64,198.48c-.64-2.33.22-3.9.73-6.06.15-.64.52-1.91.13-2.46l-.5.64h0a.44.44,0,0,0,.56-.42h0l-.75.31c.47.58,2,.51,2.68.53,2.6.06,4.74-.25,6.84,1.73,2.82,2.67,1,5.65-1.58,7.58-3.17,2.4-6.67,2.29-8.11-1.85-.19-.53-1-.3-.85.24.81,2.34,2.27,4.32,5,4.28s5.93-2.45,7.22-4.74a4.82,4.82,0,0,0-1.32-6.36,7.55,7.55,0,0,0-3.37-1.73c-1.24-.24-5.11.63-5.87-.3a.44.44,0,0,0-.75.31h0l.56-.42h0a.45.45,0,0,0-.5.65c.58.82-1,4.06-1.17,4.94a7,7,0,0,0,.22,3.38A.44.44,0,0,0,178.64,198.48Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.92,192.73c-2.44-.7-5.14-.69-7.21,1s-2.68,4.44-2.54,6.85c0,.26.41.26.4,0-.12-2.07.45-4.7,2-6.19,1.95-1.88,4.79-1.94,7.25-1.23a.2.2,0,0,0,.11-.39Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.46,191.55v0c-.23-.3-.75,0-.52.31h0c.24.31.76,0,.52-.3Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.27,207.74a6.5,6.5,0,0,1-1.51-1.45c-1.27-1.77-1.21-4.32-2.75-5.87h0c2.13-.46,3.47-2.64,5.5-3.43a6.79,6.79,0,0,1,2.05-.41,5.78,5.78,0,0,1,4.09,1,4.62,4.62,0,0,1,1.52,3.3,14.17,14.17,0,0,1-1.85,6.25,4.65,4.65,0,0,1-3.06,2A5.77,5.77,0,0,1,176.27,207.74Z",
    style: {
      fill: "#d86d18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.58,207.43c-1.85-1.47-2.17-3.31-3.05-5.36-.24-.56-.73-1.85-1.4-2.07v.85h0a.45.45,0,0,0,.19-.74h0l-.43.73c.69.18,1.74-.61,2.27-1,2-1.31,3.2-2.81,5.77-2.87,4.08-.09,5.29,3.12,4.38,6.62-1,4-3.85,6.42-7.82,3.73-.47-.31-.91.45-.45.76,2.34,1.58,5,2.1,7.11-.08a10.06,10.06,0,0,0,2.35-8c-.55-2.59-2.66-3.89-5.21-3.93a7.59,7.59,0,0,0-3.66.8c-1.11.6-3.34,3.38-4.5,3.07a.45.45,0,0,0-.43.74h0l.2-.73h0a.45.45,0,0,0,0,.85c.93.3,1.43,3.53,1.81,4.38a7,7,0,0,0,2.26,2.82C176.39,208.4,177,207.78,176.58,207.43Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.43,196.67c-5.46,2.06-7,7.55-3.22,12.09.16.2.45-.08.28-.28a8.3,8.3,0,0,1-2-5.78c.28-2.91,2.53-4.68,5.09-5.65.24-.09.13-.48-.11-.38Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.86,200.71h0a.3.3,0,0,0-.16.58h0a.3.3,0,0,0,.16-.58Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.68,219.84a7.16,7.16,0,0,0,1,1.86c1.34,1.71,3.81,2.39,4.85,4.29h0c1.05-1.9,3.51-2.58,4.85-4.29a6.87,6.87,0,0,0,1-1.86,5.74,5.74,0,0,0,.18-4.21,4.63,4.63,0,0,0-2.74-2.39,14.5,14.5,0,0,0-6.51,0,4.61,4.61,0,0,0-2.74,2.39A5.79,5.79,0,0,0,185.68,219.84Z",
    style: {
      fill: "#d86d18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.26,220a7.09,7.09,0,0,0,1.84,2.82c.85.77,3.92,2.18,4,3.22a.44.44,0,0,0,.82.22h-.76a.44.44,0,0,0,.82-.22c0-1.16,3.34-2.54,4.24-3.45a7.5,7.5,0,0,0,1.83-3.42c.65-2.59-.15-5-2.68-6.12a10.26,10.26,0,0,0-8,.15c-2.71,1.43-2.92,4.13-2.08,6.8.17.54,1,.31.85-.24-1.39-4.38,1.48-6.4,5.39-6.41s7,2,5.4,6.41c-.83,2.26-2.58,3-4.28,4.38-.49.41-1.54,1.19-1.56,1.9l.82-.22h0a.45.45,0,0,0-.76,0h0l.82.22c0-.68-1.13-1.54-1.55-1.9-1.69-1.41-3.39-2.18-4.28-4.38C185.9,219.21,185.05,219.43,185.26,220Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.43,217.82c-1.64,2.16-4,3.83-6.86,3.27a8.42,8.42,0,0,1-5-3.6c-.14-.21-.49,0-.34.2,3.29,4.91,9,5,12.51.33.16-.21-.19-.41-.34-.2Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.15,224.13v0a.3.3,0,0,0,.6,0v0a.3.3,0,0,0-.6,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,192.25a6.87,6.87,0,0,0-1-1.86c-1.34-1.72-3.8-2.39-4.85-4.29h0c-1,1.9-3.51,2.57-4.85,4.29a7.16,7.16,0,0,0-1,1.86,5.79,5.79,0,0,0-.17,4.21,4.61,4.61,0,0,0,2.74,2.39,14.5,14.5,0,0,0,6.51,0,4.63,4.63,0,0,0,2.74-2.39A5.74,5.74,0,0,0,197.32,192.25Z",
    style: {
      fill: "#d86d18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,192.13a7,7,0,0,0-1.84-2.82c-.83-.76-3.93-2.2-4-3.22a.44.44,0,0,0-.82-.22h.76a.44.44,0,0,0-.82.22c-.05,1.19-3.32,2.53-4.23,3.45A7.36,7.36,0,0,0,185,193c-.65,2.59.15,5,2.68,6.12a10.26,10.26,0,0,0,8-.15c2.7-1.43,2.92-4.13,2.07-6.8-.17-.54-1-.31-.84.23,1.39,4.39-1.49,6.41-5.4,6.42s-7-2-5.39-6.42c.83-2.25,2.58-3,4.28-4.37.49-.42,1.52-1.18,1.55-1.9l-.82.22h0a.45.45,0,0,0,.76,0h0l-.82-.22c0,.67,1.14,1.55,1.56,1.9,1.69,1.41,3.39,2.18,4.28,4.37C197.11,192.88,198,192.66,197.74,192.13Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.58,194.27c1.64-2.16,4-3.83,6.86-3.27a8.37,8.37,0,0,1,5,3.6c.14.21.49,0,.35-.21-3.29-4.9-9-5-12.52-.32-.16.2.19.4.35.2Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.86,188v0a.3.3,0,0,0-.6,0v0a.3.3,0,0,0,.6,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.6,
    cy: 205.76,
    r: 12.95,
    transform: "translate(-89.38 195.75) rotate(-45)",
    style: {
      fill: "#e3a519"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.66 199.13 202.58 199.13 191.6 218.44 180.66 199.13",
    style: {
      fill: "none",
      stroke: "#bc5108",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.469373px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.6,218.28c-6.77-.35-12.51-5.47-12.51-12.52a12.48,12.48,0,0,1,24.9-1.25c.73,7.54-5.05,13.4-12.39,13.77-.56,0-.57.9,0,.88,7.28-.37,13.39-5.83,13.39-13.4a13.39,13.39,0,0,0-26.78,0c0,7.57,6.11,13,13.39,13.4C192.17,219.18,192.16,218.3,191.6,218.28Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.67,201.59h11.86a1.18,1.18,0,0,0,0-2.35H185.67a1.18,1.18,0,0,0,0,2.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.58,200.51a42.06,42.06,0,0,1-.08,6.35c-.14,1.08-.92,3.41-2.45,2.73-.82-.36-.09-1.86.56-2.19a2.3,2.3,0,0,1,2.09.12c1.34.69,2.53-1.34,1.19-2a4.68,4.68,0,0,0-5.9,1,3.54,3.54,0,0,0,.65,5.21c2,1.2,4.46-.23,5.5-2,1.44-2.45.85-6.51.79-9.2a1.18,1.18,0,0,0-2.35,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.49,212.06l.59.42s-.25-.2,0,0l.22.18c1.09.84,2.21,1.65,3.32,2.46s2.4-1.15,1.18-2l-2.21-1.62L192,211l-.14-.11q-.57-.45-1.17-.87c-1.25-.85-2.42,1.18-1.18,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.38,198.44a1.17,1.17,0,0,0,0-2.34,1.17,1.17,0,0,0,0,2.34Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("a", {
    href: "/Anahata"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Anahata",
    className: "chakraAnimated"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.23,167.81a6.85,6.85,0,0,0,1.93-.82c1.81-1.19,2.68-3.59,4.67-4.48h0c-1.82-1.19-2.29-3.7-3.89-5.17a6.6,6.6,0,0,0-1.78-1.12,5.73,5.73,0,0,0-4.18-.51,4.61,4.61,0,0,0-2.6,2.53,8.45,8.45,0,0,0-.64,3.22,8.24,8.24,0,0,0,.12,3.28,4.54,4.54,0,0,0,2.15,2.91A5.79,5.79,0,0,0,205.23,167.81Z",
    style: {
      fill: "#70af1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.34,168.23a6.89,6.89,0,0,0,3-1.62c.69-.66,2.52-3.71,3.53-3.66.48,0,.55-.59.22-.82h0v.76h0c.42-.22.16-.77-.23-.82-1-.13-2.29-3.55-3-4.43a6.8,6.8,0,0,0-2.53-1.84c-2.52-1.15-5.36-1-6.93,1.56a10.19,10.19,0,0,0-.63,8.31c1.23,2.78,3.88,3.2,6.62,2.57.56-.12.32-1-.23-.84-4.39,1-6.25-2-5.93-5.94.35-4.1,3.17-7,7.39-4.54,2,1.16,2.44,3.17,3.84,4.85.35.42.83,1.11,1.42,1.19l-.22-.82h0a.44.44,0,0,0,0,.76h0l.22-.82c-.64,0-1.65,1.05-2,1.42-1.53,1.59-2.45,3.18-4.72,3.9C204.57,167.55,204.8,168.4,205.34,168.23Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.13,155.92c2,1.78,3.56,4.34,2.79,7.13a8.65,8.65,0,0,1-4,4.66c-.23.12,0,.47.2.34,5.14-2.87,5.68-8.54,1.34-12.42-.19-.17-.47.12-.28.29Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,162.71h0c.38,0,.38-.57,0-.6h0c-.39,0-.39.57,0,.6Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,175.87a6.86,6.86,0,0,0,1.72,1.21c2,.91,4.47.37,6.28,1.59h0c.05-2.17,1.93-3.9,2.33-6a6.66,6.66,0,0,0,0-2.09,5.75,5.75,0,0,0-1.78-3.83,4.64,4.64,0,0,0-3.53-.86A8.33,8.33,0,0,0,195,167a8.47,8.47,0,0,0-2.72,1.83,4.61,4.61,0,0,0-1.34,3.38A5.75,5.75,0,0,0,193,175.87Z",
    style: {
      fill: "#70af1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.67,176.18a7.18,7.18,0,0,0,2.94,1.66c1.15.3,4.44.07,5,1a.44.44,0,0,0,.82-.22h0l-.66.38h0a.44.44,0,0,0,.6-.6c-.49-1,1.84-3.85,2.19-5a7.41,7.41,0,0,0,.08-3.74c-.58-2.66-2.4-4.49-5.24-4.32a10.1,10.1,0,0,0-7.21,4.13c-1.48,2.48-.39,4.81,1.49,6.67.41.4,1-.22.62-.62-3.13-3.09-1.75-6.36,1.88-8.18,3.07-1.54,6.7-1.66,7.61,2.55.55,2.58-.69,4.25-1.64,6.45-.24.57-.87,1.86-.54,2.51l.6-.6h0a.44.44,0,0,0-.66.38h0l.82-.22c-.32-.57-1.75-.85-2.26-1-2.16-.47-4-.37-5.81-1.93C192.87,175.19,192.24,175.81,192.67,176.18Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.49,168.64c-.38,2.3-1.38,4.55-3.53,5.71s-5.05.62-7.13-.53c-.23-.12-.43.22-.21.35,5.16,2.83,10.3.31,11.26-5.42,0-.26-.34-.37-.39-.11Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.81,177.19v0c.18.34.7,0,.52-.31h0c-.18-.35-.7,0-.52.3Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.72,173.57a6.68,6.68,0,0,0,2.08.27c2.17-.1,4.14-1.73,6.3-1.48h0c-.95-2-.08-4.36-.71-6.44a6.84,6.84,0,0,0-1-1.86,5.72,5.72,0,0,0-3.34-2.57,4.59,4.59,0,0,0-3.53.86,14.27,14.27,0,0,0-3.75,5.32,4.59,4.59,0,0,0,.37,3.61A5.78,5.78,0,0,0,199.72,173.57Z",
    style: {
      fill: "#70af1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6,174a7.16,7.16,0,0,0,3.38.11c1-.22,4.08-1.89,4.9-1.36.31.2.79-.13.65-.49h0l-.43.56h0c.48,0,.53-.59.22-.82-.8-.61-.16-4.35-.35-5.38a7.31,7.31,0,0,0-1.67-3.43c-1.75-2.1-4.22-2.86-6.65-1.4a10.12,10.12,0,0,0-4.47,7c-.16,2.88,1.89,4.43,4.41,5.21.55.17.78-.68.24-.85-3.82-1.18-4.53-4.22-2.58-7.46s5.44-5.4,8.37-1.92c1.74,2.07,1.38,4.18,1.58,6.66.06.71.06,1.85.67,2.32l.23-.82h0a.44.44,0,0,0-.42.56h0l.65-.5c-.55-.35-1.87.05-2.46.21-2.12.59-3.72,1.5-6,.95C199.29,173,199.05,173.86,199.6,174Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,162.77c.78,2.41.86,5.3-1,7.29a8.4,8.4,0,0,1-6.12,2.22c-.26,0-.26.39,0,.4,2.42,0,5.26-.76,6.76-2.77s1.5-4.83.72-7.24c-.08-.25-.47-.14-.39.1Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4,171.59h0c.32.23.62-.29.31-.52h0c-.32-.22-.62.3-.3.52Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.44,151.5a6.66,6.66,0,0,0,0-2.09c-.37-2.15-2.23-3.9-2.25-6.07h0c-1.83,1.2-4.32.63-6.3,1.51a6.8,6.8,0,0,0-1.73,1.18,5.71,5.71,0,0,0-2.14,3.64,4.61,4.61,0,0,0,1.29,3.39,8.45,8.45,0,0,0,2.69,1.87,8.53,8.53,0,0,0,3,1.2,4.58,4.58,0,0,0,3.54-.82A5.73,5.73,0,0,0,203.44,151.5Z",
    style: {
      fill: "#70af1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.88,151.5a7.09,7.09,0,0,0-.43-3.59c-.34-.88-2.26-3.54-1.86-4.36a.44.44,0,0,0-.6-.6h0l.66.38h0a.44.44,0,0,0-.82-.22c-.62,1.06-4.14.68-5.36,1.06a7.44,7.44,0,0,0-3.13,2c-1.77,1.87-2.35,4.29-.83,6.52a10,10,0,0,0,7.68,3.87c2.89-.16,4.21-2.37,4.68-5,.09-.55-.75-.79-.85-.23-.32,1.76-.84,3.5-2.84,4.16-1.76.59-3.42-.22-4.94-1-3.07-1.61-5.13-4.68-2.28-7.7,1.66-1.76,3.43-1.92,5.64-2.25.74-.12,2.53-.25,3-1l-.82-.22h0a.44.44,0,0,0,.66.38h0l-.6-.6c-.32.65.25,1.89.49,2.46.84,2.06,1.93,3.58,1.68,5.93C202.94,152.06,203.82,152.06,203.88,151.5Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.12,147.76c5.06-2.33,9.73.33,10.29,5.84,0,.26.42.26.4,0-.6-5.88-5.55-8.65-10.89-6.19-.23.11,0,.45.2.35Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,145.16v0c.18-.34-.34-.65-.52-.3h0c-.18.34.34.65.52.31Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.67,158.63a6.8,6.8,0,0,0,1.07-1.79c.77-2,0-4.49,1.13-6.38h0c-2.17.11-4-1.64-6.2-1.88a6.69,6.69,0,0,0-2.09.15,5.74,5.74,0,0,0-3.68,2.05,4.58,4.58,0,0,0-.6,3.58,14.32,14.32,0,0,0,3.4,5.55,4.62,4.62,0,0,0,3.47,1.09A5.81,5.81,0,0,0,206.67,158.63Z",
    style: {
      fill: "#70af1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.05,158.85a6.92,6.92,0,0,0,1.4-3.08c.19-1.05-.12-4.44.65-4.94a.45.45,0,0,0-.23-.82h0l.38.67h0a.44.44,0,0,0-.6-.6c-1,.6-3.93-1.5-5.15-1.79a7.42,7.42,0,0,0-3.74.18c-2.48.72-4.19,2.51-4,5.21a10,10,0,0,0,4.67,7.21c2.57,1.32,4.83.09,6.55-1.94.37-.43-.25-1.05-.62-.62-1.16,1.36-2.49,2.6-4.55,2.16-1.81-.38-2.86-1.92-3.75-3.38-1.79-2.94-2.11-6.61,1.93-7.79,2.32-.68,3.92.08,6,.91.69.27,2.33,1.07,3.11.61l-.6-.6h0a.44.44,0,0,0,.38.66h0l-.22-.82c-.45.3-.65,1.42-.74,1.89-.44,2.32-.12,4.42-1.62,6.45C206,158.87,206.72,159.31,207.05,158.85Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,149.68c5.48.51,8.25,5.15,5.91,10.24-.1.24.24.44.35.21,2.47-5.4-.44-10.31-6.26-10.85-.26,0-.26.38,0,.4Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.46,151.74h0c.33-.2,0-.72-.3-.52h0c-.33.2,0,.72.3.52Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.78,167.81a6.61,6.61,0,0,1-1.93-.82c-1.82-1.19-2.69-3.59-4.68-4.48h0c1.82-1.19,2.29-3.7,3.9-5.17a6.4,6.4,0,0,1,1.77-1.12,5.75,5.75,0,0,1,4.19-.51,4.6,4.6,0,0,1,2.59,2.53,14.32,14.32,0,0,1,.53,6.5,4.58,4.58,0,0,1-2.16,2.91A5.76,5.76,0,0,1,177.78,167.81Z",
    style: {
      fill: "#70af1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.89,167.39c-2.3-.73-3.16-2.31-4.71-3.9-.39-.4-1.36-1.45-2-1.42l.22.82h0a.44.44,0,0,0,0-.76h0l-.22.82c.59-.08,1.06-.76,1.42-1.19,1.4-1.67,1.82-3.69,3.84-4.85a6,6,0,0,1,5-.52c1.9.78,2.2,3.35,2.34,5.06.32,3.93-1.54,7-5.93,5.94-.55-.13-.78.72-.23.84,2.72.63,5.4.21,6.63-2.57a10.11,10.11,0,0,0-.64-8.31c-1.6-2.52-4.37-2.72-6.93-1.56a6.88,6.88,0,0,0-2.53,1.84c-.7.82-2,4.3-3,4.43-.39.05-.65.6-.22.82h0v-.76h0c-.33.23-.25.84.22.82,1,0,2.9,3.06,3.53,3.66a7,7,0,0,0,3,1.62C178.2,168.4,178.43,167.55,177.89,167.39Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.59,155.63c-4.33,3.87-3.79,9.55,1.35,12.42.22.13.42-.22.2-.34a8.7,8.7,0,0,1-4.06-4.66c-.76-2.77.8-5.35,2.79-7.13.2-.17-.09-.46-.28-.29Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,162.11h0c-.39,0-.39.64,0,.6h0c.38,0,.38-.63,0-.6Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,175.87a7,7,0,0,1-1.71,1.21c-2,.91-4.48.37-6.28,1.59h0c-.05-2.17-1.93-3.9-2.33-6a6.66,6.66,0,0,1,0-2.09,5.84,5.84,0,0,1,1.78-3.83,4.65,4.65,0,0,1,3.53-.86,8.37,8.37,0,0,1,3.07,1.16,8.69,8.69,0,0,1,2.72,1.83,4.6,4.6,0,0,1,1.33,3.38A5.75,5.75,0,0,1,190,175.87Z",
    style: {
      fill: "#70af1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.71,175.56c-1.81,1.55-3.65,1.47-5.81,1.93-.55.12-1.94.39-2.26,1l.82.22h0a.44.44,0,0,0-.66-.38h0l.6.6c.32-.66-.28-1.93-.53-2.51-1-2.19-2.19-3.9-1.64-6.45.91-4.25,4.53-4.09,7.6-2.55,3.63,1.83,5,5.08,1.88,8.18-.41.4.22,1,.62.62,1.77-1.74,2.91-3.92,1.69-6.35s-4.78-4.3-7.4-4.45a4.82,4.82,0,0,0-5.15,4,7.45,7.45,0,0,0-.11,3.75c.32,1.24,2.76,4.35,2.28,5.36-.18.38.2.84.6.6h0l-.67-.38h0a.44.44,0,0,0,.82.22c.53-.93,4-.78,5-1a7,7,0,0,0,2.94-1.66C190.76,175.81,190.14,175.19,189.71,175.56Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.12,168.75c1,5.73,6.1,8.25,11.26,5.42a.2.2,0,0,0-.2-.35c-2.09,1.15-5,1.71-7.14.53s-3.15-3.41-3.53-5.71c0-.26-.43-.15-.39.11Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,176.89h0c-.17.35.34.65.52.31v0c.18-.34-.34-.65-.52-.3Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.28,173.57a6.62,6.62,0,0,1-2.07.27c-2.18-.1-4.15-1.73-6.31-1.48h0c1-2,.08-4.36.72-6.44a6.54,6.54,0,0,1,.95-1.86,5.71,5.71,0,0,1,3.35-2.57,4.57,4.57,0,0,1,3.52.86,8.27,8.27,0,0,1,2.19,2.44,8.43,8.43,0,0,1,1.57,2.88,4.63,4.63,0,0,1-.37,3.61A5.8,5.8,0,0,1,183.28,173.57Z",
    style: {
      fill: "#70af1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.16,173.14c-2.34.55-3.89-.37-6-.95-.64-.18-1.88-.58-2.45-.21l.6.61h0c.12-.27,0-.69-.38-.66h0l.31.75c.59-.46.57-1.94.61-2.66.15-2.62-.06-4.72,2-6.77,5-5,14.1,7.2,5.36,9.9-.53.17-.3,1,.24.85,2.36-.73,4.39-2.13,4.44-4.84s-2.26-6-4.5-7.38a4.83,4.83,0,0,0-6.4,1.12,7.64,7.64,0,0,0-1.84,3.31c-.29,1.26.47,5.08-.52,5.85a.45.45,0,0,0,.32.75h0l-.38-.66h0c-.16.37.19.87.6.6.83-.54,4,1.15,4.9,1.36a7,7,0,0,0,3.38-.11C184,173.86,183.72,173,183.16,173.14Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.79,162.67c-.78,2.41-.87,5.11.71,7.24s4.35,2.82,6.76,2.77c.26,0,.26-.41,0-.4a8.41,8.41,0,0,1-6.12-2.22c-1.83-2-1.74-4.88-1-7.29.08-.24-.3-.35-.38-.1Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3,171.07h0c-.32.22,0,.75.3.52h0c.31-.22,0-.74-.31-.52Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.56,151.5a6.66,6.66,0,0,1,0-2.09c.37-2.15,2.23-3.9,2.25-6.07h0c1.82,1.2,4.31.63,6.3,1.51a7,7,0,0,1,1.73,1.18,5.79,5.79,0,0,1,2.14,3.64,4.61,4.61,0,0,1-1.29,3.39,8.6,8.6,0,0,1-2.7,1.87,8.46,8.46,0,0,1-3,1.2,4.58,4.58,0,0,1-3.54-.82A5.73,5.73,0,0,1,179.56,151.5Z",
    style: {
      fill: "#70af1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,151.5c-.25-2.35.84-3.87,1.69-5.93.23-.58.79-1.8.48-2.46l-.6.6h0a.45.45,0,0,0,.67-.38h0l-.82.22c.44.79,2.25.92,3,1,2.23.34,4,.49,5.64,2.25,2.86,3,.78,6.1-2.28,7.7-1.52.79-3.17,1.6-4.94,1-2-.66-2.52-2.4-2.83-4.16-.1-.56-1-.33-.85.23.44,2.46,1.6,4.6,4.29,5s6.53-1.62,8.06-3.85a4.83,4.83,0,0,0-.59-6.24,7.6,7.6,0,0,0-3-2.2c-1.2-.43-5.12-.15-5.69-1.18a.44.44,0,0,0-.82.22h0L182,143h0a.45.45,0,0,0-.61.6c.42.9-1.51,3.48-1.86,4.36a7.09,7.09,0,0,0-.43,3.59C179.18,152.06,180.06,152.07,180,151.5Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.08,147.41c-5.34-2.46-10.29.31-10.88,6.19,0,.26.37.26.4,0,.55-5.51,5.23-8.17,10.28-5.84.23.1.44-.24.2-.35Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.88,144.85h0c-.18-.35-.7,0-.52.3v0c.19.34.71,0,.52-.31Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.33,158.63a7.08,7.08,0,0,1-1.07-1.79c-.76-2,0-4.49-1.13-6.38h0c2.18.11,4-1.64,6.2-1.88a6.69,6.69,0,0,1,2.09.15,5.71,5.71,0,0,1,3.68,2.05,4.58,4.58,0,0,1,.61,3.58,8.43,8.43,0,0,1-1.39,3,8.24,8.24,0,0,1-2,2.58,4.61,4.61,0,0,1-3.47,1.09A5.83,5.83,0,0,1,176.33,158.63Z",
    style: {
      fill: "#70af1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.71,158.41c-1.52-2.06-1.16-4.12-1.61-6.45-.11-.54-.26-1.56-.75-1.89l-.22.82h0a.44.44,0,0,0,.38-.66h0l-.6.6c.78.46,2.42-.34,3.11-.61,2.09-.83,3.67-1.59,6-.91,4.08,1.19,3.74,4.86,1.93,7.79-.9,1.46-1.94,3-3.75,3.38-2.06.44-3.39-.8-4.55-2.16-.36-.43-1,.19-.62.62,1.63,1.91,3.71,3.17,6.22,2.11s4.81-4.7,5-7.38a4.83,4.83,0,0,0-3.65-5.09,7.53,7.53,0,0,0-3.73-.37c-1.26.23-4.5,2.45-5.51,1.86a.44.44,0,0,0-.6.6h0l.38-.67h0a.44.44,0,0,0-.22.82c.77.52.47,3.94.64,4.94a7,7,0,0,0,1.4,3.08C176.29,159.31,177.05,158.87,176.71,158.41Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.21,149.28c-5.83.54-8.74,5.45-6.27,10.85.11.23.46,0,.35-.21-2.33-5.09.43-9.73,5.92-10.24.25,0,.25-.42,0-.4Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.84,151.22h0a.3.3,0,0,0-.31.52h0c.33.2.63-.32.3-.52Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.68,174.72a7,7,0,0,0,1,1.85c1.34,1.72,3.81,2.39,4.85,4.3h0c1.05-1.91,3.51-2.58,4.85-4.3a6.67,6.67,0,0,0,1-1.85,5.77,5.77,0,0,0,.18-4.22,4.62,4.62,0,0,0-2.74-2.38,14.13,14.13,0,0,0-6.51,0,4.59,4.59,0,0,0-2.74,2.38A5.82,5.82,0,0,0,185.68,174.72Z",
    style: {
      fill: "#70af1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.26,174.84a7.16,7.16,0,0,0,1.84,2.82c.85.77,3.92,2.18,4,3.22a.44.44,0,0,0,.82.22h-.76a.44.44,0,0,0,.82-.22c0-1.16,3.34-2.54,4.24-3.46A7.4,7.4,0,0,0,198,174c.65-2.58-.15-5-2.68-6.11a10.21,10.21,0,0,0-8,.15c-2.71,1.43-2.92,4.13-2.08,6.8.17.53,1,.3.85-.24-1.39-4.38,1.48-6.4,5.39-6.42s7,2,5.4,6.42c-.83,2.25-2.58,3-4.28,4.38-.49.41-1.54,1.19-1.56,1.9l.82-.23h0a.45.45,0,0,0-.76,0h0l.82.23c0-.68-1.13-1.54-1.55-1.9-1.69-1.41-3.39-2.18-4.28-4.38C185.9,174.08,185.05,174.31,185.26,174.84Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.43,172.7c-1.64,2.16-4,3.82-6.86,3.27a8.42,8.42,0,0,1-5-3.6c-.14-.21-.49,0-.34.2,3.29,4.91,9,5,12.51.33.16-.21-.19-.41-.34-.2Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.15,179v0a.3.3,0,0,0,.6,0v0a.3.3,0,0,0-.6,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,147.13a6.73,6.73,0,0,0-1-1.86c-1.34-1.72-3.8-2.39-4.85-4.3h0c-1,1.91-3.51,2.58-4.85,4.3a7,7,0,0,0-1,1.86,5.79,5.79,0,0,0-.17,4.21,4.64,4.64,0,0,0,2.74,2.39,14.5,14.5,0,0,0,6.51,0,4.67,4.67,0,0,0,2.74-2.39A5.74,5.74,0,0,0,197.32,147.13Z",
    style: {
      fill: "#70af1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,147a7.09,7.09,0,0,0-1.84-2.83c-.83-.75-3.93-2.2-4-3.21a.44.44,0,0,0-.82-.22h.76a.44.44,0,0,0-.82.22c-.05,1.19-3.32,2.52-4.23,3.45a7.36,7.36,0,0,0-1.83,3.42c-.65,2.59.15,5,2.68,6.12a10.26,10.26,0,0,0,8-.15c2.7-1.43,2.92-4.13,2.07-6.8-.17-.54-1-.31-.84.23,1.39,4.39-1.49,6.41-5.4,6.42s-7-2-5.39-6.42c.83-2.25,2.58-3,4.28-4.38.49-.41,1.52-1.17,1.55-1.89l-.82.22h0a.44.44,0,0,0,.76,0h0l-.82-.22c0,.67,1.14,1.55,1.56,1.89,1.69,1.42,3.39,2.18,4.28,4.38C197.11,147.76,198,147.53,197.74,147Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.58,149.15c1.64-2.17,4-3.83,6.86-3.28a8.41,8.41,0,0,1,5,3.6c.14.22.49,0,.35-.2-3.29-4.91-9-5-12.52-.32-.16.2.19.4.35.2Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.86,142.84v0a.3.3,0,0,0-.6,0v0a.3.3,0,0,0,.6,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.6,
    cy: 160.64,
    r: 12.95,
    transform: "translate(-8.96 309.94) rotate(-76.64)",
    style: {
      fill: "#b9d40b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.58 167.21 180.66 167.21 191.64 147.91 202.58 167.21",
    style: {
      fill: "none",
      stroke: "#097609",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.469373px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.66 154.01 202.58 154.01 191.6 173.31 180.66 154.01",
    style: {
      fill: "none",
      stroke: "#097609",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.469373px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.6,173.15c-6.77-.34-12.51-5.46-12.51-12.51a12.48,12.48,0,0,1,24.9-1.25c.73,7.53-5.05,13.39-12.39,13.76-.56,0-.57.91,0,.88,7.28-.36,13.39-5.82,13.39-13.39a13.39,13.39,0,0,0-26.78,0c0,7.56,6.11,13,13.39,13.39C192.17,174.06,192.16,173.18,191.6,173.15Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.52,157.09h11.9a1.18,1.18,0,0,0,0-2.35h-11.9a1.18,1.18,0,0,0,0,2.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89,158.69c-.69,2.05-2,3.47-.95,5.7a5.49,5.49,0,0,0,4.38,3,6,6,0,0,0,5.08-1.89c1.6-1.74,1.44-3.85,1.8-6l-2.3-.31.27,9.08c0,1.51,2.39,1.52,2.34,0l-.27-9.08c0-1.26-2.07-1.67-2.3-.31-.42,2.48-.15,5.71-3.41,6.18a3.19,3.19,0,0,1-3.62-2.07c-.31-1.23.86-2.52,1.24-3.68.49-1.43-1.78-2.05-2.26-.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.73,153.64a1.18,1.18,0,0,0,0-2.35,1.18,1.18,0,0,0,0,2.35Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("a", {
    href: "/Svadhisthana"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Svadhisthana",
    className: "chakraAnimated"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.83,238.93a9.53,9.53,0,0,0-3.06-.15c-3.16.41-5.83,3-9,2.94h0c1.64,2.73.66,6.34,1.84,9.3a9.65,9.65,0,0,0,1.63,2.6,8.46,8.46,0,0,0,5.19,3.35,6.76,6.76,0,0,0,5-1.69,12.3,12.3,0,0,0,2.89-3.84,12.16,12.16,0,0,0,1.93-4.39,6.74,6.74,0,0,0-1-5.22A8.39,8.39,0,0,0,183.83,238.93Z",
    style: {
      fill: "#ff7000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,238.5a10.25,10.25,0,0,0-4.83.23c-1.7.54-5.65,3.39-7.15,2.6a.45.45,0,0,0-.6.61l.38-.66a.44.44,0,0,0-.22.82c1.56,1,.81,6.17,1.32,8a10.57,10.57,0,0,0,2.76,4.6c2.72,2.77,6.31,3.63,9.62,1.25,3-2.12,5.68-6.88,5.61-10.57-.08-4.14-3.2-6.1-6.89-6.91-.55-.12-.79.73-.23.85,6.58,1.44,7.33,6.64,4.24,11.87-2.67,4.5-7.17,7.46-11.73,2.89-2.77-2.78-2.54-5.89-3.09-9.42-.13-.78-.36-2.83-1.17-3.35l-.22.82h0a.45.45,0,0,0,.38-.67h0l-.6.6c.8.43,2.72-.33,3.39-.58,3.07-1.11,5.32-2.67,8.8-2.16C184.27,239.43,184.51,238.59,184,238.5Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.72,255.32c-1.52-3.68-1.94-8.11.94-11.3,2-2.15,5.35-3.28,8.2-3.45.38,0,.38-.61,0-.59-8.58.52-13,7.59-9.71,15.5.15.34.71.19.57-.16Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.37,242.65l0,0a.44.44,0,0,0-.45.76l0,0a.44.44,0,0,0,.44-.76Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.57,238.93a9.54,9.54,0,0,1,3.06-.15c3.16.41,5.83,3,9,2.94h0c-1.64,2.73-.66,6.34-1.84,9.3a9.65,9.65,0,0,1-1.63,2.6A8.43,8.43,0,0,1,203,257a6.76,6.76,0,0,1-5-1.69,12.3,12.3,0,0,1-2.89-3.84,12.16,12.16,0,0,1-1.93-4.39,6.74,6.74,0,0,1,1-5.22A8.39,8.39,0,0,1,199.57,238.93Z",
    style: {
      fill: "#ff7000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.68,239.35c3.47-.51,5.75,1,8.8,2.16.72.27,2.6,1,3.39.58l-.6-.6h0a.45.45,0,0,0,.38.67h0l-.22-.82c-.81.5-1.05,2.58-1.16,3.35-.53,3.52-.36,6.66-3.1,9.42-4.59,4.6-9.08,1.62-11.73-2.89-3.07-5.24-2.35-10.42,4.24-11.87.56-.12.32-1-.23-.85-3.46.76-6.5,2.5-6.88,6.36s2.54,8.92,5.6,11.12,6.54,1.66,9.23-.88a10.86,10.86,0,0,0,3-4.46c.62-1.9-.07-7.57,1.48-8.54a.44.44,0,0,0-.22-.82l.38.66a.45.45,0,0,0-.6-.61c-1.42.75-5.6-2.11-7.14-2.6a10.29,10.29,0,0,0-4.84-.23C198.89,238.59,199.13,239.43,199.68,239.35Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.25,255.48c3.26-7.9-1.11-15-9.71-15.5-.38,0-.38.56,0,.59,2.85.17,6.25,1.3,8.2,3.45,2.89,3.19,2.46,7.62.94,11.3-.14.35.43.5.57.16Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.47,243.41l0,0a.44.44,0,0,0-.45-.76l0,0a.44.44,0,0,0,.44.76Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.82,240.23a9.54,9.54,0,0,0-1.42-2.72c-2-2.51-5.56-3.5-7.09-6.29h0c-1.53,2.79-5.14,3.78-7.09,6.29a9.8,9.8,0,0,0-1.42,2.72,8.41,8.41,0,0,0-.26,6.17,6.74,6.74,0,0,0,4,3.49,12.18,12.18,0,0,0,4.77.55,12.15,12.15,0,0,0,4.76-.55,6.71,6.71,0,0,0,4-3.49A8.41,8.41,0,0,0,199.82,240.23Z",
    style: {
      fill: "#ff7000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.25,240.11a10.39,10.39,0,0,0-2.64-4.05c-1.31-1.17-5.81-3.2-5.86-4.85a.44.44,0,0,0-.82-.22h.75a.44.44,0,0,0-.82.22c-.05,1.87-4.87,3.79-6.26,5.2a10.66,10.66,0,0,0-2.62,4.92c-.92,3.7.2,7.11,3.83,8.72a14.78,14.78,0,0,0,11.49-.21c3.88-2.05,4.16-5.91,2.95-9.73-.17-.54-1-.31-.85.23,2.08,6.56-2.24,9.64-8.09,9.66s-10.51-3.07-8.1-9.66c1.23-3.34,3.8-4.39,6.32-6.49.66-.55,2.18-1.67,2.21-2.64l-.82.23h0a.44.44,0,0,0,.76,0h0l-.82-.23c0,.9,1.68,2.19,2.21,2.64,2.51,2.09,5,3.23,6.32,6.49C199.61,240.86,200.46,240.64,200.25,240.11Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.63,243.19c2.4-3.17,5.88-5.6,10.05-4.8a12.29,12.29,0,0,1,7.26,5.28c.21.31.72,0,.51-.3-4.82-7.18-13.17-7.28-18.33-.48-.23.31.28.6.51.3Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.83,234v0a.44.44,0,0,0-.88,0v0a.44.44,0,0,0,.88,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.49,253.29a9.94,9.94,0,0,1,1.78,2.49c1.36,2.88.61,6.55,2.41,9.17h0c-3.18.1-5.69,2.88-8.82,3.49a9.81,9.81,0,0,1-3.06,0,8.47,8.47,0,0,1-5.63-2.55,6.76,6.76,0,0,1-1.3-5.16,12.14,12.14,0,0,1,1.66-4.5,12.27,12.27,0,0,1,2.64-4,6.78,6.78,0,0,1,4.92-2A8.51,8.51,0,0,1,207.49,253.29Z",
    style: {
      fill: "#ff7000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.18,253.6c2.32,2.66,2.25,5.37,2.95,8.57.16.72.57,2.74,1.34,3.17l.22-.82h0a.44.44,0,0,0-.38.66h0l.6-.6c-.89-.41-2.72.48-3.46.81-3.25,1.47-5.78,3.3-9.59,2.52-11.92-2.47-1.51-24.08,8.32-14.31a.44.44,0,0,0,.62-.62c-2.51-2.5-5.64-4.12-9.07-2.36s-6.14,6.94-6.34,10.71,2.12,6.41,5.72,7.3a11,11,0,0,0,5.38.11c1.93-.51,6.32-4.16,8-3.4.38.17.85-.2.61-.6l-.38.66a.44.44,0,0,0,.22-.82c-1.5-.85-1.27-5.81-1.7-7.41A10.14,10.14,0,0,0,207.8,253C207.42,252.55,206.8,253.18,207.18,253.6Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.18,267.87c8.37-1.48,12-9,7.79-16.55-.18-.32-.69,0-.51.3,1.7,3,2.56,7.26.88,10.44s-5,4.65-8.32,5.25c-.37.06-.21.63.16.56Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.06,264h0c.5.26.95-.5.44-.76h0c-.51-.25-.95.5-.45.76Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.33,253.29a9.94,9.94,0,0,0-1.78,2.49c-1.36,2.88-.61,6.55-2.41,9.17h0c3.18.1,5.69,2.88,8.82,3.49a9.81,9.81,0,0,0,3.06,0,8.47,8.47,0,0,0,5.63-2.55,6.76,6.76,0,0,0,1.3-5.16,12.14,12.14,0,0,0-1.66-4.5,12.27,12.27,0,0,0-2.64-4,6.76,6.76,0,0,0-4.92-2A8.51,8.51,0,0,0,175.33,253.29Z",
    style: {
      fill: "#ff7000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,253a10.3,10.3,0,0,0-2.41,4.19c-.48,1.77-.13,6.53-1.7,7.41a.44.44,0,0,0,.22.82l-.38-.66c-.24.4.23.78.61.6,1.63-.77,5.64,2.68,7.46,3.26a10.62,10.62,0,0,0,5.37.15c3.81-.79,6.45-3.36,6.24-7.42-.19-3.63-2.72-8.51-5.87-10.43-3.52-2.14-6.85-.6-9.54,2.08a.44.44,0,0,0,.62.62c4.67-4.64,9.64-2.47,12.27,2.9,2.3,4.68,2.26,10.12-3.95,11.41-3.85.79-6.31-1.07-9.59-2.52-.74-.32-2.58-1.22-3.46-.81l.6.6h0a.44.44,0,0,0-.38-.66h0l.22.82c.78-.43,1.19-2.51,1.34-3.17.73-3.2.62-5.91,2.95-8.57C176,253.18,175.4,252.55,175,253Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.8,267.31c-3.36-.6-6.64-2.08-8.32-5.25s-.82-7.41.88-10.44c.18-.33-.32-.63-.51-.3-4.22,7.52-.59,15.07,7.79,16.55.37.07.53-.5.16-.56Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.31,263.27h0c-.51.26-.06,1,.44.76h0c.5-.26.06-1-.45-.76Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,266.47a9.8,9.8,0,0,0,1.42,2.72c2,2.51,5.56,3.49,7.09,6.29h0c1.53-2.8,5.14-3.78,7.1-6.29a10.07,10.07,0,0,0,1.42-2.72,8.45,8.45,0,0,0,.25-6.17,6.72,6.72,0,0,0-4-3.49,12.2,12.2,0,0,0-4.77-.55,12.18,12.18,0,0,0-4.77.55,6.74,6.74,0,0,0-4,3.49A8.41,8.41,0,0,0,182.67,266.47Z",
    style: {
      fill: "#ff7000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.24,266.59a10.42,10.42,0,0,0,2.65,4.05c1.31,1.18,5.78,3.17,5.86,4.85a.44.44,0,0,0,.82.22h-.76a.44.44,0,0,0,.82-.22c.05-1.87,4.87-3.8,6.26-5.2a10.77,10.77,0,0,0,2.63-4.92c.92-3.7-.21-7.11-3.84-8.72a14.78,14.78,0,0,0-11.49.21c-3.88,2.05-4.16,5.91-2.95,9.73.17.54,1,.31.85-.24-2.07-6.55,2.24-9.63,8.1-9.65s10.5,3.07,8.09,9.65c-1.22,3.35-3.8,4.4-6.32,6.5-.66.55-2.18,1.67-2.21,2.64l.82-.23h0a.45.45,0,0,0-.76,0h0l.82.23c0-.91-1.67-2.18-2.22-2.64-2.51-2.09-5-3.23-6.32-6.5C182.88,265.84,182,266.06,182.24,266.59Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.86,263.51c-2.4,3.17-5.88,5.6-10.05,4.8a12.33,12.33,0,0,1-7.26-5.28c-.21-.31-.72,0-.51.3,4.82,7.18,13.18,7.28,18.33.47.23-.3-.28-.59-.51-.29Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.66,272.75v0a.44.44,0,0,0,.88,0v0a.44.44,0,0,0-.88,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.4,
    cy: 253.2,
    r: 12.95,
    style: {
      fill: "#df3e16"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.13,247.83c0,.11,0,.21,0,.32a11.74,11.74,0,0,1-23.47,0c0-.11,0-.21,0-.32a13,13,0,1,0,23.45,0Z",
    style: {
      fill: "#cc3517"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.13,247.83c0,.11,0,.21,0,.32a11.74,11.74,0,0,1-23.47,0c0-.11,0-.21,0-.32",
    style: {
      fill: "none",
      stroke: "#a5210c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.464453px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.4,265.72c-6.77-.35-12.51-5.47-12.51-12.52a12.48,12.48,0,0,1,24.9-1.25c.73,7.54-5,13.4-12.39,13.77-.56,0-.56.9,0,.88,7.29-.37,13.4-5.83,13.4-13.4a13.4,13.4,0,0,0-26.79,0c0,7.57,6.11,13,13.39,13.4C192,266.62,192,265.74,191.4,265.72Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.87,250.27h14.86a1.18,1.18,0,0,0,0-2.35H183.87a1.18,1.18,0,0,0,0,2.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.19,249.41v10.76a1.18,1.18,0,0,0,2.35,0V249.41a1.18,1.18,0,0,0-2.35,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.2,252.75c-.35,1.46-.1,3.07-1.27,4.2-1.33,1.3-4.21,1.6-5.58.22s0-3.12,1.34-3.8a5.3,5.3,0,0,1,5.21.38c1.2.92,2.37-1.12,1.19-2a7.55,7.55,0,0,0-8.11-.09c-1.95,1.29-3.3,4-2.1,6.19,1.36,2.52,5,3,7.45,2.18a6.06,6.06,0,0,0,2.93-2.2c1-1.39.83-2.86,1.21-4.43s-1.91-2.1-2.27-.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.73,246.94a1.18,1.18,0,0,0,0-2.35,1.18,1.18,0,0,0,0,2.35Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("a", {
    href: "/Muladhara"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Muladhara",
    className: "chakraAnimated"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.48,311.21a9.88,9.88,0,0,0,2.71-1.42c2.52-2,3.5-5.57,6.29-7.1h0c-2.79-1.53-3.77-5.14-6.29-7.1a9.88,9.88,0,0,0-2.71-1.42,8.48,8.48,0,0,0-6.18-.26,6.77,6.77,0,0,0-3.49,4,21,21,0,0,0,0,9.54,6.72,6.72,0,0,0,3.49,4A8.48,8.48,0,0,0,204.48,311.21Z",
    style: {
      fill: "#bf0b2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.59,311.63a10.21,10.21,0,0,0,4-2.64c1.18-1.3,3.2-5.81,4.85-5.86a.44.44,0,0,0,.22-.82v.76a.44.44,0,0,0-.22-.82c-1.86-.06-3.79-4.88-5.2-6.26a10.72,10.72,0,0,0-4.92-2.63c-3.7-.92-7.11.2-8.72,3.84a14.74,14.74,0,0,0,.22,11.49c2,3.88,5.9,4.15,9.72,2.94.54-.17.31-1-.23-.85-6.56,2.08-9.64-2.24-9.66-8.09s3.07-10.5,9.66-8.09c3.34,1.22,4.4,3.79,6.5,6.31.55.66,1.67,2.19,2.63,2.22l-.22-.82h0a.44.44,0,0,0,0,.76h0l.22-.82c-.9,0-2.19,1.68-2.63,2.22-2.09,2.51-3.24,5-6.5,6.31C203.84,311,204.07,311.84,204.59,311.63Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.51,294c3.17,2.4,5.61,5.89,4.8,10.05a12.37,12.37,0,0,1-5.27,7.27c-.32.2,0,.71.29.5,7.19-4.82,7.28-13.17.48-18.32-.3-.23-.6.28-.3.5Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.76,303.21h0a.44.44,0,0,0,0-.88h0a.44.44,0,0,0,0,.88Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,289.72A9.8,9.8,0,0,0,198.6,287c-2-2.52-5.56-3.5-7.1-6.29h0c-1.53,2.79-5.14,3.77-7.1,6.29a10.07,10.07,0,0,0-1.42,2.72,8.45,8.45,0,0,0-.25,6.17,6.75,6.75,0,0,0,4,3.49,12.2,12.2,0,0,0,4.77.55,12.18,12.18,0,0,0,4.77-.55,6.77,6.77,0,0,0,4-3.49A8.41,8.41,0,0,0,200,289.72Z",
    style: {
      fill: "#bf0b2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.45,289.6a10.34,10.34,0,0,0-2.65-4.05c-1.3-1.17-5.81-3.2-5.86-4.85a.44.44,0,0,0-.82-.22h.76a.44.44,0,0,0-.82.22c-.08,1.89-4.86,3.78-6.26,5.2a10.72,10.72,0,0,0-2.63,4.92c-.92,3.7.21,7.11,3.84,8.72a14.73,14.73,0,0,0,11.49-.22c3.88-2,4.15-5.9,2.95-9.72-.17-.54-1-.31-.85.23,2.07,6.56-2.24,9.64-8.1,9.66s-10.5-3.07-8.09-9.66c1.22-3.34,3.8-4.4,6.32-6.5.67-.55,2.17-1.66,2.21-2.63l-.82.22h0a.45.45,0,0,0,.76,0h0l-.82-.22c0,.9,1.68,2.19,2.22,2.63,2.51,2.09,5,3.24,6.32,6.5C199.81,290.35,200.66,290.12,200.45,289.6Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.83,292.68c2.4-3.17,5.88-5.61,10-4.8a12.29,12.29,0,0,1,7.26,5.28c.21.31.72,0,.51-.3-4.82-7.19-13.18-7.28-18.33-.48-.23.3.28.6.51.3Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,283.44v0a.44.44,0,0,0-.88,0v0a.44.44,0,0,0,.88,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,294.17a9.94,9.94,0,0,0-2.72,1.42c-2.51,2-3.49,5.57-6.29,7.1h0c2.8,1.53,3.78,5.14,6.29,7.1a10.22,10.22,0,0,0,2.72,1.42,8.45,8.45,0,0,0,6.17.25,6.69,6.69,0,0,0,3.49-4,21,21,0,0,0,0-9.54,6.74,6.74,0,0,0-3.49-4A8.41,8.41,0,0,0,178.53,294.17Z",
    style: {
      fill: "#bf0b2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.41,293.75a10.28,10.28,0,0,0-4,2.64c-1.17,1.3-3.19,5.81-4.85,5.86a.44.44,0,0,0-.22.82v-.76a.44.44,0,0,0,.22.82c1.89.08,3.78,4.86,5.2,6.26a10.77,10.77,0,0,0,4.92,2.63c3.7.92,7.11-.21,8.73-3.84a14.82,14.82,0,0,0-.22-11.49c-2-3.88-5.91-4.15-9.73-2.94-.54.17-.31,1,.24.84,6.55-2.07,9.63,2.25,9.65,8.1s-3.07,10.5-9.65,8.09c-3.35-1.22-4.4-3.79-6.5-6.32-.56-.66-1.67-2.17-2.64-2.21l.23.82h0a.45.45,0,0,0,0-.76h0l-.23.82c.9,0,2.19-1.68,2.64-2.22,2.09-2.51,3.23-5,6.5-6.32C179.16,294.38,178.94,293.53,178.41,293.75Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.49,311.36c-3.17-2.4-5.6-5.88-4.8-10.05a12.33,12.33,0,0,1,5.28-7.26c.31-.21,0-.72-.3-.5-7.18,4.81-7.28,13.17-.47,18.32.3.23.59-.28.29-.51Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.25,302.16h0a.44.44,0,0,0,0,.88h0a.44.44,0,0,0,0-.88Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,315.66a10.07,10.07,0,0,0,1.42,2.72c2,2.51,5.57,3.5,7.1,6.29h0c1.53-2.79,5.14-3.78,7.1-6.29a9.8,9.8,0,0,0,1.42-2.72,8.46,8.46,0,0,0,.26-6.17,6.74,6.74,0,0,0-4-3.49,12.2,12.2,0,0,0-4.77-.55,12.2,12.2,0,0,0-4.77.55,6.69,6.69,0,0,0-4,3.49A8.45,8.45,0,0,0,183,315.66Z",
    style: {
      fill: "#bf0b2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.56,315.78a10.28,10.28,0,0,0,2.64,4.05c1.3,1.17,5.81,3.2,5.86,4.85a.44.44,0,0,0,.82.22h-.76a.44.44,0,0,0,.82-.22c.06-1.87,4.88-3.8,6.26-5.2a10.68,10.68,0,0,0,2.63-4.92c.92-3.7-.2-7.11-3.83-8.72a14.8,14.8,0,0,0-11.5.21c-3.88,2.05-4.15,5.91-2.94,9.73.17.54,1,.31.85-.24-2.08-6.55,2.24-9.63,8.09-9.65s10.51,3.07,8.1,9.65c-1.23,3.35-3.8,4.4-6.32,6.5-.66.55-2.19,1.67-2.22,2.64l.82-.23h0a.44.44,0,0,0-.76,0h0l.82.23c0-.9-1.68-2.19-2.21-2.64-2.52-2.09-5-3.23-6.32-6.5C183.2,315,182.35,315.25,182.56,315.78Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18,312.7c-2.4,3.17-5.89,5.6-10.05,4.8a12.33,12.33,0,0,1-7.26-5.28c-.21-.31-.72,0-.51.3,4.82,7.18,13.17,7.28,18.32.47.23-.3-.28-.59-.5-.29Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,321.94v0a.44.44,0,0,0,.88,0v0a.44.44,0,0,0-.88,0Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.6,
    cy: 302.69,
    r: 12.95,
    transform: "translate(-147.17 419.17) rotate(-76.64)",
    style: {
      fill: "#f52f2c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.88,
    y: 294.17,
    width: 19.44,
    height: 17.04,
    style: {
      fill: "none",
      stroke: "#a30527",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.464453px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.6,315.2c-6.77-.34-12.51-5.46-12.51-12.51a12.48,12.48,0,0,1,24.9-1.25c.73,7.53-5.05,13.39-12.39,13.76-.56,0-.57.91,0,.88,7.28-.36,13.39-5.82,13.39-13.39a13.39,13.39,0,0,0-26.78,0c0,7.56,6.11,13,13.39,13.39C192.17,316.11,192.16,315.23,191.6,315.2Z",
    style: {
      fill: "#140022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.17,300.23H199a1.18,1.18,0,0,0,0-2.35H184.17a1.18,1.18,0,0,0,0,2.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.49,299.36v10.77a1.18,1.18,0,0,0,2.35,0V299.36a1.18,1.18,0,0,0-2.35,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.45,308c-1.38-.31-2.69-1.39-2.41-2.95.25-1.34,2-2.28,3-1s2.94,0,2-1.18a4.06,4.06,0,0,0-7,.59c-1.44,3,.7,6.13,3.71,6.8,1.47.33,2.09-1.93.62-2.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.11,305.05a1.66,1.66,0,0,1,1.09-1.55,4,4,0,0,1,1-.3,3.08,3.08,0,0,1,.53,0c.32,0,.6.18.09-.12v-2l0,0,1.6.42v0a1.17,1.17,0,0,0-2,1.19h0a1.19,1.19,0,0,0,1.61.42h0a1.18,1.18,0,0,0,0-2c-1.09-.64-3.09,0-4.12.51a4,4,0,0,0-2.15,3.53,1.17,1.17,0,0,0,2.34,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.45,296.89a1.17,1.17,0,0,0,0-2.34,1.17,1.17,0,0,0,0,2.34Z",
    style: {
      fill: "#fff"
    }
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelled);
export default __webpack_public_path__ + "static/media/labelled.3ad2d079.svg";
export { ForwardRef as ReactComponent };